window.wpbingo = window.wpbingo || {}, wpbingo.Sections = function() {
    this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, wpbingo.Sections.prototype = _.assignIn({}, wpbingo.Sections.prototype, {
    _createInstance: function(container2, constructor) {
        var $container = $(container2),
            id = $container.attr("data-section-id"),
            type = $container.attr("data-section-type");
        if (constructor = constructor || this.constructors[type], !_.isUndefined(constructor)) {
            var instance = _.assignIn(new constructor(container2), {
                id,
                type,
                container: container2
            });
            this.instances.push(instance)
        }
    },
    _onSectionLoad: function(evt) {
        var container2 = $("[data-section-id]", evt.target)[0];
        container2 && this._createInstance(container2)
    },
    _onSectionUnload: function(evt) {
        this.instances = _.filter(this.instances, function(instance) {
            var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;
            return isEventInstance && _.isFunction(instance.onUnload) && instance.onUnload(evt), !isEventInstance
        })
    },
    _onSelect: function(evt) {
        var instance = _.find(this.instances, function(instance2) {
            return instance2.id === evt.originalEvent.detail.sectionId
        });
        !_.isUndefined(instance) && _.isFunction(instance.onSelect) && instance.onSelect(evt)
    },
    _onDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance2) {
            return instance2.id === evt.originalEvent.detail.sectionId
        });
        !_.isUndefined(instance) && _.isFunction(instance.onDeselect) && instance.onDeselect(evt)
    },
    _onBlockSelect: function(evt) {
        var instance = _.find(this.instances, function(instance2) {
            return instance2.id === evt.originalEvent.detail.sectionId
        });
        !_.isUndefined(instance) && _.isFunction(instance.onBlockSelect) && instance.onBlockSelect(evt)
    },
    _onBlockDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance2) {
            return instance2.id === evt.originalEvent.detail.sectionId
        });
        !_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect) && instance.onBlockDeselect(evt)
    },
    register: function(type, constructor) {
        this.constructors[type] = constructor, $("[data-section-type=" + type + "]").each(function(index, container2) {
            this._createInstance(container2, constructor)
        }.bind(this))
    }
}), wpbingo.LibraryLoader = function() {
    var types = {
            link: "link",
            script: "script"
        },
        status = {
            requested: "requested",
            loaded: "loaded"
        },
        cloudCdn = "https://cdn.shopify.com/shopifycloud/",
        libraries = {
            youtubeSdk: {
                tagId: "youtube-sdk",
                src: "https://www.youtube.com/iframe_api",
                type: types.script
            },
            plyrShopifyStyles: {
                tagId: "plyr-shopify-styles",
                src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
                type: types.link
            },
            modelViewerUiStyles: {
                tagId: "shopify-model-viewer-ui-styles",
                src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                type: types.link
            }
        };

    function load(libraryName, callback) {
        var library = libraries[libraryName];
        if (library && library.status !== status.requested) {
            if (callback = callback || function() {}, library.status === status.loaded) {
                callback();
                return
            }
            library.status = status.requested;
            var tag;
            switch (library.type) {
                case types.script:
                    tag = createScriptTag(library, callback);
                    break;
                case types.link:
                    tag = createLinkTag(library, callback);
                    break
            }
            tag.id = library.tagId, library.element = tag;
            var firstScriptTag = document.getElementsByTagName(library.type)[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        }
    }

    function createScriptTag(library, callback) {
        var tag = document.createElement("script");
        return tag.src = library.src, tag.addEventListener("load", function() {
            library.status = status.loaded, callback()
        }), tag
    }

    function createLinkTag(library, callback) {
        var tag = document.createElement("link");
        return tag.href = library.src, tag.rel = "stylesheet", tag.type = "text/css", tag.addEventListener("load", function() {
            library.status = status.loaded, callback()
        }), tag
    }
    return {
        load
    }
}(), wpbingo.Disclosure = function() {
    var selectors2 = {
        disclosureInput: "[data-disclosure-input]",
        disclosureOptions: "[data-disclosure-option]"
    };

    function Disclosure($disclosure) {
        this.$container = $disclosure, this.cache = {}, this._cacheSelectors(), this._connectOptions()
    }
    return Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
        _cacheSelectors: function() {
            this.cache = {
                $disclosureInput: this.$container.find(selectors2.disclosureInput),
                $disclosureOptions: this.$container.find(selectors2.disclosureOptions)
            }
        },
        _connectOptions: function() {
            this.cache.$disclosureOptions.on("click", function(evt) {
                evt.preventDefault(), this._submitForm($(evt.currentTarget).data("value"))
            }.bind(this))
        },
        _submitForm: function(value) {
            this.cache.$disclosureInput.val(value), this.$container.parents("form").submit()
        },
        unload: function() {
            this.cache.$disclosureOptions.off(), this.$container.off()
        }
    }), Disclosure
}(), wpbingo.Currency = function() {
    var moneyFormat2 = "${{amount}}";

    function formatMoney(cents, format) {
        typeof cents == "string" && (cents = cents.replace(".", ""));
        var value = "",
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || moneyFormat2;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            if (thousands = thousands || ",", decimal = decimal || ".", isNaN(number) || number === null) return 0;
            number = (number / 100).toFixed(precision);
            var parts = number.split("."),
                dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'");
                break
        }
        return formatString.replace(placeholderRegex, value)
    }
    return {
        formatMoney
    }
}(), wpbingo.collectionPages = function() {
    var bwpFilter = ".js-page-collection",
        wpbingoCollectionProduct = "#JsCollectionProduct",
        wpbingoFilterContentProduct = ".js-collection-content-product",
        wpbingoFilterSidebar = ".collection-sidebar",
        wpbingoFilterTitle = ".wpbingo-breadcrumbs__inner",
        wpbingoFacetsContainer = ".active-facets-desktop",
        bwpChangeView = ".js-change-view",
        canbeloaded = !0,
        bwpSortBy = ".js-sortby",
        ajaxFilterParams, ajaxFilterGetCollectionUrl, ajaxFilterCreateUrl, ajaxFilterChangeView, ajaxFilterCategory, ajaxBreadcrumbsCategory, ajaxFilterLoadMore, ajaxFilterInfinity, ajaxFilterPaging, init2 = function() {
            if ($(bwpFilter)) {
                var History2 = window.History;
                History2.Adapter.bind(window, "statechange", function() {
                    History2.getState()
                })
            }
            ajaxFilterParams(), ajaxFilterChangeView(), ajaxFilterCategory(), ajaxBreadcrumbsCategory(), ajaxFilterLoadMore(), ajaxFilterInfinity(), ajaxFilterPaging()
        };
    return ajaxFilterParams = function() {
        if (Shopify.queryParams = {}, location.search.length)
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) aKeyValue = aCouples[i].split("="), aKeyValue.length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]))
    }, ajaxFilterGetCollectionUrl = function(collection, url) {
        var str = url,
            indexCollection = str.indexOf(collection);
        if (indexCollection < 0) return "";
        str = str.slice(indexCollection + collection.length, str.length);
        var indexSlash = str.indexOf("/") > -1 ? str.indexOf("/") : str.length;
        return str = str.slice(0, indexSlash).toLowerCase(), str.replace("=", "")
    }, ajaxFilterCreateUrl = function(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, "+"),
            collectionHandle = ajaxFilterGetCollectionUrl("/collections/", location.pathname),
            pathName = "/collections/" + collectionHandle,
            arrayUrl = location.pathname.split("/");
        if (arrayUrl.length >= 4) {
            var currentTagName = arrayUrl[3].split("?").shift();
            currentTagName != "" && (newQuery = newQuery + "+" + currentTagName)
        }
        return baseLink ? newQuery != "" ? baseLink + "?" + newQuery : baseLink : pathName + "?" + newQuery
    }, ajaxFilterChangeView = function() {
        cViewCollection = wpbingo.getCookie("wpbingo_view_collection"), cViewCollection && ($(wpbingoCollectionProduct).removeAttr("class"), $(wpbingoCollectionProduct).addClass(cViewCollection), $(bwpChangeView).removeClass("active"), $("[data-view=" + cViewCollection + "]").addClass("active")), $(bwpFilter).on("click", bwpChangeView, function(e) {
            e.preventDefault(), $(this).hasClass("active") || ($(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                $(".js-carousel", $(this)).slick("refresh")
            }), wpbingo.setCookie("wpbingo_view_collection", $(this).data("view"), 1), $(bwpChangeView).removeClass("active"), $(this).addClass("active"), $(wpbingoCollectionProduct).removeAttr("class"), $(wpbingoCollectionProduct).addClass($(this).data("view")))
        })
    }, ajaxFilterPaging = function() {
        $(bwpFilter).on("click", ".js-collection-pagination a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href").match(/page=\d+/g);
            if (pageURL) {
                Shopify.queryParams.page = parseInt(pageURL[0].match(/\d+/g));
                var searchParams = window.history.state && window.history.state.searchParams ? window.history.state.searchParams : "",
                    newurl = ajaxFilterCreateUrl();
                history.pushState({
                    searchParams
                }, "", `${newurl}${searchParams&&"&".concat(searchParams)}`), $.ajax({
                    type: "get",
                    url: `${newurl}${searchParams&&"&".concat(searchParams)}`,
                    success: function(data2) {
                        $(wpbingoFilterContentProduct).replaceWith($(data2).find(wpbingoFilterContentProduct)), $(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                            wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                        }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), wpbingo.click_atribute_image(), wpbingo.zoom_thumb(), wpbingo.popup_product_card(), window.SPR && (SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()), wpbingo.countdown(), initButtons(), initButtonsCompare(), wpbingo.sidebarCollection(), wpbingo.toggleSidebar(), wpbingo.product_result_count()
                    },
                    error: function(xhr, text) {
                        console.log(text)
                    }
                }), $("body,html").animate({
                    scrollTop: $(".header").height()
                }, 600)
            }
        })
    }, ajaxFilterLoadMore = function() {
        $(bwpFilter).on("click", ".js-collection-loadmore a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href");
            if ($(this).addClass("active"), pageURL) {
                Shopify.queryParams.page = parseInt(pageURL.match(/\d+/g));
                var searchParams = window.history.state && window.history.state.searchParams ? window.history.state.searchParams : "",
                    newurl = ajaxFilterCreateUrl();
                $.ajax({
                    type: "get",
                    url: pageURL,
                    success: function(data2) {
                        $(".products__row", wpbingoFilterContentProduct).append($(data2).find(".products__row").html()), $(".js-collection-loadmore").empty(), $(".js-collection-loadmore", wpbingoFilterContentProduct).append($(data2).find(".js-collection-loadmore").html()), $("#product_result_count").empty(), $("#product_result_count", wpbingoFilterContentProduct).append($(data2).find("#product_result_count").html()), $(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                            $(".js-carousel", $(this)).hasClass("slick-initialized") || wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                        }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), window.SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()), wpbingo.countdown(), wpbingo.click_atribute_image(), wpbingo.zoom_thumb(), wpbingo.popup_product_card(), initButtons(), initButtonsCompare(), wpbingo.sidebarCollection(), wpbingo.christmas_snow(), wpbingo.product_result_count(), $(this).removeClass("active")
                    },
                    error: function(xhr, text) {
                        console.log(text)
                    }
                })
            }
        })
    }, ajaxFilterInfinity = function() {
        $(".js-collection-infinity").length > 0 && $(window).scroll(function() {
            if ($(document).scrollTop() > $(document).height() - 2e3 && canbeloaded == !0 && $(".js-collection-infinity >a").length > 0) {
                $(".js-collection-infinity a").addClass("active");
                var pageURL = $("a", ".js-collection-infinity").attr("href");
                if (pageURL) {
                    Shopify.queryParams.page = parseInt(pageURL[0].match(/\d+/g));
                    var searchParams = window.history.state && window.history.state.searchParams ? window.history.state.searchParams : "",
                        newurl = ajaxFilterCreateUrl();
                    $.ajax({
                        type: "get",
                        url: pageURL,
                        beforeSend: function(xhr) {
                            canbeloaded = !1
                        },
                        success: function(data2) {
                            canbeloaded = !0, $(".products__row", wpbingoFilterContentProduct).append($(data2).find(".products__row").html()), $(".js-collection-infinity").empty(), $(".js-collection-infinity", wpbingoFilterContentProduct).append($(data2).find(".js-collection-infinity").html()), $("#product_result_count").empty(), $("#product_result_count", wpbingoFilterContentProduct).append($(data2).find("#product_result_count").html()), $(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                                $(".js-carousel", $(this)).hasClass("slick-initialized") || wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                            }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), window.SPR && (SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()), wpbingo.click_atribute_image(), wpbingo.zoom_thumb(), wpbingo.popup_product_card(), wpbingo.countdown(), initButtons(), initButtonsCompare(), wpbingo.christmas_snow(), wpbingo.sidebarCollection(), wpbingo.product_result_count()
                        },
                        error: function(xhr, text) {
                            console.log(text)
                        }
                    })
                }
            }
        })
    }, ajaxFilterCategory = function($element2) {
        var wpbingoFacetsWrapper = ".FacetsWrapperDesktop ";
        if ($element2) var $categories = $element2;
        else var $categories = $(".sidebar-categories");
        if ($(".wpbingo-breadcrumbs").hasClass("have-collection")) var $collection = !0;
        $($categories).on("click", "a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href"),
                newTitle = $(this).attr("title");
            History.pushState({
                param: Shopify.queryParams
            }, pageURL, pageURL), delete Shopify.queryParams.page, $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }), $.ajax({
                type: "get",
                url: pageURL,
                success: function(data2) {
                    document.title = newTitle, $(wpbingoFilterContentProduct).replaceWith($(data2).find(wpbingoFilterContentProduct)), $(wpbingoFilterSidebar).replaceWith($(data2).find(wpbingoFilterSidebar)), $(wpbingoFilterTitle).replaceWith($(data2).find(wpbingoFilterTitle)), $(wpbingoFacetsContainer).replaceWith($(data2).find(wpbingoFacetsContainer)), $(".js-page-collection").hasClass("dropdown") && ($(wpbingoFacetsWrapper).replaceWith($(data2).find(wpbingoFacetsWrapper)), wpbingo.countActiveSidebar()), $(".wpbingo-breadcrumbs").replaceWith($(data2).find(".wpbingo-breadcrumbs")), $collection && wpbingo.elementslickCarousel($(".wpbingo-breadcrumbs__image .js-carousel")), ajaxFilterCategory(), ajaxBreadcrumbsCategory($(".wpbingo-breadcrumbs .bwp_slider-carousel")), wpbingo.click_atribute_image(), wpbingo.zoom_thumb(), $(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                        wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                    }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), wpbingo.hideLoading(), wpbingo.popup_product_card(), window.SPR && (SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()), wpbingo.countdown(), ajaxFilterChangeView(), wpbingo.sidebarCollection(), initButtons(), initButtonsCompare(), wpbingo.toggleSidebar(), wpbingo.product_result_count(), $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }), setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }), $("#pre-loading").removeClass("load-product")
                    }, 500)
                },
                error: function(xhr, text) {
                    console.log(text)
                }
            }), $("body,html").animate({
                scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
            }, 600)
        })
    }, ajaxBreadcrumbsCategory = function($element2) {
        if ($element2) var $categories = $element2;
        else var $categories = $(".wpbingo-breadcrumbs .bwp_slider-carousel");
        if ($(".wpbingo-breadcrumbs").hasClass("have-collection")) var $collection = !0;
        $($categories).on("click", "a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href"),
                newTitle = $("h2", $(this)).text();
            History.pushState({
                param: Shopify.queryParams
            }, pageURL, pageURL), delete Shopify.queryParams.page, $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }), $.ajax({
                type: "get",
                url: pageURL,
                success: function(data2) {
                    document.title = newTitle, $(wpbingoFilterContentProduct).replaceWith($(data2).find(wpbingoFilterContentProduct)), $(wpbingoFilterSidebar).replaceWith($(data2).find(wpbingoFilterSidebar)), $(wpbingoFilterTitle).replaceWith($(data2).find(wpbingoFilterTitle)), $(wpbingoFacetsContainer).replaceWith($(data2).find(wpbingoFacetsContainer)), $(".wpbingo-breadcrumbs__image").replaceWith($(data2).find(".wpbingo-breadcrumbs__image")), ajaxFilterCategory($(".sidebar-categories")), $(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                        wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                    }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), ajaxBreadcrumbsCategory(), wpbingo.click_atribute_image(), wpbingo.zoom_thumb(), wpbingo.popup_product_card(), wpbingo.hideLoading(), window.SPR && (SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()), wpbingo.countdown(), wpbingo.sidebarCollection(), initButtonsCompare(), initButtons(), wpbingo.countActiveSidebar(), $(".js-page-collection").hasClass("dropdown") || wpbingo.toggleSidebar(), $collection && wpbingo.elementslickCarousel($(".wpbingo-breadcrumbs__image .js-carousel")), ajaxFilterChangeView(), $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }), setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }), $("#pre-loading").removeClass("load-product")
                    }, 500)
                },
                error: function(xhr, text) {
                    console.log(text)
                }
            }), $("body,html").animate({
                scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
            }, 600)
        })
    }, init2
}(), wpbingo.Variants = function() {
    function Variants(options) {
        this.$container = options.$container, this.product = options.product, this.productSelectOption = options.productSelectOption, this.singleOptionSelector = options.singleOptionSelector, this.originalSelectorId = options.originalSelectorId, this.enableHistoryState = options.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function() {
            var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element2 = $(element),
                    type = $element2.attr("type"),
                    currentOption = {};
                return type === "radio" || type === "checkbox" ? $element2[0].checked ? (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption) : !1 : (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption)
            });
            return currentOptions = _.compact(currentOptions), currentOptions
        },
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions(),
                variants = this.product.variants,
                found = _.find(variants, function(variant) {
                    return selectedValues.every(function(values) {
                        return _.isEqual(variant[values.index], values.value)
                    })
                });
            return found
        },
        _onSelectChange: function() {
            var variant = this._getVariantFromOptions();
            if ($("[data-single-option-button]", this.$container).length && $(".color-select", this.$container).length < 1 && (this._updateVariantsButton(), !variant || !variant.available)) {
                this._updateVariantsButtonDisabed();
                return
            }
            this.$container.trigger({
                type: "variantChange",
                variant
            }), variant && (this._updateMasterSelect(variant), this._updateMedia(variant), this._updatePrice(variant), this._updateQuantity(variant), this._updateOption(variant), this._updatePricesticky(variant), this._updateSKU(variant), this._updateLabelvariant(variant), this.currentVariant = variant, this._updatePickUp(variant), this._updateBtnText(variant), this._updateDelivery(variant), this.enableHistoryState && this._updateHistoryState(variant))
        },
        _updateVariantsButtonDisabed: function() {
            for (var i = 2; i <= 3; i++)
                if ($(this.productSelectOption + i, this.$container).length) {
                    var isUpdate = !1;
                    $(this.productSelectOption + i + " " + this.singleOptionSelector, this.$container).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if ((type === "radio" || type === "checkbox") && this.checked && $element2.hasClass("disabled")) return $element2.prop("checked", !1), isUpdate = !0, !1
                    }), $(this.productSelectOption + i + " " + this.singleOptionSelector, this.$container).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if (isUpdate && (type === "radio" || type === "checkbox") && !$element2.hasClass("disabled")) return $element2.prop("checked", !0), isUpdate = !1, $element2.trigger("change"), !1
                    })
                }
        },
        _updateVariantsButton: function() {
            for (var selectedValues = this._getCurrentOptions(), variants = this.product.variants, i = 2; i <= 3; i++)
                if ($(this.productSelectOption + i, this.$container).length) {
                    var $parent = this.productSelectOption + i;
                    $($parent + " " + this.singleOptionSelector, this.$container).each(function() {
                        var $self = $(this),
                            optionValue = $self.val(),
                            foundIndex;
                        i === 2 ? foundIndex = _.findIndex(variants, function(variant) {
                            return variant.option1 = variant.option1.toString(), selectedValues[0].value = selectedValues[0].value.toString(), variant.option2 = variant.option2.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === !0
                        }) : i === 3 && (foundIndex = _.findIndex(variants, function(variant) {
                            return variant.option1 = variant.option1.toString(), variant.option2 = variant.option2.toString(), variant.option3 = variant.option3.toString(), selectedValues[0].value = selectedValues[0].value.toString(), selectedValues[1].value = selectedValues[1].value.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value && variant.option3 === optionValue && variant.available === !0
                        })), foundIndex !== -1 ? $($parent + ".color-select", this.$container).length > 0 ? ($self.removeClass("disabled"), $self.next("label").removeClass("disabled")) : ($self.removeAttr("disabled", "disabled").removeClass("disabled"), $self.next("label").removeClass("disabled")) : $($parent + ".color-select", this.$container).length > 0 ? ($self.addClass("disabled"), $self.next("label").addClass("disabled")) : ($self.attr("disabled", "disabled").addClass("disabled"), $self.next("label").addClass("disabled"))
                    })
                }
        },
        _updateMedia: function(variant) {
            var variantMedia = variant.featured_media || {},
                currentVariantMedia = this.currentVariant.featured_media || {},
                isMatchingPreviewImage = !1;
            variantMedia.preview_image && currentVariantMedia.preview_image && (isMatchingPreviewImage = variantMedia.preview_image.src === currentVariantMedia.preview_image.src), !(!variant.featured_media || isMatchingPreviewImage) && this.$container.trigger({
                type: "variantMediaChange",
                variant
            })
        },
        _updatePrice: function(variant) {
            $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), !(variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) && this.$container.trigger({
                type: "variantPriceChange",
                variant
            })
        },
        _updateQuantity: function(variant) {
            $(".product-single .content-variant_inventory").length > 0 && setTimeout(function() {
                $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable")
            }, 10)
        },
        _updateOption: function() {
            setTimeout(function() {
                $("#option-selector").load(window.location.href + " #option-selector")
            }, 10)
        },
        _updatePricesticky: function() {
            setTimeout(function() {
                $("#price-sticky").load(window.location.href + " #price-sticky")
            }, 10)
        },
        _updateSKU: function(variant) {
            variant.sku !== this.currentVariant.sku && this.$container.trigger({
                type: "variantSKUChange",
                variant
            })
        },
        _updateLabelvariant: function(variant) {
            var $element2 = $(".product-single .product-single__form .variants-wrapper");
            $(".mutil_slider-single").removeClass("active"), $($element2).each(function() {
                var $this = $(this);
                if ($("select", $this).length > 0) var value = $("select", $this).find(":selected").val();
                else var value = $("input:checked", $this).attr("value");
                $(".variants__label span", $this).html(value), $(".mutil_slider-single." + value).addClass("active")
            })
        },
        _updateHistoryState: function(variant) {
            if (!(!history.replaceState || !variant)) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
                window.history.replaceState({
                    path: newurl
                }, "", newurl), $(".product-single #buy_more_form").length > 0 && ($('#buy_more_form input[name="items[][id]"]').attr("value", variant.id), wpbingo.discount_single())
            }
        },
        _updatePickUp: function(variant) {
            $(".product-single .product-single__pick_up").length > 0 && ($(".product-single .product-single__pick_up").addClass("load-pick_up").css("height", $(".product-single .product-single__pick_up").height() + "px"), $(".product-single .product-single__pick_up").empty(), wpbingo.pick_up(variant.id), setTimeout(function() {
                $(".product-single .product-single__pick_up").removeClass("load-pick_up").removeAttr("style")
            }, 1e3))
        },
        _updateBtnText: function(variant) {
            $(".product-single .product-single__buttons .btn--add-to-cart .btn__text").length > 0 && setTimeout(function() {
                $(".product-single .product-single__buttons .btn--add-to-cart").load(window.location.href + " .btn__text")
            }, 10), $(".sticky-cart-single").length > 0 && setTimeout(function() {
                $(".sticky-cart-single .btn--add-to-cart").load(window.location.href + " .btn__text")
            }, 10)
        },
        _updateDelivery: function(variant) {
            $(".product-single .estimated_delivery").length > 0 && $(".product-single .section-estimated_delivery[data-incoming]").length > 0 && ($(".product-single .section-estimated_delivery").addClass("load-delivery").css("height", $(".product-single .section-estimated_delivery").height() + "px"), setTimeout(function() {
                $(".product-single .section-estimated_delivery").load(window.location.href + ".product-single .estimated_delivery")
            }, 10), setTimeout(function() {
                $(".product-single .time_hour").length > 0 && wpbingo.time_estimated_delivery()
            }, 1200), setTimeout(function() {
                $(".product-single .time_hour").length > 0 && $(".product-single .section-estimated_delivery").removeClass("load-delivery").removeAttr("style")
            }, 1400))
        },
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container).val(variant.id)
        }
    }), Variants
}(), wpbingo.ProductModel = function() {
    var modelJsonSections = {},
        models = {},
        xrButtons = {},
        selectors2 = {
            productMediaGroup: ".js-product-media-group",
            productMediaGroupWrapper: ".js-product-single-media",
            xrButton: "[data-shopify-xr]",
            xrButtonSingle: "[data-shopify-xr-single]"
        },
        classes = {
            viewInSpaceDisabled: "product-single__view-in-space--disabled"
        };

    function init2(modelViewerContainers, sectionId2) {
        modelJsonSections[sectionId2] = {
            loaded: !1
        }, modelViewerContainers.each(function(index) {
            var $modelViewerContainer = $(this),
                mediaId = $modelViewerContainer.data("media-id"),
                $modelViewerElement = $($modelViewerContainer.find("model-viewer")[0]),
                modelId = $modelViewerElement.data("model-id");
            if (index === 0) {
                var $xrButton = $modelViewerContainer.closest(selectors2.productMediaGroupWrapper).find(selectors2.xrButtonSingle);
                xrButtons[sectionId2] = {
                    $element: $xrButton,
                    defaultId: modelId
                }
            }
            models[mediaId] = {
                modelId,
                sectionId: sectionId2,
                $container: $modelViewerContainer,
                $element: $modelViewerElement
            }
        }), window.Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: setupShopifyXr
        }]), !(models.length < 1) && (window.Shopify.loadFeatures([{
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: setupModelViewerUi
        }]), wpbingo.LibraryLoader.load("modelViewerUiStyles"))
    }

    function setupShopifyXr(errors) {
        if (!errors) {
            if (!window.ShopifyXR) {
                document.addEventListener("shopify_xr_initialized", function(event) {
                    event.detail.shopifyXREnabled ? setupShopifyXr() : $(selectors2.xrButton).addClass(classes.viewInSpaceDisabled)
                });
                return
            }
            for (var sectionId2 in modelJsonSections)
                if (modelJsonSections.hasOwnProperty(sectionId2)) {
                    var modelSection = modelJsonSections[sectionId2];
                    if (modelSection.loaded) continue;
                    var $modelJson = $("#ModelJson-" + sectionId2);
                    window.ShopifyXR.addModels(JSON.parse($modelJson.html())), modelSection.loaded = !0
                } window.ShopifyXR.setupXRElements()
        }
    }

    function setupModelViewerUi(errors) {
        if (!errors) {
            for (var key in models)
                if (models.hasOwnProperty(key)) {
                    var model = models[key];
                    model.modelViewerUi || (model.modelViewerUi = new Shopify.ModelViewerUI(model.$element)), setupModelViewerListeners(model)
                }
        }
    }

    function setupModelViewerListeners(model) {
        var xrButton = xrButtons[model.sectionId],
            $productMediaGroup = model.$container.closest(selectors2.productMediaGroup);
        model.$element.on("shopify_model_viewer_ui_toggle_play", function() {
            wpbingo.updateSlickSwipe($productMediaGroup, !1)
        }).on("shopify_model_viewer_ui_toggle_pause", function() {
            wpbingo.updateSlickSwipe($productMediaGroup, !0)
        }), model.$container.on("mediaVisible", function() {
            xrButton.$element.attr("data-shopify-model3d-id", model.modelId), model.modelViewerUi.play()
        }), model.$container.on("mediaHidden", function() {
            xrButton.$element.attr("data-shopify-model3d-id", xrButton.defaultId), model.modelViewerUi.pause()
        }).on("xrLaunch", function() {
            model.modelViewerUi.pause()
        })
    }

    function removeSectionModels(sectionId2) {
        for (var key in models)
            if (models.hasOwnProperty(key)) {
                var model = models[key];
                model.sectionId === sectionId2 && (models[key].modelViewerUi.destroy(), delete models[key])
            } delete modelJsonSections[sectionId2]
    }
    return {
        init: init2,
        removeSectionModels
    }
}();

function onYouTubeIframeAPIReady() {
    wpbingo.ProductVideo.loadVideos(wpbingo.ProductVideo.hosts.youtube)
}
wpbingo.ProductVideo = function() {
    var videos = {},
        hosts = {
            html5: "html5",
            youtube: "youtube"
        },
        selectors2 = {
            productMediaWrapper: ".js-product-media",
            productMediaGroup: ".js-product-media-group"
        },
        attributes = {
            enableVideoLooping: "enable-video-looping",
            videoId: "video-id"
        };

    function init2(videoContainer, sectionId2) {
        if (videoContainer.length) {
            var videoElement = videoContainer.find("iframe, video")[0],
                mediaId = videoContainer.data("mediaId");
            if (videoElement) {
                videos[mediaId] = {
                    mediaId,
                    sectionId: sectionId2,
                    host: hostFromVideoElement(videoElement),
                    container: videoContainer,
                    element: videoElement,
                    ready: function() {
                        createPlayer(this)
                    }
                };
                var video = videos[mediaId];
                switch (video.host) {
                    case hosts.html5:
                        window.Shopify.loadFeatures([{
                            name: "video-ui",
                            version: "1.1",
                            onLoad: setupPlyrVideos
                        }]), wpbingo.LibraryLoader.load("plyrShopifyStyles");
                        break;
                    case hosts.youtube:
                        wpbingo.LibraryLoader.load("youtubeSdk");
                        break
                }
            }
        }
    }

    function setupPlyrVideos(errors) {
        if (errors) {
            fallbackToNativeVideo();
            return
        }
        loadVideos(hosts.html5)
    }

    function createPlayer(video) {
        if (!video.player) {
            var productMediaWrapper = video.container.closest(selectors2.productMediaWrapper),
                enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);
            switch (video.host) {
                case hosts.html5:
                    video.player = new Shopify.Plyr(video.element, {
                        loop: {
                            active: enableLooping
                        }
                    });
                    var $productMediaGroup = $(video.container).closest(selectors2.productMediaGroup);
                    video.player.on("seeking", function() {
                        wpbingo.updateSlickSwipe($productMediaGroup, !1)
                    }), video.player.on("seeked", function() {
                        wpbingo.updateSlickSwipe($productMediaGroup, !0)
                    });
                    break;
                case hosts.youtube:
                    var videoId = productMediaWrapper.data(attributes.videoId);
                    video.player = new YT.Player(video.element, {
                        videoId,
                        events: {
                            onStateChange: function(event) {
                                event.data === 0 && enableLooping && event.target.seekTo(0)
                            }
                        }
                    });
                    break
            }
            productMediaWrapper.on("mediaHidden xrLaunch", function() {
                video.player && (video.host === hosts.html5 && video.player.pause(), video.host === hosts.youtube && video.player.pauseVideo && video.player.pauseVideo())
            }), productMediaWrapper.on("mediaVisible", function() {
                video.player && (video.host === hosts.html5 && video.player.play(), video.host === hosts.youtube && video.player.playVideo && video.player.playVideo())
            })
        }
    }

    function hostFromVideoElement(video) {
        return video.tagName === "VIDEO" ? hosts.html5 : video.tagName === "IFRAME" && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src) ? hosts.youtube : null
    }

    function loadVideos(host) {
        for (var key in videos)
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                video.host === host && video.ready()
            }
    }

    function fallbackToNativeVideo() {
        for (var key in videos)
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                if (video.nativeVideo) continue;
                video.host === hosts.html5 && (video.element.setAttribute("controls", "controls"), video.nativeVideo = !0)
            }
    }

    function removeSectionVideos(sectionId2) {
        for (var key in videos)
            if (videos.hasOwnProperty(key)) {
                var video = videos[key];
                video.sectionId === sectionId2 && (video.player && video.player.destroy(), delete videos[key])
            }
    }
    return {
        init: init2,
        hosts,
        loadVideos,
        removeSectionVideos
    }
}(), wpbingo.Product = function() {
    function Product(container2) {
        var $window = $(window),
            $container = this.$container = $(container2),
            sectionId2 = $container.attr("data-section-id");
        if (this.settings = {
                productPageLoad: !1,
                preloadImage: !1,
                enableHistoryState: $container.data("enable-history-state"),
                namespace: ".productSection",
                sectionId: sectionId2
            }, this.selectors = {
                productMediaGroup: ".js-product-media-group",
                productMediaGroupItem: ".js-product-media-item",
                productMediaWrapper: ".js-product-media",
                productMediaTypeModel: "[data-product-media-type-model]",
                productMediaTypeVideo: "[data-product-media-type-video]",
                productThumbnails: ".js-product-thumbnails",
                buyTogether: ".buy-together-products",
                productThumbnail: "[data-product-thumbnail]",
                productImageZoom: "[data-mfp-src]",
                meta: ".product-single__meta",
                productWrapper: ".product-single",
                productSelectOption: ".js-product-select-option--",
                originalSelectorId: ".js-product-select",
                singleOptionSelector: ".js-single-option-selector",
                slickDots: "[data-slick-dots]",
                slickNext: "[data-slick-next]",
                slickPrevious: "[data-slick-previous]",
                variantColor: "[data-color]"
            }, this.classes = {
                hide: "d-none",
                priceContainerUnitAvailable: "price-container--unit-available",
                productInventoryInStock: "product-avaiable__text--instock",
                productInventoryOutStock: "product-avaiable__text--outstock"
            }, this.slickMediaSettings = {
                slide: this.selectors.productMediaGroupItem,
                rows: 0,
                accessibility: !0,
                arrows: !0,
                appendDots: this.selectors.slickDots,
                prevArrow: this.selectors.slickPrevious,
                nextArrow: this.selectors.slickNext,
                dots: !1,
                rtl: wpbingo.rtl_slick(),
                infinite: !!$(this.selectors.productMediaGroup).data("infinite"),
                draggable: !!$(this.selectors.productMediaGroup).data("draggable"),
                adaptiveHeight: !0,
                fade: !!$(this.selectors.productMediaGroup).data("fade"),
                customPaging: function(slick, index) {
                    var slideA11yString = wpbingo.strings.productSlideLabel.replace("[slide_number]", index + 1).replace("[slide_max]", slick.slideCount),
                        mediaA11yString = $('[data-slick-index="' + index + '"]', this.$container).data("slick-media-label"),
                        ariaCurrent = index === 0 ? ' aria-current="true"' : "";
                    return '<a href="javascript:void(0)" aria-label="' + slideA11yString + " " + mediaA11yString + '" aria-controls="slick-slide0' + index + '"' + ariaCurrent + "></a>"
                }.bind(this)
            }, !!$("#ProductJson-" + sectionId2).html()) {
            this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId2).innerHTML), this.zoomType = $container.data("image-zoom-type"), this.isStackedLayout = $container.data("stacked-layout"), this.isNothumLayout = $container.data("nothum"), this.focusableElements = ["iframe", "input", "button", "video", '[tabindex="0"]'].join(","), this.slickThumbsSettings = {
                slidesToShow: $(this.selectors.productThumbnails).data("columns"),
                slidesToScroll: 1,
                rows: 0,
                accessibility: !0,
                arrows: !0,
                dots: !1,
                infinite: !1,
                focusOnSelect: !0,
                adaptiveHeight: !0,
                rtl: !!($("body").hasClass("rtl") && !$(this.selectors.productThumbnails).data("vertical")),
                vertical: !!$(this.selectors.productThumbnails).data("vertical"),
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                        vertical: !1
                    }
                }]
            }, !this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container) ? (this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + "-" + sectionId2, this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + "-" + sectionId2) : $(window).width() < 991 && $(this.selectors.productWrapper).data("layout_thumb") == "gird-sticky" && (this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + "-" + sectionId2, this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + "-" + sectionId2), this.view_gallery_product(), this.event_buy_together(), this.event_group_product(), this.initBreakpoints(), this.initProductVariant(), this.initModelViewerLibraries(), this.initShopifyXrLaunch(), this.initProductVideo(), this.initStickyProductMeta(), this.count_view_product(), this.count_sale_product(), this.percent_sale_product(), this.delivery_return(), this.ask_a_question(), this.back_in_stock(), this.single_product_share(), this.gallery_cursor(), this.discount_single(), this.sticky_gird(), this.sticky_sidebar(), this.image_360(), this.tab_information();
            var $element2 = $(".product-single"),
                _data = $element2.data();
            $(".product-single__video img").css("width", $(".product-single__thumbnail img").width()), $(".product-single__video img").css("height", $(".product-single__thumbnail img").height() - 2.5), $window.on("load" + this.settings.namespace, wpbingo.initStickyProductMeta).on("resize" + this.settings.namespace, wpbingo.debounce(this.initStickyProductMeta, 150).bind(this))
        }
    }
    return Product.prototype = _.assignIn({}, Product.prototype, {
        initBreakpoints: function() {
            var self = this;
            self.isStackedLayout ? $(window).width() < 991 ? (self.createMediaCarousel(), self.createThumbnailCarousel()) : enquire.register(wpbingo.variables.mediaMobile, {
                match: function() {
                    self.createMediaCarousel()
                },
                unmatch: function() {
                    self.destroyMediaCarousel()
                }
            }) : (self.createMediaCarousel(), self.createThumbnailCarousel())
        },
        initProductVariant: function() {
            var options = {
                    $container: this.$container,
                    enableHistoryState: this.settings.enableHistoryState || !1,
                    productSelectOption: this.selectors.productSelectOption,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId + "--" + this.settings.sectionId,
                    product: this.productSingleObject
                },
                count = $(this.selectors.productThumbnails, this.$container).data("columns");
            this.variants = new wpbingo.Variants(options);
            var featured_media = this.variants.currentVariant.featured_media;
            !$(".js-product-single-media").hasClass("no-variants") && !$(".js-product-single-media >.row").hasClass("mutil_slider-single") && featured_media && this.showVariantMedia(this.variants.currentVariant, !0), this.$container.on("variantChange" + this.settings.namespace, this.productPage.bind(this)), this.$container.on("variantMediaChange" + this.settings.namespace, this.showVariantMedia.bind(this)), this.variants.product.media.length <= count && $(this.selectors.productThumbnails, this.$container).addClass("no-transform")
        },
        initModelViewerLibraries: function() {
            if (this.$container.data("has-model")) {
                var $modelViewerElements = $(this.selectors.productMediaTypeModel, this.$container);
                wpbingo.ProductModel.init($modelViewerElements, this.settings.sectionId)
            }
        },
        initShopifyXrLaunch: function() {
            $(document).on("shopify_xr_launch", function() {
                var $currentMedia = $(this.selectors.productMediaWrapper + ":not(." + this.classes.hide + ")", this.$container);
                $currentMedia.trigger("xrLaunch")
            }.bind(this))
        },
        initProductVideo: function() {
            var sectionId2 = this.settings.sectionId;
            $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
                var $videoContainer = $(this);
                wpbingo.ProductVideo.init($videoContainer, sectionId2)
            })
        },
        trapCarouselFocus: function($slider, removeFocusTrap) {
            $slider && ($slider.find(".slick-slide:not(.slick-active)").find(this.focusableElements).attr("tabindex", removeFocusTrap ? "0" : "-1"), $slider.find(".slick-active").find(this.focusableElements).attr("tabindex", "0"))
        },
        updateCarouselDotsA11y: function(nextSlide) {
            var $dotLinks = $(this.selectors.slickDots).find("a");
            $dotLinks.removeAttr("aria-current").eq(nextSlide).attr("aria-current", "true")
        },
        view_gallery_product: function() {
            $element = $(".product-single"), $(".product-media__wrapper.product-media__wrapper--image", $element).bind("click", function(e) {
                e.preventDefault();
                var groups = $(this).closest(".js-product-media-group"),
                    items = [],
                    gallery = [],
                    $j = 0,
                    $i = 0;
                if ($(".js-product-media-item", groups).each(function() {
                        if ($("img", $(this)).data("number", $j), $("img", $(this)).data("image") == !0) {
                            var $href = $("img", $(this)).attr("src");
                            $href && (gallery[$j] = {
                                href: $href
                            }, $j++)
                        }
                    }), gallery) {
                    $.each(gallery, function(key, value) {
                        value && (items[$i] = {
                            src: value.href,
                            w: $(".mfp-image", $element).width() * 3,
                            h: $(".mfp-image", $element).height() * 3
                        }, $i++)
                    });
                    var pswpElement = document.querySelectorAll(".pswp")[0],
                        options = {
                            index: $("img", $(this)).data("number"),
                            closeOnScroll: !1,
                            history: !1,
                            shareEl: !1
                        },
                        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                    gallery.init()
                }
            })
        },
        event_buy_together: function() {
            $(document).on("change", '#buy_together_form .item-product input[type="checkbox"]', function(e) {
                var $this = $(this);
                $this.closest(".item-product").hasClass("active") ? $this.closest(".item-product").removeClass("active") : $this.closest(".item-product").addClass("active"), moneyFormat = wpbingo.strings.moneyFormat;
                var $thisWrap = $this.closest(".item-products-wrap"),
                    $thisWpbingoWrap = $thisWrap.closest(".buy-together-products"),
                    $thisProductsBtWrap = $thisWpbingoWrap.find(".item-products-wrap"),
                    total_items = 0,
                    total_price = 0;
                $thisWrap.find(".item-product").each(function() {
                    var this_product_id = $(this).attr("data-product_id");
                    if ($(this).hasClass("active")) {
                        if ($('input[type="hidden"]', $(this)).prop("disabled", !1), $('input[type="number"]', $(this)).prop("disabled", !1), $("select", $(this)).length > 0) {
                            var this_price = $("select", $(this)).find(":selected").data("price");
                            $("select", $(this)).prop("disabled", !1)
                        } else var this_price = $('input[type="checkbox"]', $(this)).attr("data-price");
                        isNaN(this_price) || (total_price = Number(total_price) + Number(this_price)), Number(total_items++), $thisProductsBtWrap.find('.item-product-inner[data-product_id="' + this_product_id + '"]').removeClass("buy-together-hidden")
                    } else $thisProductsBtWrap.find('.item-product-inner[data-product_id="' + this_product_id + '"]:not(.buy-together-content)').addClass("buy-together-hidden"), $('input[type="hidden"]', $(this)).prop("disabled", !0), $('input[type="number"]', $(this)).prop("disabled", !0), $("select", $(this)).length > 0 && $("select", $(this)).prop("disabled", !0)
                }), $thisWpbingoWrap.find(".for-items-text span").html(total_items), $thisWpbingoWrap.find(".total-price-html span").html('<span class="money">' + wpbingo.Currency.formatMoney(total_price, moneyFormat) + "</span>"), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
            }), $(document).on("change", "#buy_together_form .item-product select", function(e) {
                moneyFormat = wpbingo.strings.moneyFormat;
                var $this = $(this),
                    $thisWrap = $this.closest(".item-products-wrap"),
                    $thisWpbingoWrap = $thisWrap.closest(".buy-together-products"),
                    total_items = 0,
                    total_price = 0,
                    $parent = $(this).closest(".item-product"),
                    this_product_id = $parent.attr("data-product_id"),
                    $parent_image = $(this).closest(".buy-together-products").find('.item-product-inner[data-product_id="' + this_product_id + '"]'),
                    this_price_selected = $(this).find(":selected").data("price"),
                    this_image_selected = $(this).find(":selected").data("image");
                $(".buy-together-price", $parent).html('<span class="money">' + wpbingo.Currency.formatMoney(this_price_selected, moneyFormat) + "</span>"), $(".image img", $parent_image).attr("src", this_image_selected), $(".image img", $parent_image).attr("srcset", this_image_selected), $thisWrap.find(".item-product").each(function() {
                    if ($(this).hasClass("active")) {
                        if ($("select", $(this)).length > 0) var this_price = $("select", $(this)).find(":selected").data("price");
                        else var this_price = $('input[type="checkbox"]', $(this)).attr("data-price");
                        isNaN(this_price) || (total_price = Number(total_price) + Number(this_price)), Number(total_items++)
                    }
                }), $thisWpbingoWrap.find(".total-price-html span").html('<span class="money">' + wpbingo.Currency.formatMoney(total_price, moneyFormat) + "</span>"), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
            }), $("#buy_together_form .buy-together-add-all-to-cart").on("click", function(e) {
                e.preventDefault(), $(this).addClass("active");
                let addToCartForm = document.querySelector("#buy_together_form");
                var params = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(addToCartForm),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(line_item) {
                        $(".buy-together-add-all-to-cart").removeClass("active"), ajaxCart.load(), $(".js-drawer").length && $("body").addClass("drawer--open"), $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        })
                    },
                    error: function(XMLHttpRequest2, textStatus) {
                        typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                    }
                };
                jQuery.ajax(params)
            })
        },
        event_group_product: function() {
            $("#group_table_product .add-group-to-cart").on("click", function(e) {
                e.preventDefault(), $(this).removeClass("added"), $(this).addClass("active");
                let addToCartForm = document.querySelector("#group_table_product");
                var params = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(addToCartForm),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(line_item) {
                        $("#group_table_product .add-group-to-cart").removeClass("active"), $("#group_table_product .add-group-to-cart").addClass("added"), setTimeout(function() {
                            $("#group_table_product .add-group-to-cart").removeClass("added")
                        }, 3e3), ajaxCart.load(), $(".js-drawer").length > 0 && $("body").addClass("drawer--open"), $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        })
                    },
                    error: function(XMLHttpRequest2, textStatus) {
                        typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                    }
                };
                jQuery.ajax(params)
            })
        },
        translateCarouselDots: function(totalSlides, nextSlide, dotStyle) {
            if (!(totalSlides <= dotStyle.max)) {
                var calculatedTranslateDistance = 0,
                    maxTranslateDistance = (totalSlides - dotStyle.max) * dotStyle.width;
                nextSlide >= dotStyle.max - 1 && (calculatedTranslateDistance = (nextSlide + 2 - dotStyle.max) * dotStyle.width, calculatedTranslateDistance = maxTranslateDistance < calculatedTranslateDistance ? maxTranslateDistance : calculatedTranslateDistance), $(this.selectors.slickDots).find("ul").css("transform", "translateX(-" + calculatedTranslateDistance + "px)")
            }
        },
        triggerMediaChangeEvent: function(mediaId) {
            var $otherMedia = $(this.selectors.productMediaWrapper, this.$container);
            $otherMedia.trigger("mediaHidden");
            var $newMedia = $(this.selectors.productMediaWrapper, this.$container).filter('[data-media-id="' + mediaId + '"]');
            $newMedia.trigger("mediaVisible")
        },
        showVariantMedia: function(evt, check) {
            if (check) var variant = evt;
            else var variant = evt.variant;
            var variantMediaId = this.settings.sectionId + "-" + variant.featured_media.id,
                $newMedia = $(this.selectors.productMediaWrapper + '[data-media-id="' + variantMediaId + '"]');
            this.triggerMediaChangeEvent(variantMediaId);
            var mediaIndex;
            if (!wpbingo.variables.isMobile && this.isStackedLayout) {
                if (mediaIndex = $newMedia.closest(".slick-slide").index(), mediaIndex !== 0 || wpbingo.variables.productPageLoad)
                    if (wpbingo.variables.productPageSticky) $("html, body").animate({
                        scrollTop: $newMedia.offset().top
                    }, 250);
                    else {
                        var currentScroll = $(document).scrollTop();
                        $newMedia.closest($(this.selectors.productMediaGroupItem, this.$container)).prependTo($(this.selectors.productMediaGroup, this.$container)), $(document).scrollTop(currentScroll)
                    }
            } else {
                if (mediaIndex = $newMedia.closest(".slick-slide").data("slick-index"), _.isUndefined(mediaIndex)) return;
                (mediaIndex !== 0 || wpbingo.variables.productPageLoad) && $(this.selectors.productMediaGroup, this.$container).slick("slickGoTo", mediaIndex)
            }
            wpbingo.variables.productPageLoad || (wpbingo.variables.productPageLoad = !0)
        },
        setFeaturedMedia: function() {
            var mediaId = $(this.selectors.productMediaGroup, this.$container).find(".slick-slide.slick-current.slick-active " + this.selectors.productMediaWrapper).attr("data-media-id");
            this.triggerMediaChangeEvent(mediaId)
        },
        createMediaCarousel: function() {
            if (!($(this.selectors.productMediaGroupItem).length < 2 || !$(this.selectors.productMediaGroup, this.$container) || this.isCarouselActive)) {
                this.isCarouselActive = !0;
                var dotStyle = {
                        max: 9,
                        width: 20
                    },
                    focusTrapped = !1;
                if ($(this.selectors.productMediaGroupItem, this.$container).on("focusin", function() {
                        focusTrapped || (this.trapCarouselFocus($(this.selectors.productMediaGroup)), focusTrapped = !0)
                    }.bind(this)), $(".mutil_slider-single").length > 0) {
                    var sectionId2 = this.settings.sectionId,
                        $config = this.slickMediaSettings;
                    if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container)) var asNavFor = !0;
                    $(".mutil_slider-single").each(function(index) {
                        $config.nextArrow = $("[data-slick-next]", $(this)), $config.prevArrow = $("[data-slick-previous]", $(this)), asNavFor && ($config.asNavFor = ".js-product-thumbnails-" + sectionId2 + "-" + (index + 1)), $(".js-product-media-group", $(this)).slick($config)
                    })
                } else $(this.selectors.productMediaGroup, this.$container).slick(this.slickMediaSettings).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                    this.updateCarouselDotsA11y(nextSlide), this.translateCarouselDots(slick.slideCount, nextSlide, dotStyle)
                }.bind(this))
            }
        },
        destroyMediaCarousel: function() {
            !$(this.selectors.productMediaGroup, this.$container).length || !this.isCarouselActive || (this.trapCarouselFocus($(this.selectors.productMediaGroup, this.$container), !0), $(this.selectors.productMediaGroup, this.$container).slick("unslick"), this.isCarouselActive = !1)
        },
        createThumbnailCarousel: function() {
            if ($(".mutil_slider-single").length > 0) {
                var sectionId2 = this.settings.sectionId,
                    $configThumb = this.slickThumbsSettings;
                if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container)) var asNavFor = !0;
                $(".mutil_slider-single").each(function(index) {
                    asNavFor && ($configThumb.asNavFor = ".js-product-media-group-" + sectionId2 + "-" + (index + 1)), $(".js-product-thumbnails", $(this)).slick($configThumb)
                })
            } else $(this.selectors.productThumbnails, this.$container).slick(this.slickThumbsSettings)
        },
        initStickyProductMeta: function() {
            var $meta = $(this.selectors.meta, this.$container),
                $wrapper = $(this.selectors.productWrapper, this.$container);
            if (!(!$meta.length || $(this.selectors.productMediaWrapper, this.$container).length < 2) && ($meta.trigger("detach.ScrollToFixed"), !wpbingo.variables.isMobile)) {
                var productCopyHeight = $meta.outerHeight(),
                    productMediaGroupHeight = $(this.selectors.productMediaGroup, this.$container).height(),
                    calcLimit = $wrapper.offset().top + $wrapper.height();
                calcLimit -= productCopyHeight, productCopyHeight < productMediaGroupHeight && productCopyHeight < $(window).height() ? (wpbingo.variables.productPageSticky = !0, $meta.scrollToFixed({
                    limit: calcLimit
                })) : wpbingo.variables.productPageSticky = !1
            }
        },
        getBaseUnit: function(variant) {
            return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
        },
        productPage: function(evt) {
            var moneyFormat2 = wpbingo.strings.moneyFormat,
                variant = evt.variant,
                translations = wpbingo.strings,
                selectors2 = {
                    addToCart: ".btn--add-to-cart",
                    addToCartText: ".btn--add-to-cart .btn__text",
                    quantityElements: ".js-quantity-selector",
                    shopifyPaymentButton: ".shopify-payment-button",
                    priceContainer: "[data-price-container]",
                    productPrice: ".js-product-price",
                    priceA11y: ".js-product-price-a11y",
                    comparePrice: ".js-product-compare-price",
                    comparePriceA11y: ".js-product-compare-price-a11y",
                    comparePriceWrapper: ".product-single__price--wrapper",
                    productAvailable: ".js-product-avaiable",
                    productAvailableText: ".js-product-avaiable-text",
                    unitPrice: "[data-unit-price]",
                    unitPriceBaseUnit: "[data-unit-price-base-unit]",
                    SKU: ".js-variant-sku"
                };
            if (variant) {
                if ($(selectors2.priceContainer, this.$container).removeClass(this.classes.hide), $(selectors2.productAvailable, this.$container).removeClass(this.classes.hide), $(selectors2.productPrice, this.$container).attr("aria-hidden", "false"), $(selectors2.priceA11y, this.$container).attr("aria-hidden", "false"), variant.available ? ($(selectors2.addToCart, this.$container).removeClass("disabled").prop("disabled", !1), $(selectors2.addToCartText, this.$container).html(translations.addToCart), $(selectors2.productAvailableText).removeClass(this.classes.productInventoryOutStock).addClass(this.classes.productInventoryInStock).html(wpbingo.strings.inStock), $(selectors2.quantityElements, this.$container).removeClass(this.classes.hide), $(selectors2.shopifyPaymentButton, this.$container).removeClass(this.classes.hide)) : ($(selectors2.addToCart, this.$container).addClass("disabled").prop("disabled", !0), $(selectors2.addToCartText, this.$container).html(translations.soldOut), $(selectors2.productAvailableText).removeClass(this.classes.productInventoryInStock).addClass(this.classes.productInventoryOutStock).html(wpbingo.strings.outStock), $(selectors2.quantityElements, this.$container).addClass(this.classes.hide), $(selectors2.shopifyPaymentButton, this.$container).addClass(this.classes.hide)), $(selectors2.productPrice, this.$container).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat2)).removeClass(this.classes.hide), variant.compare_at_price > variant.price ? ($(selectors2.comparePrice, this.$container).html(wpbingo.Currency.formatMoney(variant.compare_at_price, moneyFormat2)), $(selectors2.comparePriceWrapper, this.$container).removeClass(this.classes.hide), $(selectors2.productPrice, this.$container).addClass("on-sale"), $(selectors2.comparePriceWrapper, this.$container).attr("aria-hidden", "false"), $(selectors2.comparePriceA11y, this.$container).attr("aria-hidden", "false")) : ($(selectors2.comparePriceWrapper, this.$container).addClass(this.classes.hide).attr("aria-hidden", "true"), $(selectors2.productPrice, this.$container).removeClass("on-sale"), $(selectors2.comparePrice, this.$container).html(""), $(selectors2.comparePriceA11y, this.$container).attr("aria-hidden", "true")), variant.unit_price) {
                    var $unitPrice = $(selectors2.unitPrice, this.$container),
                        $unitPriceBaseUnit = $(selectors2.unitPriceBaseUnit, this.$container);
                    $unitPrice.html(wpbingo.Currency.formatMoney(variant.unit_price, moneyFormat2)), $unitPriceBaseUnit.html(this.getBaseUnit(variant)), $(selectors2.priceContainer, this.$container).addClass(this.classes.priceContainerUnitAvailable)
                }
                $(selectors2.SKU).html(variant.sku != "" ? variant.sku : "N/A")
            } else $(selectors2.addToCart, this.$container).addClass("disabled").prop("disabled", !0), $(selectors2.addToCartText, this.$container).html(translations.unavailable), $(selectors2.quantityElements, this.$container).addClass(this.classes.hide), $(selectors2.shopifyPaymentButton, this.$container).addClass(this.classes.hide), $(selectors2.priceContainer, this.$container).addClass(this.classes.hide), $(selectors2.productAvailable, this.$container).addClass(this.classes.hide), $(selectors2.productPrice, this.$container).attr("aria-hidden", "true"), $(selectors2.priceA11y, this.$container).attr("aria-hidden", "true"), $(selectors2.comparePriceWrapper, this.$container).attr("aria-hidden", "true"), $(selectors2.comparePriceA11y, this.$container).attr("aria-hidden", "true")
        },
        onUnload: function() {
            this.$container.off(this.settings.namespace), wpbingo.ProductModel.removeSectionModels(this.settings.sectionId), wpbingo.ProductVideo.removeSectionVideos(this.settings.sectionId), this.isStackedLayout && $(window).width() > 991 && this.destroyMediaCarousel()
        },
        count_view_product: function() {
            if ($(".product-count-view").length > 0) {
                var id_product = $(".product-count-view").data("id_product"),
                    min = $(".product-count-view").data("min") ? $(".product-count-view").data("min") : 30,
                    max = $(".product-count-view").data("max") ? $(".product-count-view").data("max") : 40,
                    timeout = $(".product-count-view").data("timeout") ? $(".product-count-view").data("timeout") : 1e4,
                    auto = Math.round(Math.random() * (max - min)) + min;
                $("span", ".product-count-view").html(auto), setTimeout(function random() {
                    var auto2 = Math.round(Math.random() * (max - min)) + min;
                    $("span", ".product-count-view").html(auto2), setTimeout(random, timeout)
                }, timeout)
            }
        },
        count_sale_product: function() {
            if ($(".product-count-sale").length > 0) {
                var id_product = $(".product-count-sale").data("id_product"),
                    min = $(".product-count-sale").data("min") ? $(".product-count-sale").data("min") : 30,
                    max = $(".product-count-sale").data("max") ? $(".product-count-sale").data("max") : 40,
                    time_min = $(".product-count-sale").data("time_min") ? $(".product-count-sale").data("time_min") : 30,
                    time_max = $(".product-count-sale").data("time_max") ? $(".product-count-sale").data("time_max") : 40,
                    cookieValue = wpbingo.getCookie("product_" + id_product),
                    cookieTime = wpbingo.getCookie("time_" + id_product);
                if (cookieValue && cookieTime) $("span.count", ".product-count-sale").html(cookieValue), $("span.time", ".product-count-sale").html(cookieTime);
                else {
                    var rand2 = Math.round(Math.random() * (max - min)) + min,
                        time = Math.round(Math.random() * (time_max - time_min)) + time_min;
                    wpbingo.setCookie("product_" + id_product, rand2, {
                        expires: 24 * 60 * 60 * 1e3
                    }), wpbingo.setCookie("time_" + id_product, time, {
                        expires: 24 * 60 * 60 * 1e3
                    }), $("span.count", ".product-count-sale").html(rand2), $("span.time", ".product-count-sale").html(time)
                }
            }
        },
        percent_sale_product: function() {
            setTimeout(function() {
                var percent = $(".js-product-avaiable #variant-inventory_percent.show").data("percent");
                $(".js-product-avaiable #variant-inventory_percent .percent").css("--progress-bar-width", percent)
            }, 500)
        },
        delivery_return: function() {
            if ($(".product-single .delivery_return").length > 0) {
                var $element2 = $(".product-single .delivery_return");
                $(".delivery_return-title", $element2).on("click", function() {
                    $(".delivery_return-content", $element2).hasClass("active") || ($(".delivery_return-content", $element2).addClass("active"), setTimeout(function() {
                        $(".content-shipping", $element2).addClass("active")
                    }, 300))
                }), $(".delivery_return-close", $element2).on("click", function() {
                    $(".delivery_return-content", $element2).hasClass("active") && ($(".content-shipping", $element2).removeClass("active"), setTimeout(function() {
                        $(".delivery_return-content", $element2).removeClass("active")
                    }, 300))
                })
            }
        },
        ask_a_question: function() {
            $(".product-single .product-ask_a_question").length > 0 && ($(".product-ask_a_question .open-ask_a_question").on("click", function() {
                $(".product-ask_a_question .ask_a_question-form").hasClass("active") ? ($(".product-ask_a_question .ask_a_question-form").removeClass("active"), $(".product-ask_a_question .ask_a_question-form .content-form").removeClass("active")) : ($(".product-ask_a_question .ask_a_question-form").addClass("active"), setTimeout(function() {
                    $(".product-ask_a_question .ask_a_question-form .content-form").addClass("active")
                }, 300))
            }), $(".product-ask_a_question .close-ask_a_question-form").on("click", function() {
                $(".product-ask_a_question .ask_a_question-form").hasClass("active") && ($(".product-ask_a_question .ask_a_question-form .content-form").removeClass("active"), setTimeout(function() {
                    $(".product-ask_a_question .ask_a_question-form").removeClass("active")
                }, 300))
            }), setTimeout(function() {
                $(".product-ask_a_question .alert").remove()
            }, 2e3))
        },
        back_in_stock: function() {
            $(".product-single .product-back_in_stock").length > 0 && ($(".product-back_in_stock .open-back_in_stock").on("click", function() {
                $(".product-back_in_stock .back_in_stock-form").hasClass("active") ? ($(".product-back_in_stock .back_in_stock-form").removeClass("active"), $(".product-back_in_stock .back_in_stock-form .content-form").removeClass("active")) : ($(".product-back_in_stock .back_in_stock-form").addClass("active"), setTimeout(function() {
                    $(".product-back_in_stock .back_in_stock-form .content-form").addClass("active")
                }, 300))
            }), $(".product-back_in_stock .close-back_in_stock-form").on("click", function() {
                $(".product-back_in_stock .back_in_stock-form").hasClass("active") && ($(".product-back_in_stock .back_in_stock-form .content-form").removeClass("active"), setTimeout(function() {
                    $(".product-back_in_stock .back_in_stock-form").removeClass("active")
                }, 300))
            }), setTimeout(function() {
                $(".product-back_in_stock .alert").remove()
            }, 2e3))
        },
        single_product_share: function() {
            if ($(".product-single .product_share").length > 0) {
                var $element2 = $(".product-single .product_share");
                $(".product_share_label", $element2).on("click", function() {
                    $(".product_share-content", $element2).hasClass("active") || ($(".product_share-content", $element2).addClass("active"), setTimeout(function() {
                        $(".content-product_share", $element2).addClass("active")
                    }, 300))
                }), $(".product_share-close", $element2).on("click", function() {
                    $(".product_share-content", $element2).hasClass("active") && ($(".content-product_share", $element2).removeClass("active"), setTimeout(function() {
                        $(".product_share-content", $element2).removeClass("active")
                    }, 300))
                }), $(".product_share-copy button", $element2).click(function() {
                    var copyText = $(".product_share-copy .url_share", $element2).attr("value"),
                        $text = $(".product_share-copy", $element2).data("text"),
                        $temp = $("<input>");
                    $("body").append($temp), $temp.val(copyText).select(), document.execCommand("copy"), $temp.remove();
                    var notificationTag = $("div.copy-notification");
                    notificationTag.length == 0 && (notificationTag = $("<div/>", {
                        class: "copy-notification",
                        text: $text
                    }), $("body").append(notificationTag), notificationTag.fadeIn("slow", function() {
                        setTimeout(function() {
                            notificationTag.fadeOut("slow", function() {
                                notificationTag.remove()
                            })
                        }, 1e3)
                    }))
                })
            }
        },
        gallery_cursor: function() {
            $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mouseenter(function() {
                $(".gallery-cursor", $(this)).addClass("show")
            }), $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mousemove(function(event) {
                var offset = $(this).offset(),
                    relX = event.pageX - offset.left - 25,
                    relY = event.pageY - offset.top - 25;
                $(".gallery-cursor", $(this)).css({
                    top: relY + "px",
                    left: relX + "px"
                })
            }), $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mouseleave(function(event) {
                $(".gallery-cursor", $(this)).removeClass("show")
            })
        },
        discount_single: function() {
            $(".product-single #buy_more_form").length > 0 && $("#buy_more_form .buy-more-cart").on("click", function(e) {
                e.preventDefault(), $(this).addClass("active");
                let addToCartForm = document.querySelector("#buy_more_form");
                var params = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(addToCartForm),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(line_item) {
                        $(".buy-more-cart").removeClass("active"), $(".buy-more-cart").addClass("added"), $(".js-drawer").length && $("body").addClass("drawer--open"), $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        }), ajaxCart.load(), wpbingo.discount_single()
                    },
                    error: function(XMLHttpRequest2, textStatus) {
                        typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                    }
                };
                jQuery.ajax(params)
            })
        },
        sticky_gird: function() {
            if ($(window).width() > 992 && $(".product-single.gird-sticky").length > 0) {
                var $element2 = $(".product-single.gird-sticky"),
                    eventElemArray = [],
                    _count = 0,
                    _countFix = 0,
                    $image_array = $(".js-product-media-group .js-product-media-item", $element2);
                $(".js-product-thumbnails a", $element2).on("click", function() {
                    var $thumb = $(this).data("media-id"),
                        $image = $(".js-product-media-group .js-product-media[data-media-id=" + $thumb + "]", $element2);
                    $("html, body").animate({
                        scrollTop: $image.offset().top
                    }, "300"), $image.css({
                        "padding-top": "15px"
                    }), $(this).addClass("slick-current")
                }), $(window).on("load scroll resize", function() {
                    eventElemArray = [], _count = 0, $image_array.each(function(i, pager) {
                        eventElemArray.push($(pager).offset().top)
                    });
                    for (var _i = 0; _i < eventElemArray.length; _i++) $(window).scrollTop() + $(window).height() * .5 > eventElemArray[_i] && _count++;
                    _count !== _countFix && (_countFix = _count, $(".js-product-thumbnails .product-single__thumbnail-wrapper", $element2).removeClass("slick-current"), $(".js-product-thumbnails .product-single__thumbnail-wrapper", $element2).eq(_count - 1).addClass("slick-current"))
                });
                var $content = $(".js-product-single-media", $element2),
                    thumb_left = $(".js-product-thumbnails", $element2).offset.left,
                    thumb_width = $(".js-product-thumbnails", $element2).width() + "px",
                    thumb_ToTop = $(".js-product-thumbnails", $element2).offset().top;
                $content.height() > $(".js-product-thumbnails", $element2).height() && $(window).scroll(function() {
                    var windowToTop = $(window).scrollTop(),
                        thumb_height = $(".js-product-thumbnails", $element2).height() + "px",
                        stopsticky = $content.height() + $content.offset().top - windowToTop;
                    windowToTop + 10 > thumb_ToTop ? $(".js-product-thumbnails", $element2).css({
                        position: "fixed",
                        top: "15px",
                        left: thumb_left,
                        width: thumb_width,
                        height: thumb_height
                    }) : ($(".js-product-thumbnails", $element2).removeAttr("style"), $(".js-product-media-group .js-product-media", $element2).removeAttr("style")), stopsticky < $(".js-product-thumbnails", $element2).height() && $(".js-product-thumbnails", $element2).css({
                        position: "absolute",
                        top: $content.height() - $(".js-product-thumbnails", $element2).height() + "px",
                        left: thumb_left,
                        width: thumb_width,
                        height: thumb_height
                    })
                });
                var info_image = $(".js-product-media-item", $content).height() * 2,
                    info_left = $(".product-single__metas", $element2).offset.left,
                    info_width = $(".product-single__metas", $element2).width() + "px",
                    info_ToTop = $(".product-single__metas", $element2).offset().top;
                $content.height() > $(".product-single__metas", $element2).height() + info_image && $(window).scroll(function() {
                    var windowToTop = $(window).scrollTop(),
                        info_height = $(".product-single__metas", $element2).height() + "px",
                        stopsticky = $content.height() + $content.offset().top - windowToTop;
                    windowToTop + 10 > info_ToTop ? $(".product-single__metas", $element2).css({
                        position: "fixed",
                        top: "15px",
                        left: info_left,
                        width: info_width,
                        height: info_height
                    }) : $(".product-single__metas", $element2).removeAttr("style"), stopsticky < $(".product-single__metas", $element2).height() + info_image && $(".product-single__metas", $element2).css({
                        position: "absolute",
                        top: $content.height() - $(".product-single__metas", $element2).height() - info_image + "px",
                        left: info_left,
                        width: info_width,
                        height: info_height
                    })
                })
            }
        },
        sticky_sidebar: function() {
            if ($(window).width() < 1199 && $(".product-single .bwp-single-sidebar").length > 0) {
                var $element2 = $(".product-single .bwp-single-sidebar");
                $(".product-single .toggle-sidebar").on("click", function() {
                    $element2.hasClass("show") ? $element2.removeClass("show") : $element2.addClass("show")
                })
            }
        },
        image_360: function() {
            $(".product-single .bwp-image-360").length > 0 && $(".product-single .bwp-image-360").TreeSixtyImageRotate({
                totalFrames: $(".product-single .bwp-image-360").data("count"),
                endFrame: $(".product-single .bwp-image-360").data("count")
            }).initTreeSixty()
        },
        tab_information: function() {
            if ($(".template-product .product-more-info").length > 0) {
                var $parent = $(".template-product .product-more-info");
                $(window).width() > 991 ? $(".more-info-tabs__nav-link", $parent).on("click", function() {
                    var id = $(this).data("id");
                    $(".more-info-tabs__nav-link", $parent).removeClass("active"), $(".more-info-tabs__content .tab-pane", $parent).removeClass("show"), $(this).addClass("active"), $("#" + id, $parent).addClass("show")
                }) : ($(".more-info-tabs__content .tab-pane", $parent).removeClass("show"), $(".more-info-tabs__nav-link", $parent).on("click", function() {
                    var id = $(this).data("id");
                    $(".more-info-tabs__content .tab-pane", $parent).slideUp(), $("body,html").animate({
                        scrollTop: $(".more-info-tabs__content").offset().top - 50
                    }, 600), $(this).hasClass("active") ? ($("#" + id, $parent).slideUp(), $(".more-info-tabs__nav-link", $parent).removeClass("active")) : ($("#" + id, $parent).slideDown(), $(".more-info-tabs__nav-link", $parent).removeClass("active"), $(this).addClass("active"))
                }))
            }
        }
    }), Product
}(), wpbingo.ProductRecommendations = function() {
    function ProductRecommendations(container2) {
        this.$container = $(container2);
        var self = this,
            baseUrl = this.$container.data("baseUrl"),
            productId = this.$container.data("productId"),
            recommendationsSectionUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=6";
        $.get(recommendationsSectionUrl).then(function(section) {
            var recommendationsMarkup = $(section).html();
            if (recommendationsMarkup.trim() !== "") {
                self.$container.html(recommendationsMarkup);
                var $config = $('[data-section-type="product-recommendations"]'),
                    $title = $('[data-section-type="product-recommendations"]').data("title"),
                    $element2 = $(".js-product-recommendations", self.$container);
                $(".wpbingo-title__heading", $config).html($title), $element2.slick({
                    slidesToShow: $config.data("columns"),
                    autoplay: $config.data("autoplay"),
                    autoplaySpeed: $config.data("autoplayspeed"),
                    arrows: $config.data("nav"),
                    infinite: $config.data("infinite"),
                    slidesToScroll: $config.data("slidestoscroll") ? $config.data("columns") : 1,
                    rtl: wpbingo.rtl_slick(),
                    responsive: [{
                        breakpoint: 1441,
                        settings: {
                            slidesToShow: $config.data("column1440") ? $config.data("column1440") : $config.data("column"),
                            slidesToScroll: $config.data("column1440") ? $config.data("column1440") : $config.data("column")
                        }
                    }, {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: $config.data("column1"),
                            slidesToScroll: $config.data("column1")
                        }
                    }, {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: $config.data("column2"),
                            slidesToScroll: $config.data("column2")
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: $config.data("column3"),
                            slidesToScroll: $config.data("column3")
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: $config.data("column4"),
                            slidesToScroll: $config.data("column4")
                        }
                    }]
                }), initButtons(".js-product-recommendations"), initButtonsCompare(".js-product-recommendations"), wpbingo.countdown(), wpbingo.click_atribute_image(), wpbingo.zoom_thumb(), wpbingo.popup_product_card(), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), $(".product-card__image-wrapper.slider").each(function() {
                    wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                })
            }
        })
    }
    return ProductRecommendations
}(), wpbingo.HeaderSection = function() {
    var selectors2 = {
        disclosureLocale: "[data-disclosure-locale]",
        disclosureCurrency: "[data-disclosure-currency]",
        searchOptions: ".js-header-search-options",
        searchMobileToggle: ".js-header-search-toggle",
        menuMobileToggle: ".js-menu-mobile",
        menuMobileChildToggle: ".js-mm-nav-item"
    };

    function Header(container2) {
        this.$container = $(container2), this.cache = {}, this.cacheSelectors();
        var $body2 = $("body");
        this.cache.$localeDisclosure.length && (this.localeDisclosure = new wpbingo.Disclosure(this.cache.$localeDisclosure)), this.cache.$currencyDisclosure.length && (this.currencyDisclosure = new wpbingo.Disclosure(this.cache.$currencyDisclosure)), this.cache.$searchOptions.on("click", function(evt) {
            evt.preventDefault();
            var $this = $(this),
                $form = $this.closest("form");
            $form.find(".js-header-search-options").removeClass("active"), $this.addClass("active"), $form.find(".dropdown-toggle").text($this.text()), $form.find(".js-search-type").val($this.data("type"))
        }), this.cache.$searchMobileToggle.on("click", function(evt) {
            evt.preventDefault(), $body2.toggleClass("modal-search--open")
        }), this.cache.$menuMobileToggle.on("click", function(evt) {
            evt.preventDefault(), $body2.toggleClass("menu-mobile--open")
        }), $(".menu-mobile__overlay").on("click", function(evt) {
            evt.preventDefault(), $body2.removeClass("menu-mobile--open")
        }), this.cache.$menuMobileChildToggle.on("click", function(evt) {
            evt.preventDefault();
            var $this = $(this);
            $this.hasClass("mm-nav__prev") ? $this.closest(".active--hidden").removeClass("active--hidden") : $this.parents(".mm-nav__links").addClass("active--hidden"), $this.closest(".menu-mobile__nav-item").toggleClass("active")
        })
    }
    return Header.prototype = _.assignIn({}, Header.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $localeDisclosure: this.$container.find(selectors2.disclosureLocale),
                $currencyDisclosure: this.$container.find(selectors2.disclosureCurrency),
                $searchOptions: this.$container.find(selectors2.searchOptions),
                $searchMobileToggle: this.$container.find(selectors2.searchMobileToggle),
                $menuMobileToggle: this.$container.find(selectors2.menuMobileToggle),
                $menuMobileChildToggle: this.$container.find(selectors2.menuMobileChildToggle)
            }
        },
        onUnload: function() {
            this.cache.$localeDisclosure.length && this.localeDisclosure.unload(), this.cache.$currencyDisclosure.length && this.currencyDisclosure.unload()
        }
    }), Header
}(), wpbingo.LoginRegister = function() {
    var selectors2 = {
        loginForm: ".js-login-form",
        recoverPasswordForm: ".js-recover-password",
        recoverPasswordToggle: ".js-forget-password",
        recoverPasswordSuccess: ".js-recover-password-success"
    };

    function LoginRegister(container2) {
        this.$container = $(container2), this.cache = {}, this.classes = {
            hidden: "d-none"
        }, this.cacheSelectors(), this.initializeEvents(), this.resetPasswordSuccess()
    }
    return LoginRegister.prototype = _.assignIn({}, LoginRegister.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $loginForm: this.$container.find(selectors2.loginForm),
                $recoverPasswordForm: this.$container.find(selectors2.recoverPasswordForm),
                $recoverPasswordToggle: this.$container.find(selectors2.recoverPasswordToggle),
                $recoverPasswordSuccess: this.$container.find(selectors2.recoverPasswordSuccess)
            }
        },
        initializeEvents: function() {
            this.cache.$recoverPasswordToggle.length && this.cache.$recoverPasswordToggle.on("click", function(e) {
                e.preventDefault();
                var isShow = !this.cache.$loginForm.hasClass(this.classes.hidden);
                this.displayRecoverPasswordForm(isShow)
            }.bind(this)), window.location.hash === "#recover" && this.displayRecoverPasswordForm(!0)
        },
        displayRecoverPasswordForm: function(isShow) {
            isShow ? (this.cache.$loginForm.addClass(this.classes.hidden), this.cache.$recoverPasswordForm.removeClass(this.classes.hidden)) : (this.cache.$loginForm.removeClass(this.classes.hidden), this.cache.$recoverPasswordForm.addClass(this.classes.hidden))
        },
        resetPasswordSuccess: function() {
            typeof window.resetPassword < "u" && window.resetPassword && this.cache.$recoverPasswordSuccess.removeClass(this.classes.hidden)
        }
    }), LoginRegister
}(), wpbingo.Search = function() {
    var selectors2 = {
        search: "[data-search]",
        searchPagination: ".search-pagination a"
    };

    function Search(container2) {
        var ajaxCartSearch = function() {
                typeof ajaxCart < "u" && ajaxCart.init({
                    formSelector: ".search-results [data-product-form]"
                })
            },
            searchResultData = function(container3, url) {
                $.get(url, function(data2) {
                    container3.html(data2), ajaxCartSearch()
                })
            },
            getSearchResult = function(searchs) {
                searchs.each(function() {
                    var $this = $(this);
                    $.get($this.data("url"), function(data2) {
                        $this.html(data2), ajaxCartSearch()
                    })
                })
            };
        this.$container = $(container2), this.cache = {}, this.cacheSelectors(), this.cache.$search.length && getSearchResult(this.cache.$search), this.$container.on("click", selectors2.searchPagination, function(e) {
            e.preventDefault();
            var $searchContainer = $(this).parents(selectors2.search),
                searchURL = $(this).attr("href");
            searchResultData($searchContainer, searchURL)
        })
    }
    return Search.prototype = _.assignIn({}, Search.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $search: this.$container.find(selectors2.search)
            }
        }
    }), Search
}(), wpbingo.QuickView = function() {
    var selectors2 = {
        body: "body",
        quickView: "[data-quickview]",
        quickViewTemplate: "#quickview-template",
        quickViewBtn: ".js-btn-quickview",
        quickViewContainer: "[data-quickview-container]",
        quickViewClose: "[data-quickview-close]",
        quickViewImages: "[data-quickview-images]",
        quickViewReview: "[data-quickview-review]",
        quickViewReview: "[data-quickview-review]",
        quickviewVariant: ".js-quickview-option-selector",
        originalSelectorId: "[data-quickview-variant]",
        quickViewProductPrice: ".js-qv-product-price",
        quickViewProductPriceCompare: ".js-qv-product-price-compare",
        quickViewQty: "[data-quickview-quantity]",
        quickViewSKU: "[data-quickview-sku]",
        quickViewAvaiable: ".product-avaiable",
        quickViewAvaiableInStock: ".product-avaiable--instock",
        quickViewAvaiableOutStock: ".product-avaiable--outstock",
        quickViewProductDetailsURL: ".js-qv-product-details"
    };

    function QuickView(container2) {
        this.$container = $(container2), this.cache = {}, this.productVariants = [], this.currentVariant = {}, this.cacheSelectors(), this.initializeEvents()
    }
    return QuickView.prototype = _.assignIn({}, QuickView.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $quickViewContainer: this.$container.find(selectors2.quickViewContainer)
            }
        },
        initializeEvents: function() {
            var $this = this;
            $(selectors2.body).on("click", selectors2.quickViewBtn, function(e) {
                e.preventDefault();
                var productHandle = $(this).data("handle");
                $(this).addClass("load-quickview"), $.getJSON("/products/" + productHandle + ".js", function(product) {
                    product.available ? $this.firstAvailableVariant(product.variants, $this) : $this.currentVariant = product.variants[0], $(selectors2.quickViewBtn).removeClass("load-quickview"), $this.buildQuickView(product), $this.buildMetafields(product), $this.renderReview(), $this.createImageCarousel(), $("[data-quickview]").addClass("show"), setTimeout(function() {
                        $("[data-quickview]").addClass("show-content")
                    }, 300);
                    var $element2 = $(".quickview .product-quickview__variants .variants-wrapper");
                    $($element2).each(function() {
                        var $this2 = $(this);
                        if ($("select", $this2).length > 0) var value = $("select", $this2).find(":selected").val();
                        else var value = $("input:checked", $this2).attr("value");
                        $(".variants__label span", $this2).html(value)
                    })
                })
            }), $(selectors2.body).on("click", selectors2.quickViewClose, function(e) {
                e.preventDefault(), $("[data-quickview]").removeClass("show-content"), setTimeout(function() {
                    $("[data-quickview]").removeClass("show")
                }, 300), setTimeout(function() {
                    $("[data-quickview-container]").empty()
                }, 500)
            }), $(selectors2.quickViewContainer).on("change", selectors2.quickviewVariant, function(e) {
                $this.onVariantChange()
            })
        },
        firstAvailableVariant: function(variants, global) {
            global.productVariants = variants;
            for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                if (variant.available) {
                    global.currentVariant = variant;
                    break
                }
            }
        },
        buildQuickView: function(product) {
            var moneyFormat2 = wpbingo.strings.moneyFormat,
                currentVariant = this.currentVariant,
                source = $(selectors2.quickViewTemplate).html(),
                template = Handlebars.compile(source),
                images = "",
                price = "",
                external = "",
                qvObject = {
                    id: product.id
                };
            if (typeof product.media < "u") {
                images += '<div class="quickview-images__list slick-carousel" data-quickview-images>';
                for (var i = 0; i < product.media.length; i++) {
                    var media = product.media[i];
                    if (media.media_type !== "video") images += '<div class="slick-carousel__item"><div class="quickview-images__item" data-media-id=' + media.id + '><img class="img-fluid" alt="' + product.title + '" src="' + media.preview_image.src + '" /></div></div>';
                    else {
                        var media_video;
                        for (var j in media.sources) media.sources[j].width == media.preview_image.width && media.sources[j].format == "mp4" && (media_video = media.sources[j].url);
                        images += '<div class="slick-carousel__item"><div class="quickview-images__item" data-media-id=' + media.id + '><video class="img-fluid" playsinline="" loop="loop" autoplay="autoplay" muted="muted" src="' + media_video + '" /></video></div></div>'
                    }
                }
                images += "</div>"
            }
            qvObject.variantID = currentVariant.id, qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== "" ? currentVariant.sku : "N/A", qvObject.images = images, qvObject.title = product.title, qvObject.url = product.url, qvObject.vendor = product.vendor, price += '<div class="price-container">';
            var productCompareClass = currentVariant.compare_at_price !== null ? "" : "d-none";
            price += '<div class="js-qv-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + wpbingo.Currency.formatMoney(currentVariant.compare_at_price, moneyFormat2) + "</div>", price += '<div class="js-qv-product-price product-single__price">' + wpbingo.Currency.formatMoney(currentVariant.price, moneyFormat2) + "</div>", price += '</div">', qvObject.price = price, qvObject.vendor = product.vendor, qvObject.type = product.type, qvObject.variants = this.buildVariant(product), $(selectors2.quickViewContainer).html(template(qvObject)), this.updateMedia(currentVariant), this.updateSKU(currentVariant), this.updateProductAvaiable(currentVariant), this.updateDetailsLink(currentVariant), $("#form-simple-addtocart .btn--add-to-cart").on("click", function(e) {
                e.preventDefault(), $(this).removeClass("added"), $(this).addClass("active");
                let addToCartForm = document.querySelector("#form-simple-addtocart");
                var params = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(addToCartForm),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(line_item) {
                        $("#form-simple-addtocart .btn--add-to-cart").removeClass("active"), $("#form-simple-addtocart .btn--add-to-cart").addClass("added"), setTimeout(function() {
                            $("#form-simple-addtocart .btn--add-to-cart").removeClass("added")
                        }, 2e3), ajaxCart.load(), $(".js-drawer").length && $("body").addClass("drawer--open"), $(".js-drawer-close").on("click", function() {
                            $("body").removeClass("drawer--open")
                        })
                    },
                    error: function(XMLHttpRequest2, textStatus) {
                        typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                    }
                };
                jQuery.ajax(params)
            }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        convertToSlug: function(str) {
            return str.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        buildMetafields: function(product) {
            var this_button = $(".js-btn-quickview[data-handle=" + product.handle + "]"),
                parent_button = this_button.closest(".product-card"),
                html = "";
            if (parent_button.data("external")) {
                var value = parent_button.data("external");
                $(".product-quickview__buttons").remove(), html += '<a href="' + value + '">' + wpbingo.strings.external + "</a>", $(".product-quickview__buttons_external").html(html)
            }
            if (parent_button.data("short_description")) {
                var value = parent_button.data("short_description");
                $(".product-quickview .product-quickview__description").html(value)
            }
            if (parent_button.data("countdowns")) {
                var countdowns = parent_button.data("countdowns");
                $(".quickview .countdown-quickview").removeClass("hidden"), html += '<div class="countdown" data-countdown="' + countdowns + '"></div>', $(".countdown-quickview .content").html(html);
                var $this = $(".product-quickview .countdown-quickview .countdown"),
                    finalDate = $this.data("countdown"),
                    date_final = new Date(finalDate),
                    seconds_final = date_final.getTime(),
                    date = Date.now(),
                    text_day = "d",
                    text_hour = "h",
                    time_min = "m",
                    text_sec = "s";
                seconds_final > date ? $this.countdown(finalDate, function(event) {
                    var strTime = '<div class="countdown__item"><span>%D</span><span>' + text_day + '</span></div><div class="countdown__item"><span>%H</span><span>' + text_hour + '</span></div><div class="countdown__item"><span>%M</span><span>' + time_min + '</span></div><div class="countdown__item"><span>%S</span><span>' + text_sec + "</span></div>";
                    $this.html(event.strftime(strTime))
                }).on("finish.countdown", function() {
                    $this.html(wpbingo.strings.countdownFinish)
                }) : $(".product-quickview .countdown-quickview").remove()
            }
            if (parent_button.data("is_group_product"))
                if (parent_button.data("group_product")) {
                    var value = parent_button.data("group_product");
                    const group_handle = value.split(",");
                    $(".product-quickview .product-quickview__variants").remove(), $(".product-quickview .price-container").remove(), $("#form-simple-addtocart").remove(), html += '<form method="post" id="group_table_product" action="/cart/add"  enctype="multipart/form-data" novalidate="novalidate"><input type="hidden" name="form_type" value="product"><div class="group_table"></div><div class="product-group__add-to-cart product-single__buttons"><button type="submit" class="add-group-to-cart"><span>' + wpbingo.strings.add_to_cart + "</span></button></div></form>", $(".group-quickview").html(html);
                    var group = "";
                    for (const handle of group_handle) $.getJSON("/products/" + handle + ".js", function(product2) {
                        if (group += '<div data-product_id="' + product2.id + '" class="item-product-group">', group += '<div class="product-content">', group += '<div class="product-thumb">', group += '<a href="/product/' + product2.handle + '"><img class="featured-banner__img" src="' + product2.featured_image + '" alt="' + product2.featured_image.alt + '" /></a>', group += "</div>", group += '<div class="product-info">', group += '<h3 class="product-title"><a href="/product/' + product2.handle + '">' + product2.title + "</a></h3>", product2.variants.length > 1) {
                            group += '<select name="items[][id]" class="js-product-btp--' + product2.id + ' product-single__variants">';
                            for (var i = 0; i < product2.variants.length; i++) group += '<option data-price="' + product2.variants[i].price + '" value="' + product2.variants[i].id + '"> ' + product2.variants[i].title + " - " + wpbingo.Currency.formatMoney(product2.variants[i].price) + " </option>";
                            group += "</select>"
                        } else group += '<div class="product-price">' + wpbingo.Currency.formatMoney(product2.variants[0].price) + '</div><input name="items[][id]" type="hidden" value="' + product2.variants[0].id + '">';
                        group += "</div>", group += "</div>", group += '<div class="quantity-content">', group += '<button type="button" class="js-qty-adjust wpbingo-qty__adjust wpbingo-qty__adjust--minus"><i class="feather-minus"></i></button>', group += '<input type="text" name="items[][quantity]" class="js-qty-number wpbingo-qty__number" value="1" min="0" aria-label="quantity" pattern="[0-9]*">', group += '<button type="button" class="js-qty-adjust wpbingo-qty__adjust wpbingo-qty__adjust--plus"><i class="feather-plus"></i></button>', group += "</div>", group += "</div>", $(".group-quickview .group_table").html(group)
                    });
                    $("#group_table_product .add-group-to-cart").on("click", function(e) {
                        e.preventDefault(), $(this).removeClass("added"), $(this).addClass("active");
                        let addToCartForm = document.querySelector("#group_table_product");
                        var params = {
                            type: "POST",
                            url: "/cart/add.js",
                            data: new FormData(addToCartForm),
                            processData: !1,
                            contentType: !1,
                            dataType: "json",
                            success: function(line_item) {
                                $("#group_table_product .add-group-to-cart").removeClass("active"), $("#group_table_product .add-group-to-cart").addClass("added"), setTimeout(function() {
                                    $("#group_table_product .add-group-to-cart").removeClass("added")
                                }, 3e3), ajaxCart.load()
                            },
                            error: function(XMLHttpRequest2, textStatus) {
                                typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                            }
                        };
                        jQuery.ajax(params)
                    })
                } else $(".product-quickview .product-quickview__variants").remove(), $(".product-quickview .price-container").remove(), $("#form-simple-addtocart").remove(), html += '<div class="view-gruop-product"><a class="view-gruop-product-btn" href="' + product.url + '"><span>' + wpbingo.strings.view_group + "</span></a></div>", $(".group-quickview").html(html)
        },
        buildVariant: function(product) {
            var result = "",
                currentVariant = this.currentVariant;
            if (product.options[0].name !== "Title")
                for (var options = product.options, i = 0; i < options.length; i++) {
                    var option = options[i],
                        optionIndex = i + 1,
                        type = "label",
                        size = wpbingo.settings.size_option;
                    if (wpbingo.settings.filter_name_1 === option.name ? type = wpbingo.settings.select_filter_1 : wpbingo.settings.filter_name_2 === option.name ? type = wpbingo.settings.select_filter_2 : wpbingo.settings.filter_name_3 === option.name && (type = wpbingo.settings.select_filter_3), result += '<div class="variants-wrapper product-form__item ' + type + '" data-quickview-variant-option="' + optionIndex + '">', result += '<label class="variants__label">' + option.name + ": <span></span></label>", result += '<div class="variants__options">', wpbingo.settings.quickViewVariantType === "select") {
                        result += '<select class="js-quickview-option-selector product-form__input" data-id="quickViewOptionSelector-' + optionIndex + '" data-index="option' + optionIndex + '">';
                        for (var j = 0; j < option.values.length; j++) {
                            var value = option.values[j];
                            result += '<option value="' + _.escape(value) + '" ', result += currentVariant.options[i] === value ? 'selected="selected"' : "", result += ">" + value + "</option>"
                        }
                        result += "</select>"
                    } else if (wpbingo.settings.quickViewVariantType === "radio")
                        for (var j = 0; j < option.values.length; j++) {
                            for (var value = option.values[j], isDisable = !0, isVariantsImage = !1, colorAttribute = "", k = 0; k < this.productVariants.length; k++) {
                                var variantCondition = this.productVariants[k];
                                if (variantCondition.available) {
                                    if (i == 0 && variantCondition.option1 === value) {
                                        isDisable = !1;
                                        break
                                    } else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
                                        isDisable = !1;
                                        break
                                    } else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
                                        isDisable = !1;
                                        break
                                    }
                                }
                            }
                            for (var e = 0; e < product.media.length; e++) {
                                var media_arr = product.media[e],
                                    media_alt = media_arr.alt;
                                if (media_alt) var alt = media_alt.split("-");
                                if (alt && alt[1] == value) {
                                    isVariantsImage = !0;
                                    break
                                }
                            }
                            if (isVariantsImage)
                                for (var e = 0; e < product.media.length; e++) {
                                    var media_arr = product.media[e],
                                        media_alt = media_arr.alt;
                                    if (media_alt) var alt = media_alt.split("-");
                                    if (alt[1] == value) {
                                        var background = media_arr.src;
                                        result += '<div class="single-option-selector">', result += '<input type="radio" data-single-option-button', result += currentVariant.options[i] === value ? " checked " : " ", isDisable && (result += 'disabled="disabled"'), result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ', result += 'class="js-quickview-option-selector', isDisable && (result += " disabled"), result += '" id="quickview-product-option-' + i + "-" + value.toLowerCase() + '">', result += '<label class="' + value + '" data-toggle="tooltip" title="' + value + '" for="quickview-product-option-' + i + "-" + value.toLowerCase() + '" ' + colorAttribute, isDisable && (result += ' class="disabled"'), result += 'style="background:url(' + background + ');background-size: cover;background-position: center;">' + value + '<span class="d-none"></span></label>', result += "</div>";
                                        break
                                    }
                                } else result += '<div class="single-option-selector">', result += '<input type="radio" data-single-option-button', result += currentVariant.options[i] === value ? " checked " : " ", isDisable && (result += 'disabled="disabled"'), result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ', result += 'class="js-quickview-option-selector', isDisable && (result += " disabled"), result += '" id="quickview-product-option-' + i + "-" + value.toLowerCase() + '">', result += '<label class="' + value + '" data-toggle="tooltip" title="' + value + '" for="quickview-product-option-' + i + "-" + value.toLowerCase() + '" ' + colorAttribute, isDisable && (result += ' class="disabled"'), result += ">" + value + '<span class="d-none"></span></label>', result += "</div>"
                        }
                    result += "</div>", result += "</div>"
                }
            return result
        },
        createImageCarousel: function() {
            $(selectors2.quickView).find(selectors2.quickViewImages).slick({
                infinite: !1,
                rows: 0,
                fade: !0,
                rtl: wpbingo.rtl_slick()
            })
        },
        renderReview: function() {
            if (window.SPR && wpbingo.settings.enableReview && $(selectors2.quickView).find(selectors2.quickViewReview).length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
        },
        getCurrentOptions: function() {
            var currentOptions = _.map($(selectors2.quickviewVariant, selectors2.quickViewContainer), function(element) {
                var $element2 = $(element),
                    type = $element2.attr("type"),
                    currentOption = {};
                return type === "radio" || type === "checkbox" ? $element2[0].checked ? (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption) : !1 : (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption)
            });
            return currentOptions = _.compact(currentOptions), currentOptions
        },
        getVariantFromOptions: function() {
            var selectedValues = this.getCurrentOptions(),
                variants = this.productVariants,
                found = _.find(variants, function(variant) {
                    return selectedValues.every(function(values) {
                        return _.isEqual(variant[values.index], values.value)
                    })
                });
            return found
        },
        updateVariantsButton: function() {
            for (var selectedValues = this.getCurrentOptions(), variants = this.productVariants, i = 2; i <= 3; i++) $('[data-quickview-variant-option="' + i + '"]', selectors2.quickViewContainer).length && $('[data-quickview-variant-option="' + i + '"] ' + selectors2.quickviewVariant, selectors2.quickViewContainer).each(function() {
                var $self = $(this),
                    optionValue = $self.val(),
                    foundIndex;
                i === 2 ? foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), selectedValues[0].value = selectedValues[0].value.toString(), variant.option2 = variant.option2.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === !0
                }) : i === 3 && (foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), variant.option2 = variant.option2.toString(), variant.option3 = variant.option3.toString(), selectedValues[0].value = selectedValues[0].value.toString(), selectedValues[1].value = selectedValues[1].value.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value && variant.option3 === optionValue && variant.available === !0
                })), foundIndex !== -1 ? ($self.removeAttr("disabled", "disabled").removeClass("disabled"), $self.next("label").removeClass("disabled")) : ($self.attr("disabled", "disabled").addClass("disabled"), $self.next("label").addClass("disabled"))
            })
        },
        updateVariantsButtonDisabed: function() {
            for (var i = 2; i <= 3; i++)
                if ($('[data-quickview-variant-option="' + i + '"]', selectors2.quickViewContainer).length) {
                    var isUpdate = !1;
                    $('[data-quickview-variant-option="' + i + '"] ' + selectors2.quickviewVariant, selectors2.quickViewContainer).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if ((type === "radio" || type === "checkbox") && this.checked && $element2.hasClass("disabled")) return $element2.prop("checked", !1), isUpdate = !0, !1
                    }), $('[data-quickview-variant-option="' + i + '"] ' + selectors2.quickviewVariant, selectors2.quickViewContainer).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if (isUpdate && (type === "radio" || type === "checkbox") && !$element2.hasClass("disabled")) return $element2.prop("checked", !0), isUpdate = !1, $element2.trigger("change"), !1
                    })
                }
        },
        updateMasterSelect: function(variant) {
            variant && $(selectors2.originalSelectorId, selectors2.quickViewContainer).val(variant.id)
        },
        updateMedia: function(variant) {
            $(selectors2.quickViewImages, selectors2.quickView).on("init", function(event, slick) {
                variant && variant.featured_media && variant.featured_media.id && $(selectors2.quickViewImages, selectors2.quickViewContainer).find(".quickview-images__item").each(function() {
                    var imageID = $(this).data("media-id");
                    if (variant.featured_media.id == imageID) {
                        var slickIndex = $(this).closest(".slick-carousel__item").data("slick-index");
                        setTimeout(function() {
                            slickIndex != null && $(selectors2.quickViewImages, selectors2.quickViewContainer).slick("slickGoTo", slickIndex)
                        }, 100)
                    }
                })
            }), variant && variant.featured_media && variant.featured_media.id && $(selectors2.quickViewImages, selectors2.quickViewContainer).find(".quickview-images__item").each(function() {
                var imageID = $(this).data("media-id");
                if (variant.featured_media.id == imageID) {
                    var slickIndex = $(this).closest(".slick-carousel__item").data("slick-index");
                    slickIndex != null && $(selectors2.quickViewImages, selectors2.quickViewContainer).slick("slickGoTo", slickIndex)
                }
            })
        },
        updatePrice: function(variant) {
            var moneyFormat2 = wpbingo.strings.moneyFormat;
            variant ? ($(selectors2.quickViewProductPrice, selectors2.quickViewContainer).removeClass("d-none"), $(selectors2.quickViewProductPriceCompare, selectors2.quickViewContainer).removeClass("d-none"), $(selectors2.quickViewProductPrice, selectors2.quickViewContainer).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat2)), variant.compare_at_price > variant.price ? ($(selectors2.quickViewProductPriceCompare, selectors2.quickViewContainer).html(wpbingo.Currency.formatMoney(variant.compare_at_price, moneyFormat2)).removeClass("d-none"), $(selectors2.quickViewProductPrice, selectors2.quickViewContainer).addClass("on-sale")) : ($(selectors2.quickViewProductPriceCompare, selectors2.quickViewContainer).addClass("d-none"), $(selectors2.quickViewProductPrice, selectors2.quickViewContainer).removeClass("on-sale"))) : ($(selectors2.quickViewProductPrice, selectors2.quickViewContainer).addClass("d-none"), $(selectors2.quickViewProductPriceCompare, selectors2.quickViewContainer).addClass("d-none")), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        updateSKU: function(variant) {
            var sku = variant && variant.sku !== null && variant.sku !== "" ? variant.sku : "N/A";
            $(selectors2.quickViewSKU, selectors2.quickViewContainer).html(sku)
        },
        updateProductAvaiable: function(variant) {
            var classActive = "product-avaiable--active",
                translations = wpbingo.strings;
            $(selectors2.quickViewAvaiable, selectors2.quickViewContainer).removeClass(classActive), variant ? (variant.available ? ($(selectors2.quickViewQty, selectors2.quickViewContainer).removeClass("d-none"), $(selectors2.quickViewAvaiableInStock, selectors2.quickViewContainer).addClass(classActive)) : ($(selectors2.quickViewQty, selectors2.quickViewContainer).addClass("d-none"), $(selectors2.quickViewAvaiableOutStock, selectors2.quickViewContainer).addClass(classActive)), variant.available ? ($(selectors2.quickViewContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", !1), $(selectors2.quickViewContainer).find(".btn--add-to-cart .btn__text").html(translations.addToCart)) : ($(selectors2.quickViewContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0), $(selectors2.quickViewContainer).find(".btn--add-to-cart .btn__text").html(translations.soldOut))) : ($(selectors2.quickViewQty, selectors2.quickViewContainer).addClass("d-none"), $(selectors2.quickViewContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0), $(selectors2.quickViewContainer).find(".btn--add-to-cart .btn__text").html(translations.unavailable))
        },
        updateDetailsLink: function(variant) {
            if (variant) {
                var productURL = $(selectors2.quickViewProductDetailsURL, selectors2.quickViewContainer).data("url") + "?variant=" + variant.id;
                $(selectors2.quickViewProductDetailsURL, selectors2.quickViewContainer).removeClass("d-none").attr("href", productURL)
            } else $(selectors2.quickViewProductDetailsURL, selectors2.quickViewContainer).addClass("d-none")
        },
        onVariantChange: function() {
            var variant = this.getVariantFromOptions();
            if ($("[data-single-option-button]", selectors2.quickViewContainer).length && (this.updateVariantsButton(), !variant || !variant.available)) {
                this.updateVariantsButtonDisabed();
                return
            }
            var $element2 = $(".quickview .product-quickview__variants .variants-wrapper");
            $($element2).each(function() {
                var $this = $(this);
                if ($("select", $this).length > 0) var value = $("select", $this).find(":selected").val();
                else var value = $("input:checked", $this).attr("value");
                $(".variants__label span", $this).html(value)
            }), this.updateMasterSelect(variant), this.updateMedia(variant), this.updatePrice(variant), this.updateSKU(variant), this.updateProductAvaiable(variant), this.updateDetailsLink(variant), this.currentVariant = variant
        }
    }), QuickView
}(), typeof ShopifyAPI > "u" && (ShopifyAPI = {}), ShopifyAPI.attributeToString = function(attribute) {
    return typeof attribute != "string" && (attribute += "", attribute === "undefined" && (attribute = "")), jQuery.trim(attribute)
}, ShopifyAPI.updateCartNote = function(note, callback) {
    var params = {
        type: "POST",
        url: "/cart/update.js",
        data: "note=" + ShopifyAPI.attributeToString(note),
        dataType: "json",
        success: function(cart) {
            typeof callback == "function" && callback(cart)
        },
        error: function(XMLHttpRequest2, textStatus) {
            ShopifyAPI.onError(XMLHttpRequest2, textStatus)
        }
    };
    jQuery.ajax(params)
}, ShopifyAPI.onError = function(XMLHttpRequest) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    data.message && alert(data.message + "(" + data.status + "): " + data.description)
}, ShopifyAPI.addItemFromForm = function(form, callback, errorCallback2) {
    var formData = new FormData(form),
        params = {
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            processData: !1,
            contentType: !1,
            dataType: "json",
            success: function(line_item) {
                typeof callback == "function" ? (callback(line_item, form), $(".product-single .content-variant_inventory").length > 0 && setTimeout(function() {
                    $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable")
                }, 100)) : (ShopifyAPI.onItemAdded(line_item, form), $(".product-single .content-variant_inventory").length > 0 && setTimeout(function() {
                    $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable")
                }, 100))
            },
            error: function(XMLHttpRequest2, textStatus) {
                typeof errorCallback2 == "function" ? errorCallback2(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
            }
        };
    jQuery.ajax(params)
}, ShopifyAPI.getCart = function(callback, added) {
    jQuery.getJSON("/cart.js", function(cart) {
        typeof callback == "function" && callback(cart, added)
    })
}, ShopifyAPI.changeItem = function(line, quantity, callback, modal) {
    var params = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + quantity + "&line=" + line,
        dataType: "json",
        success: function(cart) {
            if (typeof callback == "function" && callback(cart), modal) {
                var moneyFormat2 = "${{amount}}";
                wpbingo.strings.moneyFormat !== void 0 && (moneyFormat2 = wpbingo.strings.moneyFormat);
                var id = $("#form-modal-addtocart input[data-modal-variant]").val();
                for (var j in cart.items)
                    if (id == cart.items[j].variant_id) var price = cart.items[j].final_line_price,
                        price_discount = cart.items[j].original_line_price;
                if ($("#form-modal-addtocart .modalcart__line_price .price").html(wpbingo.Currency.formatMoney(price, moneyFormat2)), cart.items[j].discounts.length > 0) {
                    $("#form-modal-addtocart .modalcart__line_price .price_discount").html(wpbingo.Currency.formatMoney(price_discount, moneyFormat2));
                    for (var i in cart.items[j].discounts) $(".js-cart-modal .discount").text(cart.items[j].discounts[i].title)
                } else $("#form-modal-addtocart .modalcart__line_price .price_discount").empty(), $(".js-cart-modal .discount").empty();
                $("#form-modal-addtocart .cart-modal__middle").removeClass("load_modal")
            }
        },
        error: function(XMLHttpRequest2, textStatus) {
            ShopifyAPI.onError(XMLHttpRequest2, textStatus)
        }
    };
    jQuery.ajax(params)
};
var ajaxCart = function(module, $) {
    "use strict";
    var init, loadCart, settings, isUpdating, $body, $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, initializeEvents, updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartModalAdded, cartModalupdate, updateModalRecommendations, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;
    return init = function(options) {
        settings = {
            formSelector: "[data-product-form]",
            cartContainer: "[data-cart-container]",
            addToCartSelector: 'button[type="submit"]',
            cartCountSelector: "[data-cart-count]",
            cartCostSelector: "[data-cart-cost]",
            cartRemoveSelector: "[data-cart-remove]",
            headerCartSelector: ".js-header-cart",
            cartModalSelector: ".js-cart-modal",
            cartModalCloseSelector: ".js-cart-modal-close",
            moneyFormat: "${{amount}}",
            disableAjaxCart: !1,
            cartTemplate: "#ajaxcart-template",
            cartModalHeaderTemplate: "#ajaxcart-header-template"
        }, wpbingo.strings.moneyFormat !== void 0 && (settings.moneyFormat = wpbingo.strings.moneyFormat), $.extend(settings, options), $formContainer = $(settings.formSelector), $cartContainer = $(settings.cartContainer), $addToCart = $formContainer.find(settings.addToCartSelector), $cartCountSelector = $(settings.cartCountSelector), $cartCostSelector = $(settings.cartCostSelector), $body = $("body"), isUpdating = !1, initializeEvents(), !settings.disableAjaxCart && $addToCart.length && formOverride(), adjustCart()
    }, initializeEvents = function() {
        $body.on("click", settings.cartModalCloseSelector, function() {
            $(".js-cart-modal .cart-modal__inner").removeClass("show"), setTimeout(function() {
                $(settings.cartModalSelector).fadeOut(400, function() {
                    $(this).remove()
                })
            }, 400)
        }), $body.on("click", settings.headerCartSelector, function(e) {
            if (wpbingo.settings.cartType == "modal" && $(window).width() > 767 && !$("body").hasClass("template-cart")) {
                e.preventDefault();
                return
            }
        }), $body.on("click", settings.cartRemoveSelector, function(e) {
            if (!isUpdating) {
                var $el = $(this),
                    line = $el.data("line");
                line && ($('.ajaxcart__product[data-line="' + line + '"]').addClass("is-loading"), isUpdating = !0, setTimeout(function() {
                    ShopifyAPI.changeItem(line, 0, adjustCartCallback)
                }, 250)), wpbingo.discount_single()
            }
        }), $body.on("change", ".ajaxcart__note-input", function() {
            var newNote = $(this).val();
            $(".ajaxcart__info .save-ajaxcart__note").on("click", function() {
                ShopifyAPI.updateCartNote(newNote, function() {})
            })
        }), $body.on("change", ".discount_code_input", function() {
            var newDiscount = $(this).val();
            $(".ajaxcart__info .save-discount_code_input").on("click", function() {
                wpbingo.setCookie("wpbingo_discount", newDiscount, 1)
            })
        })
    }, loadCart = function() {
        ($(".js-drawer").length > 0 || $("[data-cart-container]").length > 0) && $body.addClass("ajaxcart--is-loading"), ShopifyAPI.getCart(cartUpdateCallback)
    }, updateCountPrice = function(cart) {
        $("[data-cart-count]") && $("[data-cart-count]").html(cart.item_count), ($(".js-drawer").length > 0 || $("[data-cart-container]").length > 0) && ($cartCostSelector && $cartCostSelector.html(wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat)), $(".cart-modal-totalprice span").html(wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat)), $(".cart-modal-totalcount span.count").html(cart.item_count))
    }, formOverride = function() {
        $body.on("submit", settings.formSelector, function(evt) {
            evt.preventDefault(), $(".btn--add-to-cart", $(this)).attr("disabled", "disabled").prepend('<span class="spinner-border spinner-border-sm"></span>'), $(".btn--add-to-cart", $(this)).removeClass("is-added").addClass("is-adding"), $(".ajaxcart-toast").toast("hide"), ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback)
        })
    }, itemAddedCallback = function(lineItem) {
        $("form .btn--add-to-cart").removeAttr("disabled").find(".spinner-border").remove(), $("form .btn--add-to-cart").removeClass("is-adding").addClass("is-added"), wpbingo.settings.cartType == "modal" && cartModalAdded(lineItem), ShopifyAPI.getCart(cartUpdateCallback, !0), wpbingo.discount_single()
    }, itemErrorCallback = function(XMLHttpRequest) {
        var data = eval("(" + XMLHttpRequest.responseText + ")");
        if ($addToCart.removeAttr("disabled").find(".spinner-border").remove(), $addToCart.removeClass("is-adding is-added"), data.message && data.status === 422) {
            var $toast = $(".ajaxcart-toast");
            $toast.find(".toast-body").html(data.description), $toast.toast("show")
        }
    }, cartModalAdded = function(lineItem) {
        var data2 = {},
            image = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif",
            source = $(settings.cartModalHeaderTemplate).html(),
            template = Handlebars.compile(source);
        lineItem.image != null && (image = lineItem.image), updateModalRecommendations(lineItem);
        var count = $('#count_quantity [data-variant_id="' + lineItem.variant_id + '"]').data("count_quantity"),
            disabled = "";
        if (lineItem.quantity == count && (disabled = "disabled"), data2 = {
                name: lineItem.product_title,
                image,
                discount: lineItem.discounts,
                variant_id: lineItem.variant_id,
                variant: lineItem.variant_title,
                options: lineItem.options_with_values,
                price_discount: wpbingo.Currency.formatMoney(lineItem.original_line_price, settings.moneyFormat),
                final_line_price: wpbingo.Currency.formatMoney(lineItem.final_line_price, settings.moneyFormat),
                final_price: wpbingo.Currency.formatMoney(lineItem.final_price, settings.moneyFormat),
                quantity: lineItem.quantity,
                disabled
            }, $body.append(template(data2)), data2.variant != null)
            for (var j in data2.options) $(".js-cart-modal .variant").append("<span>" + data2.options[j].name + " : " + data2.options[j].value + "</span>");
        if (data2.discount.length > 0) {
            for (var j in data2.discount) $(".js-cart-modal .discount").text(data2.discount[j].title);
            $("#form-modal-addtocart .modalcart__line_price .price_discount").html(wpbingo.Currency.formatMoney(lineItem.original_line_price, settings.moneyFormat))
        } else $(".js-cart-modal .discount").empty(), $("#form-modal-addtocart .modalcart__line_price .price_discount").empty();
        $(".js-cart-modal").fadeIn(400), setTimeout(function() {
            $(".js-cart-modal .cart-modal__inner").addClass("show")
        }, 400)
    }, cartModalupdate = function(cart) {
        $("#form-modal-addtocart .modalcart__quantity input").change(function() {
            $("#form-modal-addtocart .cart-modal__middle").addClass("load_modal");
            var id = $("#form-modal-addtocart input[data-modal-variant]").val(),
                qty = $("#form-modal-addtocart .modalcart__quantity input").val(),
                modal = !0,
                count = $('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity");
            if (qty >= count) {
                var qty = count;
                $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust.wpbingo-qty__adjust--plus").prop("disabled", !0)
            } else $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust.wpbingo-qty__adjust--plus").prop("disabled", !1);
            $("#form-modal-addtocart .modalcart__quantity input").val(qty);
            for (var j in cart.items)
                if (id == cart.items[j].variant_id) var line = parseInt(j) + 1;
            ShopifyAPI.changeItem(line, qty, adjustCartCallback, modal)
        }), $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust").on("click", function() {
            $("#form-modal-addtocart .cart-modal__middle").addClass("load_modal");
            var id = $("#form-modal-addtocart input[data-modal-variant]").val(),
                modal = !0;
            for (var j in cart.items)
                if (id == cart.items[j].variant_id) var line = parseInt(j) + 1,
                    lineItem = cart.items[j];
            setTimeout(function() {
                var qty = $("#form-modal-addtocart .modalcart__quantity input").val(),
                    count = $('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity");
                if (qty >= count) {
                    var qty = count;
                    $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust.wpbingo-qty__adjust--plus").prop("disabled", !0)
                } else $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust.wpbingo-qty__adjust--plus").prop("disabled", !1);
                $("#form-modal-addtocart .modalcart__quantity input").val(qty), qty == 1 ? $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust.wpbingo-qty__adjust--minus").prop("disabled", !0) : $("#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust.wpbingo-qty__adjust--minus").prop("disabled", !1), ShopifyAPI.changeItem(line, qty, adjustCartCallback, modal)
            }, 500)
        })
    }, updateModalRecommendations = function(lineItem) {
        var baseUrl = routes.product_recommendations_url,
            productId = lineItem.product_id,
            recommendationsSectionUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=6";
        $.get(recommendationsSectionUrl).then(function(section) {
            var recommendationsMarkup = $(section).html();
            $(".cart-modal-recommendations").html(recommendationsMarkup);
            var $element2 = $(".js-product-recommendations", $(".cart-modal-recommendations"));
            wpbingo.elementslickCarousel($element2), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        })
    }, cartUpdateCallback = function(cart, added) {
        updateCountPrice(cart), ($(".js-drawer").length > 0 || $("[data-cart-container]").length > 0) && (buildCart(cart, fire_work), cartModalupdate(cart), added && $body.trigger("drawer.open"))
    }, buildCart = function(cart) {
        if ($cartContainer.empty(), cart.item_count === 0) {
            $cartContainer.append('<p class="cart-empty-message">' + wpbingo.strings.cartEmpty + `</p>
<p class="cookie-message">` + wpbingo.strings.cartCookies + "</p>"), cartCallback(cart), $(".js-drawer .drawer__title .count").text("0"), $(".shipping-bar-cart").addClass("hidden");
            return
        }
        var items = [],
            item = {},
            data2 = {},
            source = $(settings.cartTemplate).html(),
            template = Handlebars.compile(source);
        $.each(cart.items, function(index, cartItem) {
            var prodImg2, unitPrice = null,
                disabled = "",
                variant_id = cartItem.variant_id,
                count = $('#count_quantity [data-variant_id="' + variant_id + '"]').data("count_quantity");
            if (cartItem.quantity == count && (disabled = "disabled"), cartItem.image !== null ? prodImg2 = cartItem.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") : prodImg2 = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif", cartItem.properties !== null && $.each(cartItem.properties, function(key, value) {
                    (key.charAt(0) === "_" || !value) && delete cartItem.properties[key]
                }), cartItem.properties !== null && $.each(cartItem.properties, function(key, value) {
                    (key.charAt(0) === "_" || !value) && delete cartItem.properties[key]
                }), cartItem.line_level_discount_allocations.length !== 0)
                for (var discount in cartItem.line_level_discount_allocations) {
                    var amount = cartItem.line_level_discount_allocations[discount].amount;
                    cartItem.line_level_discount_allocations[discount].formattedAmount = wpbingo.Currency.formatMoney(amount, settings.moneyFormat)
                }
            if (cart.cart_level_discount_applications.length !== 0)
                for (var cartDiscount in cart.cart_level_discount_applications) {
                    var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
                    cart.cart_level_discount_applications[cartDiscount].formattedAmount = wpbingo.Currency.formatMoney(cartAmount, settings.moneyFormat)
                }
            cartItem.unit_price_measurement && (unitPrice = {
                addRefererenceValue: cartItem.unit_price_measurement.reference_value !== 1,
                price: wpbingo.Currency.formatMoney(cartItem.unit_price, settings.moneyFormat),
                reference_value: cartItem.unit_price_measurement.reference_value,
                reference_unit: cartItem.unit_price_measurement.reference_unit
            }), item = {
                key: cartItem.key,
                line: index + 1,
                url: cartItem.url,
                img: prodImg2,
                name: cartItem.product_title,
                variation: cartItem.variant_title !== null,
                variant: cartItem.variant,
                options: cartItem.options_with_values,
                variant_id: cartItem.variant_id,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                handle: cartItem.handle,
                price: wpbingo.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discountedPrice: wpbingo.Currency.formatMoney(cartItem.final_line_price, settings.moneyFormat),
                discounts: cartItem.line_level_discount_allocations,
                discountsApplied: cartItem.line_level_discount_allocations.length !== 0,
                vendor: cartItem.vendor,
                unitPrice,
                disabled
            }, items.push(item), wpbingo.discount_single()
        }), data2 = {
            items,
            note: cart.note,
            totalPrice: wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat),
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length !== 0
        }, $cartContainer.append(template(data2)), cartCallback(cart), data2.note && $(".cart-table .cart-note__input textarea").val(data2.note);
        var discount_code = wpbingo.getCookie("wpbingo_discount");
        if (discount_code && ($(".cart-table .discount_code_input").val(discount_code), $(".js-drawer .discount_code_input").val(discount_code)), $(".js-drawer .drawer__title .count").text(cart.item_count), $(".shipping-bar-cart").removeClass("hidden"), $(".shipping-bar-cart").length) {
            var price_shipping_bar = $(".shipping-bar-cart").data("price_shipping_bar");
            if (price_shipping_bar > cart.total_price && price_shipping_bar != 0) {
                var minus_spend = price_shipping_bar - cart.total_price,
                    spend = wpbingo.Currency.formatMoney(minus_spend, settings.moneyFormat),
                    percent = cart.total_price / price_shipping_bar * 100;
                $(".shipping-bar-cart .title-spend .spend").html(spend), $(".shipping-bar-cart .shipping-progress").css("width", percent + "%"), $(".shipping-bar-cart .title-shipping").addClass("hide"), $(".shipping-bar-cart .title-spend").removeClass("hide"), $(".shipping-bar-cart").removeClass("full"), $("[data-cart-container]").removeClass("fire-done"), $("#fire_work").addClass("hide")
            } else $(".shipping-bar-cart .title-shipping").removeClass("hide"), $(".shipping-bar-cart .title-spend").addClass("hide"), $(".shipping-bar-cart .shipping-progress").css("width", "100%"), $(".shipping-bar-cart").addClass("full"), $("[data-cart-container]").hasClass("fire-done") || $("[data-cart-container]").addClass("fire"), $("[data-cart-container]").hasClass("fire") && ($("#fire_work").removeClass("hide"), confettiLoop()), setTimeout(function() {
                $("[data-cart-container]").addClass("fire-done"), $("[data-cart-container]").removeClass("fire")
            }, 1e3), setTimeout(function() {
                $("#fire_work").addClass("hide")
            }, 5e3)
        }
        $(".pre_order-cart >span").each(function() {
            var id = $(this).data("handle");
            for (var i in data2.items) data2.items[i].variant_id == id && $('.ajaxcart__product[data-line="' + data2.items[i].line + '"] .pre_order').removeClass("hide")
        }), wpbingo.checkbox_terms_conditions(), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
    }, cartCallback = function(cart) {
        $body.removeClass("ajaxcart--is-loading"), window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize(), $body.trigger("drawer.footer")
    }, adjustCart = function() {
        $body.on("click", ".ajaxcart__qty-adjust", function() {
            if (!isUpdating) {
                var $el = $(this),
                    line = $el.data("line"),
                    $qtySelector = $el.siblings(".ajaxcart__qty-num"),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ""));
                qty = validateQty(qty), $el.hasClass("ajaxcart__qty--plus") ? qty += 1 : (qty -= 1, qty <= 0 && (qty = 0)), line ? updateQuantity(line, qty) : $qtySelector.val(qty)
            }
        }), $body.on("change", ".ajaxcart__qty-num", function() {
            var id = $(this).data("variant_id"),
                count = $('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity");
            if (!isUpdating) {
                var $el = $(this),
                    line = $el.data("line"),
                    qty = parseInt($el.val().replace(/\D/g, ""));
                qty = validateQty(qty), qty >= count && (qty = count, $el.val(qty)), line && updateQuantity(line, qty)
            }
        }), $body.on("submit", "form.ajaxcart", function(evt) {
            isUpdating && evt.preventDefault()
        }), $body.on("focus", ".ajaxcart__qty-adjust", function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select()
            }, 50)
        });

        function updateQuantity(line, qty) {
            isUpdating = !0;
            var $row = $('.ajaxcart__product[data-line="' + line + '"]').addClass("is-loading");
            qty === 0 && $row.parent().addClass("is-removed"), setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback)
            }, 250)
        }
    }, adjustCartCallback = function(cart) {
        updateCountPrice(cart), setTimeout(function() {
            ShopifyAPI.getCart(buildCart), isUpdating = !1
        }, 150)
    }, validateQty = function(qty) {
        return parseFloat(qty) === parseInt(qty) && !isNaN(qty) || (qty = 1), qty
    }, module = {
        init,
        load: loadCart
    }, module
}(ajaxCart || {}, jQuery);
wpbingo.drawerCart = function(module2) {
    var $body2, $drawer, drawerCloseSelector, headerCartSelector, drawerIsOpen, init2, drawerOpen, drawerClose, drawerFooter, classes = {
        open: "drawer--open"
    };
    return init2 = function() {
        $body2 = $("body"), $drawer = $(".js-drawer"), drawerCloseSelector = ".js-drawer-close", headerCartSelector = ".js-header-cart", drawerIsOpen = !1, $body2.on("drawer.open", function(evt) {
            drawerOpen(evt)
        }), $body2.on("drawer.close", function(evt) {
            drawerClose(evt)
        }), $body2.on("drawer.footer", function() {
            drawerFooter()
        }), $body2.on("click", headerCartSelector, function(evt) {
            $("body").hasClass("template-cart") || (evt.preventDefault(), $body2.trigger("drawer.open", evt))
        }), $body2.on("click", drawerCloseSelector, function(evt) {
            evt.preventDefault(), $body2.trigger("drawer.close", evt)
        })
    }, drawerOpen = function(evt) {
        if (drawerIsOpen) {
            evt && evt.preventDefault();
            return
        }
        evt && evt.preventDefault(), $body2.addClass(classes.open), drawerIsOpen = !0
    }, drawerClose = function(evt) {
        drawerIsOpen && (evt.keyCode !== 27 && evt.preventDefault(), $body2.removeClass(classes.open), drawerIsOpen = !1)
    }, drawerFooter = function() {
        if ($drawer.hasClass("drawer--has-fixed-footer")) {
            var $cartFooter = $(".ajaxcart__footer").removeAttr("style"),
                $cartInner = $(".ajaxcart__inner").removeAttr("style"),
                cartFooterHeight = $cartFooter.outerHeight();
            $cartInner.css("bottom", cartFooterHeight), $cartFooter.css("height", cartFooterHeight), $(".ajaxcart__info .button_note").on("click", function() {
                $(".ajaxcart__info .ajaxcart__note").hasClass("active") ? $(".ajaxcart__info .ajaxcart__note").removeClass("active") : $(".ajaxcart__info .ajaxcart__note").addClass("active")
            }), $(".ajaxcart__info .button_discount").on("click", function() {
                $(".ajaxcart__info .discount_code").hasClass("active") ? $(".ajaxcart__info .discount_code").removeClass("active") : $(".ajaxcart__info .discount_code").addClass("active")
            }), $(".ajaxcart__info .button_shiping").on("click", function() {
                $(".drawer__inner #shipping-calculator").hasClass("active") ? $(".drawer__inner #shipping-calculator").removeClass("active") : $(".drawer__inner #shipping-calculator").addClass("active")
            }), $(".ajaxcart__info .close-ajaxcart__info").on("click", function() {
                $(".ajaxcart__info .ajaxcart__info_content >div").hasClass("active") && $(".ajaxcart__info .ajaxcart__info_content >div").removeClass("active")
            }), $(".ajaxcart__info .save").on("click", function() {
                $(".ajaxcart__info .ajaxcart__info_content >div").hasClass("active") && $(".ajaxcart__info .ajaxcart__info_content >div").removeClass("active")
            }), $(".drawer__inner #shipping-calculator .close-ajaxcart__info").on("click", function() {
                $(".drawer__inner #shipping-calculator").hasClass("active") && $(".drawer__inner #shipping-calculator").removeClass("active")
            }), Shopify.Cart.ShippingCalculator.show({
                submitButton: window.strings.shippingCalcSubmitButton,
                submitButtonDisabled: window.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: window.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: window.strings.shippingCalcMoneyFormat,
                CalculateMessSuccess: window.strings.CalculateMessSuccess,
                CalculateMessPrice: window.strings.CalculateMessPrice,
                CalculateMessError: window.strings.CalculateMessError
            })
        }
    }, module2 = {
        init: init2
    }, module2
}(), wpbingo.variables = {
    productPageLoad: !1,
    productPageSticky: !0,
    mediaTablet: "screen and (max-width: 1024px)",
    mediaMobile: "screen and (max-width: 767px)",
    isTablet: !1,
    isMobile: !1
}, wpbingo.initializeEvents = function() {
    var $body2 = $("body"),
        passwordToggle = ".js-password-toggle",
        tooltip = '[data-toggle="tooltip"]',
        scrollToTop = ".js-scroll-to-top",
        collectionSidebarToggle = ".js-sidebar-toggle",
        classes = {
            passwordShow: "password-toggle--show"
        };
    $(tooltip).tooltip(), $body2.on("click", passwordToggle, function(e) {
        e.preventDefault();
        var $this = $(this),
            $passwordField = $this.siblings(".form-control"),
            isShow = !!$this.hasClass(classes.passwordShow);
        isShow ? ($this.removeClass(classes.passwordShow), $passwordField.attr("type", "password")) : ($this.addClass(classes.passwordShow), $passwordField.attr("type", "text"))
    }), $body2.on("click", scrollToTop, function(e) {
        e.preventDefault(), $("body, html").stop().animate({
            scrollTop: 0
        }, "500")
    }), $body2.on("click", collectionSidebarToggle, function(evt) {
        evt.preventDefault(), $body2.toggleClass("collection-sidebar--open")
    }), $(window).scroll(function() {
        $(window).scrollTop() >= 200 ? $(scrollToTop).fadeIn() : $(scrollToTop).fadeOut()
    }), $(scrollToTop).hide()
}, wpbingo.setBreakpoints = function() {
    enquire.register(wpbingo.variables.mediaTablet, {
        match: function() {
            wpbingo.variables.isTablet = !0
        },
        unmatch: function() {
            wpbingo.variables.isTablet = !1
        }
    }), enquire.register(wpbingo.variables.mediaMobile, {
        match: function() {
            wpbingo.variables.isMobile = !0
        },
        unmatch: function() {
            wpbingo.variables.isMobile = !1
        }
    })
}, wpbingo.updateSlickSwipe = function(element, allowSwipe) {
    if (element.hasClass("slick-initialized")) {
        var slickOptions = {
            accessibility: allowSwipe,
            draggable: allowSwipe,
            swipe: allowSwipe,
            touchMove: allowSwipe
        };
        element.slick("slickSetOption", slickOptions, !1)
    }
}, wpbingo.showLoading = function() {
    $("body").append(wpbingo.loading != null && wpbingo.loading != "" ? wpbingo.loading : "")
}, wpbingo.hideLoading = function() {
    $(".wpbingo-loading").remove()
}, wpbingo.cartInit = function() {
    var $body2 = $("body");
    wpbingo.cookiesEnabled() || $body2.addClass("cart--no-cookies"), (wpbingo.settings.cartType == "modal" || wpbingo.settings.cartType == "drawer") && (ajaxCart.init(), ajaxCart.load(), wpbingo.settings.cartType == "drawer" && wpbingo.drawerCart.init())
}, wpbingo.cookiesEnabled = function() {
    var cookieEnabled = navigator.cookieEnabled;
    return cookieEnabled || (document.cookie = "webcookie", cookieEnabled = document.cookie.indexOf("webcookie") !== -1), cookieEnabled
}, wpbingo.setCookie = function(cname, cvalue, exdays) {
    var d = new Date;
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
}, wpbingo.getCookie = function(cname) {
    for (var name = cname + "=", decodedCookie = decodeURIComponent(document.cookie), cookieArray = decodedCookie.split(";"), i = 0; i < cookieArray.length; i++) {
        for (var cookieItem = cookieArray[i]; cookieItem.charAt(0) === " ";) cookieItem = cookieItem.substring(1);
        if (cookieItem.indexOf(name) === 0) return cookieItem.substring(name.length, cookieItem.length)
    }
    return ""
}, wpbingo.cookieConsent = function() {
    var cConsent = wpbingo.getCookie("cookie_consent"),
        cConsentSelector = $(".cookie-consent"),
        cConsentDismiss = ".cookie-consent-dismiss";
    cConsentAgree = ".cookie-consent-agree", cConsent == "true" || cConsent == "false" ? cConsentSelector.remove() : (setTimeout(function() {
        cConsentSelector.addClass("active")
    }, 1500), cConsent == "" && wpbingo.setCookie("cookie_consent", "", 10)), $("body").on("click", cConsentDismiss, function(e) {
        e.preventDefault(), cConsentSelector.remove(), wpbingo.setCookie("cookie_consent", !1, 10)
    }), $("body").on("click", cConsentAgree, function(e) {
        e.preventDefault(), cConsentSelector.remove(), wpbingo.setCookie("cookie_consent", !0, 10)
    })
}, wpbingo.slideshow = function() {
    var slideshow = ".js-wpbingo-slideshow",
        fade = $(slideshow).data("fade"),
        autoplay = $(slideshow).data("autoplay"),
        autoplayInterval = $(slideshow).data("autoplayinterval"),
        autoplayNavigation = $(slideshow).data("navigation"),
        autoplayPagination = $(slideshow).data("pagination"),
        config = {
            fade: !0,
            rows: 0,
            arrows: autoplayNavigation,
            autoplay,
            rtl: wpbingo.rtl_slick(),
            autoplaySpeed: autoplayInterval
        };
    fade === void 0 || fade == null || (config.fade = fade), autoplayInterval === void 0 || autoplayInterval == null || (config.autoplaySpeed = autoplayInterval), autoplayPagination === void 0 || autoplayPagination == null || autoplayPagination != !0 ? config.dots = !1 : config.dots = !0, $(slideshow).slick(config)
}, wpbingo.rtl_slick = function() {
    return !!$("body").hasClass("rtl")
}, wpbingo.slickCarousel = function() {
    var bwpCarousel = ".js-carousel";
    $(bwpCarousel).each(function() {
        var $element2 = $(this),
            nav = $element2.data("nav"),
            dots = $element2.data("dots"),
            draggable = !$element2.data("draggable"),
            fade = !!$element2.data("fade"),
            center = $element2.data("center"),
            infinite = $element2.data("infinite"),
            autoplay = $element2.data("autoplay"),
            autoplaySpeed = $element2.data("autoplayspeed"),
            slidesToScroll = $element2.data("slidestoscroll") ? $element2.data("columns") : 1,
            columns = $element2.data("columns"),
            column1440 = $element2.data("column1440"),
            column1 = $element2.data("column1"),
            column2 = $element2.data("column2"),
            column3 = $element2.data("column3"),
            column4 = $element2.data("column4"),
            asNavFor = $element2.data("asnavfor") ? $element2.data("asnavfor") : !1,
            rows = $element2.data("rows"),
            config = {
                rtl: wpbingo.rtl_slick(),
                draggable,
                fade,
                asNavFor,
                arrows: nav,
                slidesToShow: columns,
                slidesToScroll,
                responsive: [{
                    breakpoint: 1441,
                    settings: {
                        slidesToShow: column1440,
                        slidesToScroll: column1440
                    }
                }, {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: column1,
                        slidesToScroll: column1
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: column2,
                        slidesToScroll: column2
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: column3,
                        slidesToScroll: column3,
                        vertical: !1,
                        verticalSwiping: !1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: column4,
                        slidesToScroll: column4,
                        vertical: !1,
                        verticalSwiping: !1
                    }
                }]
            };
        if (center === void 0 || center == null || center != !0 ? config.centerMode = !1 : config.centerMode = !0, dots === void 0 || dots == null || dots != !0 ? config.dots = !1 : config.dots = !0, infinite === void 0 || infinite == null || infinite != !0 ? config.infinite = !1 : config.infinite = !0, autoplay && (config.autoplay = autoplay, config.autoplaySpeed = autoplaySpeed), rows !== void 0 && rows != null && rows != 1 ? (config.rows = rows, config.slidesPerRow = columnone, config.slidesToShow = 1, config.responsive = [{
                breakpoint: 1025,
                settings: {
                    slidesPerRow: columntwo,
                    slidesToShow: 1
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesPerRow: columnthree,
                    slidesToShow: 1
                }
            }]) : config.rows = 0, $element2.slick(config), $(".slick-arrow", $element2).length > 0) {
            var $prev = $(".slick-prev", $element2).clone();
            $(".slick-prev", $element2).remove(), $element2.parent().find(".slick-prev").length == 0 && $prev.prependTo($element2.parent()), $prev.on("click", function() {
                $element2.slick("slickPrev")
            });
            var $next = $(".slick-next", $element2).clone();
            $(".slick-next", $element2).remove(), $element2.parent().find(".slick-next").length == 0 && $next.appendTo($element2.parent()), $next.on("click", function() {
                $element2.slick("slickNext")
            })
        }
    }), $(".product-tabs__nav-link").on("shown.bs.tab", function() {
        var productTabs = $(this).closest(".product-tabs");
        productTabs.find(bwpCarousel).length > 0 && productTabs.find(bwpCarousel).slick("setPosition")
    })
}, wpbingo.elementslickCarousel = function($element2) {
    var nav = $element2.data("nav"),
        infinite = $element2.data("infinite"),
        columns = $element2.data("columns") ? $element2.data("columns") : 1,
        column1440 = $element2.data("column1440"),
        column1 = $element2.data("column1"),
        column2 = $element2.data("column2"),
        column3 = $element2.data("column3"),
        column4 = $element2.data("column4"),
        rows = $element2.data("rows"),
        config = {
            arrows: nav,
            slidesToShow: columns,
            slidesToScroll: columns,
            rtl: wpbingo.rtl_slick(),
            responsive: [{
                breakpoint: 1441,
                settings: {
                    slidesToShow: column1440,
                    slidesToScroll: column1440
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: column1,
                    slidesToScroll: column1
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: column2,
                    slidesToScroll: column2
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: column3,
                    slidesToScroll: column3,
                    vertical: !1,
                    verticalSwiping: !1
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: column4,
                    slidesToScroll: column4,
                    vertical: !1,
                    verticalSwiping: !1
                }
            }]
        };
    if (rows !== void 0 && rows != null && rows != 1 ? (config.rows = rows, config.slidesPerRow = columnone, config.slidesToShow = 1, config.responsive = [{
            breakpoint: 1025,
            settings: {
                slidesPerRow: columntwo,
                slidesToShow: 1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesPerRow: columnthree,
                slidesToShow: 1
            }
        }]) : config.rows = 0, $element2.slick(config), $(".slick-arrow", $element2).length > 0) {
        var $prev = $(".slick-prev", $element2).clone();
        $(".slick-prev", $element2).remove(), $element2.parent().find(".slick-prev").length == 0 && $prev.prependTo($element2.parent()), $prev.on("click", function() {
            $element2.slick("slickPrev")
        });
        var $next = $(".slick-next", $element2).clone();
        $(".slick-next", $element2).remove(), $element2.parent().find(".slick-next").length == 0 && $next.appendTo($element2.parent()), $next.on("click", function() {
            $element2.slick("slickNext")
        })
    }
}, wpbingo.countdown = function($class) {
    var countdown = "[data-countdown]";
    $(countdown).each(function() {
        var $this = $(this),
            finalDate = $(this).data("countdown"),
            date_final = new Date(finalDate),
            seconds_final = date_final.getTime(),
            date = Date.now(),
            parent = $this.closest(".product-card"),
            text_day = $(this).data("day") ? $(this).data("day") : wpbingo.strings.countdownDays,
            text_hour = $(this).data("hour") ? $(this).data("hour") : wpbingo.strings.countdownHours,
            time_min = $(this).data("min") ? $(this).data("min") : wpbingo.strings.countdownMinutes,
            text_sec = $(this).data("sec") ? $(this).data("sec") : wpbingo.strings.countdownSeconds;
        seconds_final > date ? $this.countdown(finalDate, function(event) {
            var strTime = '<div class="countdown__item"><span>%D</span><span>' + text_day + '</span></div><div class="countdown__item"><span>%H</span><span>' + text_hour + '</span></div><div class="countdown__item"><span>%M</span><span>' + time_min + '</span></div><div class="countdown__item"><span>%S</span><span>' + text_sec + "</span></div>";
            $this.html(event.strftime(strTime))
        }).on("finish.countdown", function() {
            $this.html(wpbingo.strings.countdownFinish)
        }) : ($(".countdown-product", parent).remove(), $(".product-quickview .countdown-quickview").remove())
    })
}, wpbingo.countdown_single = function() {
    var $this = $(".countdown-single .countdown"),
        finalDate = $this.data("countdown_single"),
        date_final = new Date(finalDate),
        seconds_final = date_final.getTime(),
        date = Date.now(),
        text_day = $this.data("day") ? $this.data("day") : wpbingo.strings.countdownDays,
        text_hour = $this.data("hour") ? $this.data("hour") : wpbingo.strings.countdownHours,
        time_min = $this.data("min") ? $this.data("min") : wpbingo.strings.countdownMinutes,
        text_sec = $this.data("sec") ? $this.data("sec") : wpbingo.strings.countdownSeconds;
    seconds_final > date ? $this.countdown(finalDate, function(event) {
        var strTime = '<div class="countdown__item"><span>%D</span><span>' + text_day + '</span></div><div class="countdown__item"><span>%H</span><span>' + text_hour + '</span></div><div class="countdown__item"><span>%M</span><span>' + time_min + '</span></div><div class="countdown__item"><span>%S</span><span>' + text_sec + "</span></div>";
        $this.html(event.strftime(strTime))
    }).on("finish.countdown", function() {
        $this.html(wpbingo.strings.countdownFinish)
    }) : $(".product-single .countdown-single").remove()
}, wpbingo.active_form_login = function() {
    $(".header-account [data-login-account]").on("click", function(e) {
        e.preventDefault();
        var $element2 = $("[data-login_popup]");
        $element2.hasClass("active") ? ($element2.removeClass("active"), $("body").removeClass("not-scroll")) : ($element2.addClass("active"), $("body").addClass("not-scroll"))
    }), $("[data-close_login_popup]").on("click", function(e) {
        e.preventDefault();
        var $element2 = $("[data-login_popup]");
        $element2.hasClass("active") && ($element2.removeClass("active"), $("body").removeClass("not-scroll"))
    })
}, wpbingo.click_atribute_image = function() {
    var moneyFormat2 = wpbingo.strings.moneyFormat;
    $(".wpb-variants-swatch").each(function() {
        var $element2 = $(this);
        $(".swatch-items", $element2).on("click", function() {
            var $this = $(this);
            if (!$(this).hasClass("active")) {
                var $parent = $(this).closest(".swatch-content");
                $(".swatch-items", $parent).removeClass("active"), $(this).addClass("active");
                var variants_value = wpbingo.get_variant_value($element2),
                    productHandle = $element2.data("handle");
                $.getJSON("/products/" + productHandle + ".js", function(product) {
                    product.variants && (wpbingo.updateVariantsButton($element2, product), $.each(product.variants, function(index, variant) {
                        if (variant.available && variant.title == variants_value) {
                            var $current = $this.closest(".product-card");
                            if ($(".product-group-price[data-handle=" + productHandle + "] .variant-price", $current).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat2)), $(".product-card__form[data-handle=" + productHandle + "] input[name='id']", $current).val(variant.id), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), variant.featured_media) {
                                if (prodImg = variant.featured_media.preview_image.src.replace(/(\.[^.]*)$/, "_600x$1").replace("http:", ""), $(".product-card__image-wrapper", $current).hasClass("slider")) {
                                    var variant_slick = $('.product-card__image-wrapper .product-card__image-link[data-variant_id="' + variant.featured_media.id + '"]', $current).data("slick-index");
                                    $(".product-card__image", $current).slick("slickGoTo", variant_slick)
                                } else $(".product-card__image img.variant", $current).attr("src", prodImg), $(".product-card__image img.variant", $current).attr("srcset", prodImg);
                                $(".product-card__image-wrapper", $current).hasClass("zoom") && $(".product-card__image img", $current).last().attr("src", prodImg), $(".product-card__image_compare[data-handle=" + productHandle + "] img", ".content-compare.active").attr("src", prodImg), $(".product-card__image_compare[data-handle=" + productHandle + "] img", ".content-compare.active").attr("srcset", prodImg)
                            }
                        }
                    }))
                })
            }
        })
    })
}, wpbingo.get_variant_value = function($element2) {
    var variant1, variant2, variant3;
    if ($(".swatch-content-1", $element2).each(function(index) {
            var value = $(".swatch-items.active label", $(this)).data("variant");
            value === null && (value = "null"), variant1 = value
        }), $(".swatch-content-2", $element2).each(function(index) {
            var value = $(".swatch-items.active label", $(this)).data("variant");
            value === null && (value = "null"), variant2 = value
        }), $(".swatch-content-3", $element2).each(function(index) {
            var value = $(".swatch-items.active label", $(this)).data("variant");
            value === null && (value = "null"), variant3 = value
        }), variant1 && variant2 && variant3) var variants_value = variant1 + " / " + variant2 + " / " + variant3;
    else if (variant1 && variant2) var variants_value = variant1 + " / " + variant2;
    else if (variant1) var variants_value = variant1;
    return variants_value
}, wpbingo.updateVariantsButton = function($element2, $product) {
    for (var selectedValues = wpbingo.getCurrentOptions($element2), variants = $product.variants, i = 2; i <= 3; i++)
        if ($(".swatch-content-" + i, $element2).length) {
            var $container = $(".swatch-content-" + i, $element2);
            $("label", $container).each(function() {
                var $self = $(this),
                    optionValue = $self.data("variant"),
                    foundIndex;
                i === 2 ? foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), selectedValues[0].value = selectedValues[0].value.toString(), variant.option2 = variant.option2.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === !0
                }) : i === 3 && (foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), variant.option2 = variant.option2.toString(), variant.option3 = variant.option3.toString(), selectedValues[0].value = selectedValues[0].value.toString(), selectedValues[1].value = selectedValues[1].value.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value && variant.option3 === optionValue && variant.available === !0
                })), foundIndex !== -1 ? $self.closest(".swatch-items").removeClass("disabled") : $self.closest(".swatch-items").addClass("disabled")
            })
        }
}, wpbingo.getCurrentOptions = function($element2) {
    for (var currentOptions = [], i = 1; i <= 3; i++)
        if ($(".swatch-content-" + i, $element2).length) {
            var currentOption = {};
            currentOption.index = $(".swatch-content-" + i + " .swatch-items.active label", $element2).data("index");
            var $variant = $(".swatch-content-" + i + " .swatch-items.active label", $element2).data("variant");
            $variant === null && ($variant = "null"), currentOption.value = $variant, currentOptions[i] = currentOption
        } return _.compact(currentOptions)
}, wpbingo.sticky_product = function() {
    var $parent = $(".template-product");
    if ($(".sticky-cart-single", $parent).length > 0) {
        var bwp_width = $(window).width();
        $(window).scroll(function() {
            var scroll_top = $(window).scrollTop(),
                offset_top = $(".product-single__buttons", $parent).offset().top,
                offset_top2 = $(".bwp-footer").offset().top,
                distance = offset_top - scroll_top,
                distance2 = offset_top2 - scroll_top - $(window).height();
            distance <= 0 ? $(".sticky-cart-single", $parent).addClass("sticky") : $(".sticky-cart-single", $parent).removeClass("sticky"), $(".sticky-cart-single", $parent).hasClass("sticky") && (distance2 <= 0 ? $(".sticky-cart-single", $parent).removeClass("sticky") : $(".sticky-cart-single", $parent).addClass("sticky"))
        })
    }
}, wpbingo.sticky_header = function() {
    if ($(".bwp-header").data("sticky_header")) {
        var current_scroll = 0,
            height = $(".bwp-header").height(),
            height_mb = $(".bwp-header .header-mobile .header-top-mobile").height();
        if ($(".bwp-header-topbar").length > 0) var height_topbar = $(".bwp-header-topbar").height();
        else var height_topbar = 0;
        if ($(".bwp-header-campar").length > 0) var height_campar = $(".bwp-header-campar").height();
        else var height_campar = 0;
        $(window).scroll(function() {
            var next_scroll = $(this).scrollTop();
            $(window).width() > 1199 ? next_scroll > height + height_topbar + height_campar ? ($(".bwp-header").addClass("sticky"), $("body").hasClass("template-index") && $(".bwp-header").hasClass("header-absolute") || $(".bwp-header").css("padding-top", height + "px")) : ($(".bwp-header").removeClass("sticky"), $(".bwp-header").removeAttr("style")) : next_scroll > height_mb + height_topbar + height_campar ? ($(".bwp-header").addClass("sticky"), $(".bwp-header").css("padding-top", height_mb + "px")) : ($(".bwp-header").removeClass("sticky"), $(".bwp-header").removeAttr("style")), current_scroll = next_scroll
        })
    }
}, wpbingo.click_button = function() {
    $(".search-toggle").on("click", function() {
        $(".content-search-toggle").hasClass("active") ? ($(".bwp-header-topbar ").removeClass("active-index"), $("body").removeClass("active_search"), $(".content-search-toggle").removeClass("show"), setTimeout(function() {
            $(".content-search-toggle").removeClass("active")
        }, 300)) : ($(".content-search-toggle").addClass("active"), $(".bwp-header-topbar ").addClass("active-index"), $("body").addClass("active_search"), setTimeout(function() {
            $(".content-search-toggle").addClass("show")
        }, 100))
    }), $("[data-close-search-toggle]").on("click", function() {
        $(".content-search-toggle").hasClass("active") ? ($(".content-search-toggle").removeClass("show"), $(".bwp-header-topbar ").removeClass("active-index"), $("body").removeClass("active_search"), setTimeout(function() {
            $(".content-search-toggle").removeClass("active")
        }, 300)) : ($(".content-search-toggle").addClass("active"), $(".bwp-header-topbar ").addClass("active-index"), $("body").addClass("active_search"), setTimeout(function() {
            $(".content-search-toggle").addClass("show")
        }, 100))
    }), $(".title-size-guide").on("click", function() {
        $(".size-guide").hasClass("active") ? $(".size-guide").removeClass("active") : $(".size-guide").addClass("active")
    })
}, wpbingo.lookbook = function() {
    $(window).on("click.Bst", function(event) {
        var $box = $(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card .product-card"),
            $box2 = $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__point");
        $box.has(event.target).length == 0 && !$box.is(event.target) && $box2.has(event.target).length == 0 && !$box2.is(event.target) && $(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").hasClass("active") && ($(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").removeClass("active").removeAttr("style"), $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").removeClass("active"))
    }), $(".wpbingo-section--lookbook:not(.lookbook-simple) .close-lookbook").on("click", function() {
        $(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").hasClass("active") && ($(".wpbingo-section--lookbook:not(.lookbook-simple) .content-product-card").removeClass("active").removeAttr("style"), $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").removeClass("active"))
    }), $(".wpbingo-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").on("click", function() {
        var $parent = $(this).closest(".wpbingo-section--lookbook:not(.lookbook-simple)"),
            $id = $(this).data("target"),
            x = $(this).offset();
        $(".content-product-card", $parent).removeClass("active").removeAttr("style"), $(".lookbook-card__btn", $parent).removeClass("active"), $(this).hasClass("active") ? ($(this).removeClass("active"), $("#" + $id, $parent).removeClass("active").removeAttr("style")) : ($(this).addClass("active"), $("#" + $id, $parent).addClass("active").css({
            top: x.top,
            left: x.left
        }))
    }), $(".wpbingo-section--lookbook.lookbook-split .wpbingo-lookbook__item").mouseover(function() {
        $(this).hasClass("active") || ($(".wpbingo-section--lookbook.lookbook-split .wpbingo-lookbook__item").removeClass("active"), $(this).addClass("active"), $(".wpbingo-section--lookbook.lookbook-split .content-product-card").hasClass("active") && ($(".wpbingo-section--lookbook.lookbook-split .content-product-card").removeClass("active").removeAttr("style"), $(".wpbingo-section--lookbook.lookbook-split .lookbook-card__btn").removeClass("active")))
    }), $(".wpbingo-section--lookbook.lookbook-simple .lookbook-card__btn").on("click", function() {
        var $parent = $(this).closest(".wpbingo-section--lookbook.lookbook-simple"),
            $element2 = $(this).closest(".lookbook__item"),
            $id = $(this).data("target");
        if (!$(this).hasClass("active")) {
            $(".content-product-card", $element2).removeClass("active"), $(".lookbook-card__btn", $element2).removeClass("active"), $(this).addClass("active"), $("#" + $id, $parent).addClass("active");
            var slick_current = $("#" + $id, $parent).data("slick-index");
            $(".lookbook-product", $element2).slick("slickGoTo", slick_current)
        }
    })
}, wpbingo.lookbook_block = function() {
    $(window).on("click.Bst", function(event) {
        var $box3 = $(".wpbingo-widget-lookbook .content-product-card .product-card"),
            $box4 = $(".wpbingo-widget-lookbook .lookbook-card__point");
        $box3.has(event.target).length == 0 && !$box3.is(event.target) && $box4.has(event.target).length == 0 && !$box4.is(event.target) && $(".wpbingo-widget-lookbook .lookbook-card__item").hasClass("active") && $(".wpbingo-widget-lookbook .lookbook-card__item").removeClass("active")
    }), $(".wpbingo-widget-lookbook .close-lookbook").on("click", function() {
        $(".wpbingo-widget-lookbook .lookbook-card__item").hasClass("active") && $(".wpbingo-widget-lookbook .lookbook-card__item").removeClass("active")
    }), $(".wpbingo-widget-lookbook .lookbook-card__btn").on("click", function() {
        var $parent = $(this).closest(".wpbingo-widget-lookbook"),
            $item = $(this).closest(".lookbook-card__item");
        $(".lookbook-card__item", $parent).removeClass("active"), $(this).hasClass("active") ? $item.removeClass("active") : $item.addClass("active")
    })
}, wpbingo.newsletter = function() {
    var alertNewsletter;
    $(".js-wpbingo-newsletter").each(function() {
        var $form = $(this);
        $form.on("submit", function(event) {
            event.preventDefault(), $(".js-alert-newsletter").remove(), $.ajax({
                type: $form.attr("method"),
                url: $form.attr("action"),
                data: $form.serialize(),
                cache: !1,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function(data2) {
                    data2.result === "success" ? ($form.prepend(alertNewsletter(wpbingo.strings.newsletterSuccess, "success")), $(".js-input-newsletter").val("")) : $form.prepend(alertNewsletter(data2.msg.replace("0 - ", ""), "danger"))
                },
                error: function(err) {
                    $form.prepend(alertNewsletter(err, "danger"))
                }
            })
        })
    }), alertNewsletter = function(message, type) {
        var alert2 = '<div class="js-alert-newsletter alert alert--mailchimp alert-' + type + '">' + message + "</div>";
        return alert2
    };
    var newsletterPopup = ".js-newsletter-popup",
        newsletterPopupClose = ".js-newsletter-popup-close",
        newsletterPopupSubmit = ".js-newsletter-popup-submit",
        cNewsletter = "",
        classNameNewsletterActive = "newsletter-popup--active";
    $(newsletterPopup).find(".js-newsletter-popup-success").length > 0 && wpbingo.setCookie("wpbingo_newsletter_popup", 1, 30), cNewsletter = wpbingo.getCookie("wpbingo_newsletter_popup"), cNewsletter == 1 && $(newsletterPopup).remove(), cNewsletter != 1 && !($(".shopify-challenge__container").length > 0) && $(newsletterPopup).addClass("show"), $(newsletterPopupClose).on("click", function() {
        $(newsletterPopup).find(".alert--mailchimp").length > 0 ? wpbingo.setCookie("wpbingo_newsletter_popup", 1, 30) : wpbingo.setCookie("wpbingo_newsletter_popup", 1, 1), $(newsletterPopup).removeClass("show")
    }), $(newsletterPopupSubmit).on("click", function() {
        wpbingo.setCookie("wpbingo_newsletter_popup", 1, 30)
    })
}, wpbingo.verify_popup = function() {
    if ($(".js-verify-popup").length) {
        var verify_popup = "";
        verify_popup || $(".js-verify-popup").addClass("active"), $(".js-verify-popup .button-not-allow").on("click", function() {
            wpbingo.setCookie("wpbingo_verify_popup", "exit", 1), $(".js-verify-popup").addClass("disabled"), $(".js-verify-popup .verify-info").addClass("hidden"), $(".js-verify-popup .alert-verify").removeClass("hidden"), $("body").addClass("not-scroll")
        }), $(".js-verify-popup .button-allow").on("click", function() {
            wpbingo.setCookie("wpbingo_verify_popup", "allow", 1), $(".js-verify-popup").removeClass("active")
        }), verify_popup = wpbingo.getCookie("wpbingo_verify_popup"), verify_popup == "allow" && $(".js-verify-popup").removeClass("active"), verify_popup == "exit" && ($(".js-verify-popup").addClass("disabled"), $(".js-verify-popup .verify-info").addClass("hidden"), $(".js-verify-popup .alert-verify").removeClass("hidden"), $("body").addClass("not-scroll"))
    }
}, wpbingo.header_campar = function() {
    var header_campar = "";
    $(".bwp-header-campar .close-campbar").on("click", function() {
        wpbingo.setCookie("wpbingo_header_campar", 1, 1), $(".bwp-header-campar").slideUp()
    }), header_campar = wpbingo.getCookie("wpbingo_header_campar"), header_campar != 1 && ($(".bwp-header-campar").removeClass("active"), $(".bwp-header-campar").slideDown())
}, wpbingo.customNumberInput = function() {
    var $body2 = $("body"),
        qtyAdjust = ".js-qty-adjust",
        qtyNumber = ".js-qty-number",
        validateQty2;
    $body2.on("click", qtyAdjust, function() {
        var $el = $(this),
            $qtySelector = $el.siblings(qtyNumber),
            qty = parseInt($qtySelector.val().replace(/\D/g, ""));
        qty = validateQty2(qty), $el.hasClass("wpbingo-qty__adjust--plus") ? qty += 1 : (qty -= 1, qty <= 0 && (qty = 0), qty <= 0 && $qtySelector.attr("min") == "1" && (qty = 1)), $qtySelector.val(qty)
    }), $body2.on("focus", qtyAdjust, function() {
        var $el = $(this);
        setTimeout(function() {
            $el.select()
        }, 50)
    }), validateQty2 = function(qty) {
        return parseFloat(qty) === parseInt(qty) && !isNaN(qty) || (qty = 1), qty
    }
}, wpbingo.ajaxFilterCategory = function($element2) {
    if ($element2) var $categories = $element2;
    else var $categories = $(".js-page-collection .FacetsWrapperDesktop .sidebar-categories");
    if ($(".wpbingo-breadcrumbs").hasClass("have-collection")) var $collection = !0;
    var wpbingoFilterContentProduct = ".js-collection-content-product",
        wpbingoFilterSidebar = ".collection-sidebar",
        wpbingoFilterTitle = ".wpbingo-breadcrumbs__inner",
        wpbingoFacetsContainer = ".active-facets-desktop",
        bwpChangeView = ".js-change-view",
        wpbingoFacetsWrapper = ".FacetsWrapperDesktop ";
    $($categories).on("click", "a", function(e) {
        e.preventDefault();
        var pageURL = $(this).attr("href"),
            newTitle = $(this).attr("title");
        History.pushState({
            param: Shopify.queryParams
        }, pageURL, pageURL), delete Shopify.queryParams.page, $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
            width: "40%"
        }), $.ajax({
            type: "get",
            url: pageURL,
            success: function(data2) {
                document.title = newTitle, $(wpbingoFilterContentProduct).replaceWith($(data2).find(wpbingoFilterContentProduct)), $(wpbingoFilterSidebar).replaceWith($(data2).find(wpbingoFilterSidebar)), $(wpbingoFilterTitle).replaceWith($(data2).find(wpbingoFilterTitle)), $(wpbingoFacetsContainer).replaceWith($(data2).find(wpbingoFacetsContainer)), $(wpbingoFacetsWrapper).replaceWith($(data2).find(wpbingoFacetsWrapper)), $(".wpbingo-breadcrumbs__image").replaceWith($(data2).find(".wpbingo-breadcrumbs__image")), $collection && wpbingo.elementslickCarousel($(".wpbingo-breadcrumbs__image .js-carousel")), wpbingo.ajaxFilterCategory(), wpbingo.click_atribute_image(), wpbingo.popup_product_card(), wpbingo.zoom_thumb(), $(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                    wpbingo.elementslickCarousel($(".js-carousel", $(this)))
                }), wpbingo.hideLoading(), window.SPR && (SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()), wpbingo.countdown(), cViewCollection = wpbingo.getCookie("wpbingo_view_collection"), cViewCollection && ($("#JsCollectionProduct").removeAttr("class"), $("#JsCollectionProduct").addClass(cViewCollection), $(bwpChangeView).removeClass("active"), $("[data-view=" + cViewCollection + "]").addClass("active")), $(".js-page-collection").on("click", bwpChangeView, function(e2) {
                    e2.preventDefault(), $(this).hasClass("active") || ($(".product-card__image-wrapper.slider", wpbingoFilterContentProduct).each(function() {
                        $(".js-carousel", $(this)).slick("refresh")
                    }), wpbingo.setCookie("wpbingo_view_collection", $(this).data("view"), 1), $(bwpChangeView).removeClass("active"), $(this).addClass("active"), $("#JsCollectionProduct").removeAttr("class"), $("#JsCollectionProduct").addClass($(this).data("view")))
                }), wpbingo.sidebarCollection(), initButtons(), initButtonsCompare(), wpbingo.countActiveSidebar(), wpbingo.toggleSidebar(), !$(".js-page-collection").hasClass("dropdown") && !$(".js-page-collection").hasClass("on_top") && wpbingo.toggleSidebar(), $("#pre-loading .pre-loading__bar").css({
                    width: "100%"
                }), setTimeout(function() {
                    $("#pre-loading .pre-loading__bar").css({
                        width: "0"
                    }), $("#pre-loading").removeClass("load-product")
                }, 500)
            },
            error: function(xhr, text) {
                console.log(text)
            }
        }), $("body,html").animate({
            scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
        }, 600)
    })
}, wpbingo.zoom_thumb = function() {
    $(".product-card .product-card__image-wrapper").hasClass("zoom") && $(".product-card .product-card__image").zoom()
}, wpbingo.sale_nofication = function() {
    if ($(".sale-nofication").length) {
        var $element2 = $(".sale-nofication"),
            time_start = 0,
            start = $element2.data("start"),
            start_unit = $element2.data("start_unit");
        start_unit == "second" ? time_start = start * 1e3 : start_unit == "minute" && (time_start = start * 1e3 * 60), $(".close-notification", $element2).on("click", function() {
            $element2.hasClass("active") && $element2.removeClass("active")
        }), setTimeout(function() {
            wpbingo.sale_nofication_start()
        }, time_start)
    }
}, wpbingo.sale_nofication_start = function() {
    if ($(".sale-nofication").length) {
        var $element2 = $(".sale-nofication"),
            collectionId = $element2.data("id"),
            array_product = $element2.data("array_product"),
            limit = $element2.data("limit") - 1,
            stay = $element2.data("stay"),
            stay_unit = $element2.data("stay_unit"),
            user_purchased = window.routes.user_purchased,
            list_time = window.routes.list_time;
        const purchased = user_purchased.split("|"),
            time = list_time.split("|");
        var time_stay = 0;
        stay_unit == "second" ? time_stay = stay * 1e3 : stay_unit == "minute" && (time_stay = stay * 1e3 * 60);
        var array1 = array_product.split('""'),
            item = Math.floor(limit * Math.random()),
            array2 = array1[item].split('"');
        if (item == 0) var array = array2[1];
        else var array = array2[0];
        $.getJSON("/products/" + array + ".js", function(product) {
            $("#image", $element2).attr("src", product.featured_image), $("a", $element2).attr("href", "/products/" + product.handle), $(".product-title a", $element2).text(product.title), $(".notification-purchased .name", $element2).text(purchased[item]), $(".time-suggest", $element2).text(time[item]), $element2.addClass("active")
        }), $(".scroll-notification", $element2).css("animation-duration", stay + "s"), setTimeout(function() {
            $element2.removeClass("active"), wpbingo.sale_nofication()
        }, time_stay)
    }
}, wpbingo.discount_single = function() {
    if ($(".product-single #buy_more_form").length > 0) {
        var $parent = $(".product-single #buy_more_form"),
            count = $(".buy_more", $parent).data("quatily"),
            id_product = $("input[name='items[][id]']", $parent).attr("value"),
            params = {
                type: "POST",
                url: "/cart.js",
                processData: !1,
                contentType: !1,
                dataType: "json",
                success: function(cart) {
                    if (cart.items.length == 0) $(".buy-more-cart", $parent).removeClass("disabled");
                    else
                        for (var item in cart.items) {
                            var variant = cart.items[item],
                                variant_id = variant.variant_id;
                            if (variant_id == id_product) {
                                variant.quantity >= count ? ($(".buy-more-cart", $parent).addClass("disabled"), $(".buy-more-cart", $parent).prop("disabled", !0)) : ($(".buy-more-cart", $parent).removeClass("disabled"), $(".buy-more-cart", $parent).prop("disabled", !1));
                                break
                            } else $(".buy-more-cart", $parent).removeClass("disabled"), $(".buy-more-cart", $parent).prop("disabled", !1)
                        }
                },
                error: function(XMLHttpRequest2, textStatus) {
                    typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                }
            };
        jQuery.ajax(params)
    }
}, wpbingo.pick_up = function(id) {
    if ($(".product-single .product-single__pick_up").length > 0) {
        var $element2 = $(".product-single .product-single__pick_up"),
            title = $element2.data("product_title"),
            image_url = $element2.data("src");
        if (id == null) var id = $element2.data("id");
        fetch(window.Shopify.routes.root + "variants/" + id + "/?section_id=pickup-availability").then(response => response.text()).then(text => {
            const container2 = document.querySelector("[data-store-availability-container]"),
                pickupAvailabilityHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
            container2.appendChild(pickupAvailabilityHTML), $(".content-info .title", $element2).html(title), $element2.data("only_variant") == !0 && $(".product-info .content-image img", $element2).attr("src", image_url), $(".pickup-availability-information", $element2).on("click", function() {
                $(".pickup-availabilities-modal", $element2).hasClass("active") || $(".pickup-availabilities-modal", $element2).addClass("active")
            }), $(".pickup_modal-close", $element2).on("click", function() {
                $(".pickup-availabilities-modal", $element2).hasClass("active") && $(".pickup-availabilities-modal", $element2).removeClass("active")
            })
        }).catch(e => {
            console.error(e)
        })
    }
}, wpbingo.time_estimated_delivery = function() {
    if ($(".product-single .estimated_delivery").length > 0) {
        var code_time = window.routes.iso_code,
            $element2 = $(".product-single .estimated_delivery"),
            datenow_preorder = $(".product-single .estimated_delivery").data("date_now");
        if (datenow_preorder) var datenow = new Date(datenow_preorder).getTime();
        else var datenow = Date.now();
        var date = new Date,
            day = 24 * 60 * 60 * 1e3,
            day_ship = $($element2).data("number_day"),
            day_start = new Date(day_ship * day + datenow),
            day_stop = new Date((day_ship + 4) * day + datenow),
            day_start = day_start.toLocaleDateString(code_time, {
                weekday: "long",
                month: "short",
                day: "numeric"
            }),
            day_stop = day_stop.toLocaleDateString(code_time, {
                weekday: "long",
                month: "short",
                day: "numeric"
            }),
            date_time = ((date.getHours() * 60 + date.getMinutes()) * 60 + date.getSeconds()) * 1e3,
            time_sec = (day - date_time) / 1e3,
            time_left_m = (time_sec - time_sec % 60) / 60 % 60,
            time_left_h = ((time_sec - time_sec % 60) / 60 - time_left_m % 60) / 60;
        $("span.time_hour", $element2).html(time_left_h), $("span.time_min", $element2).html(time_left_m), $("span.day_start", $element2).html(day_start), $("span.day_stop", $element2).html(day_stop)
    }
}, wpbingo.countActiveSidebar = function() {
    var count = 0;
    if ($(".js-page-collection").hasClass("dropdown") || $(".js-page-collection").hasClass("on_top")) var $parent_collection = $(".js-page-collection .FacetsWrapperDesktop");
    else var $parent_collection = $(".js-page-collection .collection-sidebar");
    $(".js-filter", $parent_collection).each(function() {
        count = $("input:checked", $(this)).length, count > 0 ? ($(".block-sidebar__title .count", $(this)).removeClass("hide"), $(".facets__display .reset-filter", $(this)).removeClass("hide"), $(".block-sidebar__title .count", $(this)).text(count)) : $(".block-sidebar__title .count", $(this)).addClass("hide"), $(this).hasClass("show") && ($("h4.block-sidebar__title", $(this)).hasClass("active") ? $("h4.block-sidebar__title", $(this)).removeClass("active") : $("h4.block-sidebar__title", $(this)).addClass("active"))
    });
    var count_sidebar = $(".js-page-collection.dropdown .sidebar-categories ul li.active").length;
    count_sidebar > 0 ? $(".js-page-collection.dropdown .sidebar-categories .block-sidebar__title .count").removeClass("hide") : $(".js-page-collection.dropdown .sidebar-categories .block-sidebar__title .count").addClass("hide"), $(".collection-sidebar .js-filter .facets__display .select-filter label").on("click", function() {
        $(".collection-sidebar .js-filter").removeClass("show");
        var $parent = $(this).closest(".js-filter");
        $parent.addClass("show")
    }), $(".collection-sidebar .js-filter .facets__display .facets__price input").change(function() {
        $(".collection-sidebar .js-filter").removeClass("show");
        var $parent = $(this).closest(".js-filter");
        $parent.addClass("show")
    }), $(".js-page-collection.on_top .js-filter .facets__display li label").on("click", function() {
        var $parent = $(this).closest(".js-page-collection.on_top ");
        $parent.hasClass("show") || $parent.addClass("show")
    }), $(".js-page-collection.on_top .js-filter .facets__display .facets__price input").change(function() {
        var $parent = $(this).closest(".js-page-collection.on_top ");
        $parent.hasClass("show") || $parent.addClass("show")
    })
}, wpbingo.toggleSidebar = function($element2) {
    if ($(".js-page-collection:not(.sidebar_4,.on_top) h4.block-sidebar__title").on("click", function() {
            if ($(".js-page-collection").hasClass("dropdown") && ($(this).hasClass("active") || ($(".js-page-collection.dropdown .facets__display").slideUp(), $(".js-page-collection.dropdown h4.block-sidebar__title").removeClass("active"))), $element2)
                if ($(".js-page-collection").hasClass("dropdown")) var $parent = $(this).closest(".js-filter");
                else var $parent = $(this).closest(".js-filter:not(.sidebar-categories)");
            else var $parent = $(this).closest(".js-filter");
            $("h4.block-sidebar__title", $parent).hasClass("active") ? $("h4.block-sidebar__title", $parent).removeClass("active") : $("h4.block-sidebar__title", $parent).addClass("active"), $(".facets__display", $parent).slideToggle()
        }), $(window).width() > 991 ? ($(".js-page-collection.on_top .js-sidebar-toggle").on("click", function() {
            $(this).toggleClass("active"), $(".js-page-collection.on_top .dropdown_ontop").slideToggle(), $(".js-page-collection.on_top").hasClass("show") && $(".js-page-collection.on_top").removeClass("show")
        }), $(".js-page-collection .collection-sidebar__overlay").on("click", function() {
            $("body").hasClass("collection-sidebar--open") && ($(".js-page-collection.on_top .dropdown_ontop").slideUp(), $(".js-page-collection").hasClass("on_top") ? setTimeout(function() {
                $("body").removeClass("collection-sidebar--open"), $(".js-page-collection.on_top").hasClass("show") && $(".js-page-collection.on_top").removeClass("show")
            }, 600) : $("body").removeClass("collection-sidebar--open"))
        })) : $element2 || $(".js-page-collection.on_top .collection-sidebar__overlay").on("click", function() {
            $("body").hasClass("collection-sidebar--open") ? $("body").removeClass("collection-sidebar--open") : $("body").addClass("collection-sidebar--open")
        }), $(".js-page-collection").hasClass("viewmore")) {
        var number_list = $(".js-page-collection").data("list_number");
        if ($(".js-page-collection").hasClass("filter_drawer"))
            if ($element2)
                if ($(".js-page-collection").hasClass("on_top")) var list = $(".filter-list");
                else var list = $(".filter-list:not(.sidebar-categories)");
        else var list = $(".filter-list");
        else if ($(".js-page-collection").hasClass("side_out"))
            if ($element2) var list = $(".js-filter:not(.sidebar-categories,.filter-color,.js-filter-price,.filter-image)");
            else var list = $(".js-filter:not(.filter-color,.js-filter-price,.filter-image)");
        else if ($(".js-page-collection").hasClass("sidebar_1"))
            if ($element2) var list = $(".js-filter:not(.sidebar-categories,.filter-color,.js-filter-price,.filter-image)");
            else var list = $(".js-filter:not(.filter-color,.js-filter-price,.filter-image)");
        else if ($(".js-page-collection").hasClass("sidebar_2"))
            if ($element2) var list = $(".js-filter:not(.sidebar-categories,.filter-color,.js-filter-price,.filter-image)");
            else var list = $(".js-filter:not(.filter-color,.js-filter-price,.filter-image)");
        else if ($(".js-page-collection").hasClass("sidebar_3"))
            if ($element2) var list = $(".js-filter:not(.sidebar-categories,.js-filter-price,.filter-image,.filter-label)");
            else var list = $(".js-filter:not(.js-filter-price,.filter-image,.filter-label)");
        else if ($(".js-page-collection").hasClass("sidebar_4"))
            if ($element2) var list = $(".filter-list:not(.sidebar-categories,.filter-out_stock)");
            else var list = $(".filter-list:not(.filter-out_stock)");
        else if ($(".js-page-collection").hasClass("dropdown") || $(".js-page-collection").hasClass("on_top")) var list = $(".js-filter:not(.filter-image)");
        $(list).each(function() {
            var count_sidebar_1 = $(".facets__display>ul>li", $(this)).length;
            $(".facets__display>ul>li.view", $(this)).length || count_sidebar_1 > number_list && $(".facets__display>ul", $(this)).append('<li class="view"><span>' + window.strings.view_more + "</span></li>"), $(".facets__display>ul>li:not(.view)", $(this)).each(function(index) {
                index + 1 > number_list && $(this).css("display", "none")
            })
        }), $(".facets__display>ul>li.view", list).on("click", function() {
            var $parent = $(this).closest("ul");
            if ($(">li:not(.view)", $parent).each(function(index) {
                    index + 1 > number_list && $(this).slideToggle()
                }), $(this).hasClass("show")) {
                $(this).removeClass("show"), $("span", $(this)).text(window.strings.view_more);
                return
            } else {
                $(this).addClass("show"), $("span", $(this)).text(window.strings.view_less);
                return
            }
        })
    }
}, wpbingo.sidebarCollection = function($element2) {
    if ($element2) var $parent = $(".js-page-collection .FacetsWrapperDesktop");
    else var $parent = $(".js-page-collection");
    $(".sidebar-categories ul li a", $parent).on("click", function() {
        var $parent2 = $(this).closest("li");
        $(".sidebar-categories ul li").removeClass("active"), $parent2.hasClass("active") || $parent2.addClass("active")
    }), $(".sidebar-categories .toggle_collection-children", $parent).on("click", function() {
        var $parent2 = $(this).closest("li");
        $(this).toggleClass("show"), $(">.collection-children", $parent2).slideToggle()
    }), $(".sidebar-categories .collection-children li", $parent).each(function() {
        if ($(this).hasClass("active")) {
            var $parent2 = $(this).parents(".collection-children"),
                $parent22 = $(this).parents("li");
            $parent2.css({
                display: "block"
            }), $(">.link-collection >.toggle_collection-children", $parent22).hasClass("show") || $(">.link-collection >.toggle_collection-children", $parent22).addClass("show")
        }
    })
}, wpbingo.gift_wrap = function() {
    var selectors2 = {
        body: "body",
        GiftCard: "[data-gift-card]",
        giftWrapTemplate: "#gift-card-template",
        giftWrapBtn: ".gift-wrap [data-gift_card]",
        giftCardContainer: "[data-gift-card-container]",
        giftCardClose: "[data-gift-card-close]",
        giftCardImages: "[data-gift-card-images]",
        giftCardVariant: ".js-giftcard-option-selector",
        originalSelectorId: "[data-edit_variant-variant]",
        giftCardProductPrice: ".js-gift-product-price",
        giftCardProductPriceCompare: ".js-gift-product-price-compare",
        giftCardQty: "[data-gift-card-quantity]",
        giftCardAvaiable: ".product-avaiable",
        giftCardAvaiableInStock: ".product-avaiable--instock",
        giftCardAvaiableOutStock: ".product-avaiable--outstock",
        giftCardProductDetailsURL: ".js-qv-product-details"
    };

    function GiftCard(container2) {
        this.$container = $(container2), this.cache = {}, this.productVariants = [], this.currentVariant = {}, this.cacheSelectors(), this.initializeEvents()
    }
    return GiftCard.prototype = _.assignIn({}, GiftCard.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $giftCardContainer: this.$container.find(selectors2.giftCardContainer)
            }
        },
        initializeEvents: function() {
            var $this = this;
            $(selectors2.body).on("click", selectors2.giftWrapBtn, function(e) {
                e.preventDefault();
                var productHandle = $(this).data("gift_card");
                $(this).addClass("load-giftcard"), $.getJSON("/products/" + productHandle + ".js", function(product) {
                    product.available ? $this.firstAvailableVariant(product.variants, $this) : $this.currentVariant = product.variants[0], $(selectors2.giftWrapBtn).removeClass("load-giftcard"), $this.buildGiftCard(product), $this.show(), $this.createImageCarousel(product)
                })
            }), $(selectors2.body).on("click", selectors2.giftCardClose, function(e) {
                e.preventDefault(), $this.hide()
            }), $(selectors2.giftCardContainer).on("change", selectors2.giftCardVariant, function(e) {
                $this.onVariantChange()
            })
        },
        firstAvailableVariant: function(variants, global) {
            global.productVariants = variants;
            for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                if (variant.available) {
                    global.currentVariant = variant;
                    break
                }
            }
        },
        buildGiftCard: function(product) {
            var moneyFormat2 = wpbingo.strings.moneyFormat,
                currentVariant = this.currentVariant,
                source = $(selectors2.giftWrapTemplate).html(),
                template = Handlebars.compile(source),
                images = "",
                price = "",
                external = "",
                qvObject = {
                    id: product.id
                };
            if (typeof product.media < "u") {
                images += '<div class="gift_card-images__list slick-carousel" data-gift-card-images>';
                for (var i = 0; i < product.media.length; i++) {
                    var media = product.media[i];
                    media.media_type === "image" && (images += '<div class="slick-carousel__item"><div class="giftcard-images__item" data-media-id=' + media.id + '><img class="img-fluid" alt="' + product.title + '" src="' + media.src + '" /></div></div>')
                }
                images += "</div>"
            }
            qvObject.variantID = currentVariant.id, qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== "" ? currentVariant.sku : "N/A", qvObject.images = images, qvObject.title = product.title, qvObject.url = product.url, price += '<div class="price-container">';
            var productCompareClass = product.compare_at_price !== null ? "" : "d-none";
            price += '<div class="js-gift-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + wpbingo.Currency.formatMoney(product.compare_at_price, moneyFormat2) + "</div>", price += '<div class="js-gift-product-price product-single__price">' + wpbingo.Currency.formatMoney(product.price, moneyFormat2) + "</div>", price += '</div">', qvObject.price = price, qvObject.variants = this.buildVariant(product), $(selectors2.giftCardContainer).html(template(qvObject)), this.updateMedia(currentVariant), this.updateDetailsLink(currentVariant), $("#form-gift-card-addtocart .btn--add-to-cart").on("click", function(e) {
                e.preventDefault(), $(this).removeClass("added"), $(this).addClass("active");
                let addToCartForm = document.querySelector("#form-gift-card-addtocart");
                var params = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(addToCartForm),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(line_item) {
                        $("#form-gift-card-addtocart .btn--add-to-cart").removeClass("active"), $("#form-gift-card-addtocart .btn--add-to-cart").addClass("added"), setTimeout(function() {
                            $("#form-gift-card-addtocart .btn--add-to-cart").removeClass("added")
                        }, 3e3), ajaxCart.load(), ajaxCartPage.load()
                    },
                    error: function(XMLHttpRequest2, textStatus) {
                        typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                    }
                };
                jQuery.ajax(params)
            }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        convertToSlug: function(str) {
            return str.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        buildVariant: function(product) {
            var result = "",
                currentVariant = this.currentVariant;
            if (product.options[0].name !== "Title")
                for (var options = product.options, i = 0; i < options.length; i++) {
                    var option = options[i],
                        optionIndex = i + 1;
                    result += '<div class="variants-wrapper product-form__item" data-giftcard-variant-option="' + optionIndex + '">', result += '<label class="variants__label">' + option.name + "</label>", result += '<div class="variants__options">';
                    for (var j = 0; j < option.values.length; j++) {
                        for (var value = option.values[j], isDisable = !0, colorAttribute = "", k = 0; k < this.productVariants.length; k++) {
                            var variantCondition = this.productVariants[k];
                            if (variantCondition.available) {
                                if (i == 0 && variantCondition.option1 === value) {
                                    isDisable = !1;
                                    break
                                } else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
                                    isDisable = !1;
                                    break
                                } else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
                                    isDisable = !1;
                                    break
                                }
                            }
                        }
                        result += '<div class="single-option-selector">', result += '<input type="radio" data-single-option-button', result += currentVariant.options[i] === value ? " checked " : " ", isDisable && (result += 'disabled="disabled"'), result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ', result += 'class="js-giftcard-option-selector', isDisable && (result += " disabled"), result += '" id="giftcard-product-option-' + i + "-" + value.toLowerCase() + '">', result += '<label data-toggle="tooltip" title="' + value + '" for="giftcard-product-option-' + i + "-" + value.toLowerCase() + '" ' + colorAttribute, isDisable && (result += ' class="disabled"'), result += ">" + value + '<span class="d-none"></span></label>', result += "</div>"
                    }
                    result += "</div>", result += "</div>"
                }
            return result
        },
        createImageCarousel: function(product) {
            product.media.length > 1 && $(selectors2.GiftCard).find(selectors2.giftCardImages).slick({
                infinite: !1,
                rows: 0,
                arrows: !1,
                rtl: wpbingo.rtl_slick()
            })
        },
        getCurrentOptions: function() {
            var currentOptions = _.map($(selectors2.giftCardVariant, selectors2.giftCardContainer), function(element) {
                var $element2 = $(element),
                    type = $element2.attr("type"),
                    currentOption = {};
                return type === "radio" || type === "checkbox" ? $element2[0].checked ? (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption) : !1 : (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption)
            });
            return currentOptions = _.compact(currentOptions), currentOptions
        },
        getVariantFromOptions: function() {
            var selectedValues = this.getCurrentOptions(),
                variants = this.productVariants,
                found = _.find(variants, function(variant) {
                    return selectedValues.every(function(values) {
                        return _.isEqual(variant[values.index], values.value)
                    })
                });
            return found
        },
        updateVariantsButton: function() {
            for (var selectedValues = this.getCurrentOptions(), variants = this.productVariants, i = 2; i <= 3; i++) $('[data-giftcard-variant-option="' + i + '"]', selectors2.giftCardContainer).length && $('[data-giftcard-variant-option="' + i + '"] ' + selectors2.giftCardVariant, selectors2.giftCardContainer).each(function() {
                var $self = $(this),
                    optionValue = $self.val(),
                    foundIndex;
                i === 2 ? foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), selectedValues[0].value = selectedValues[0].value.toString(), variant.option2 = variant.option2.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === !0
                }) : i === 3 && (foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), variant.option2 = variant.option2.toString(), variant.option3 = variant.option3.toString(), selectedValues[0].value = selectedValues[0].value.toString(), selectedValues[1].value = selectedValues[1].value.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value && variant.option3 === optionValue && variant.available === !0
                })), foundIndex !== -1 ? ($self.removeAttr("disabled", "disabled").removeClass("disabled"), $self.next("label").removeClass("disabled")) : ($self.attr("disabled", "disabled").addClass("disabled"), $self.next("label").addClass("disabled"))
            })
        },
        updateVariantsButtonDisabed: function() {
            for (var i = 2; i <= 3; i++)
                if ($('[data-giftcard-variant-option="' + i + '"]', selectors2.giftCardContainer).length) {
                    var isUpdate = !1;
                    $('[data-giftcard-variant-option="' + i + '"] ' + selectors2.giftCardVariant, selectors2.giftCardContainer).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if ((type === "radio" || type === "checkbox") && this.checked && $element2.hasClass("disabled")) return $element2.prop("checked", !1), isUpdate = !0, !1
                    }), $('[data-giftcard-variant-option="' + i + '"] ' + selectors2.giftCardVariant, selectors2.giftCardContainer).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if (isUpdate && (type === "radio" || type === "checkbox") && !$element2.hasClass("disabled")) return $element2.prop("checked", !0), isUpdate = !1, $element2.trigger("change"), !1
                    })
                }
        },
        updateMasterSelect: function(variant) {
            variant && $(selectors2.originalSelectorId, selectors2.giftCardContainer).val(variant.id)
        },
        updateMedia: function(variant) {
            variant && variant.featured_media && variant.featured_media.id && $(selectors2.giftCardImages, selectors2.giftCardContainer).find(".giftcard-images__item").each(function() {
                var imageID = $(this).data("media-id");
                if (variant.featured_media.id == imageID) {
                    var slickIndex = $(this).closest(".slick-carousel__item").data("slick-index");
                    slickIndex != null && $(selectors2.giftCardImages, selectors2.giftCardContainer).slick("slickGoTo", slickIndex)
                }
            })
        },
        updatePrice: function(variant) {
            var moneyFormat2 = wpbingo.strings.moneyFormat;
            variant ? ($(selectors2.giftCardProductPrice, selectors2.giftCardContainer).removeClass("d-none"), $(selectors2.giftCardProductPriceCompare, selectors2.giftCardContainer).removeClass("d-none"), $(selectors2.giftCardProductPrice, selectors2.giftCardContainer).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat2)), variant.compare_at_price > variant.price ? ($(selectors2.giftCardProductPriceCompare, selectors2.giftCardContainer).html(wpbingo.Currency.formatMoney(variant.compare_at_price, moneyFormat2)).removeClass("d-none"), $(selectors2.giftCardProductPrice, selectors2.giftCardContainer).addClass("on-sale")) : ($(selectors2.giftCardProductPriceCompare, selectors2.giftCardContainer).addClass("d-none"), $(selectors2.giftCardProductPrice, selectors2.giftCardContainer).removeClass("on-sale"))) : ($(selectors2.giftCardProductPrice, selectors2.giftCardContainer).addClass("d-none"), $(selectors2.giftCardProductPriceCompare, selectors2.giftCardContainer).addClass("d-none")), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        updateProductAvaiable: function(variant) {
            var classActive = "product-avaiable--active",
                translations = wpbingo.strings;
            $(selectors2.giftCardAvaiable, selectors2.giftCardContainer).removeClass(classActive), variant ? (variant.available ? ($(selectors2.giftCardQty, selectors2.giftCardContainer).removeClass("d-none"), $(selectors2.giftCardAvaiableInStock, selectors2.giftCardContainer).addClass(classActive)) : ($(selectors2.giftCardQty, selectors2.giftCardContainer).addClass("d-none"), $(selectors2.giftCardAvaiableOutStock, selectors2.giftCardContainer).addClass(classActive)), variant.available ? ($(selectors2.giftCardContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", !1), $(selectors2.giftCardContainer).find(".btn--add-to-cart .btn__text").html(translations.addToCart)) : ($(selectors2.giftCardContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0), $(selectors2.giftCardContainer).find(".btn--add-to-cart .btn__text").html(translations.soldOut))) : ($(selectors2.giftCardQty, selectors2.giftCardContainer).addClass("d-none"), $(selectors2.giftCardContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0), $(selectors2.giftCardContainer).find(".btn--add-to-cart .btn__text").html(translations.unavailable))
        },
        updateDetailsLink: function(variant) {
            if (variant) {
                var productURL = $(selectors2.giftCardProductDetailsURL, selectors2.giftCardContainer).data("url") + "?variant=" + variant.id;
                $(selectors2.giftCardProductDetailsURL, selectors2.giftCardContainer).removeClass("d-none").attr("href", productURL)
            } else $(selectors2.giftCardProductDetailsURL, selectors2.giftCardContainer).addClass("d-none")
        },
        onVariantChange: function() {
            var variant = this.getVariantFromOptions();
            if ($("[data-single-option-button]", selectors2.giftCardContainer).length && (this.updateVariantsButton(), !variant || !variant.available)) {
                this.updateVariantsButtonDisabed();
                return
            }
            this.updateMasterSelect(variant), this.updateMedia(variant), this.updatePrice(variant), this.updateProductAvaiable(variant), this.updateDetailsLink(variant), this.currentVariant = variant
        },
        show: function() {
            $(selectors2.body).addClass("giftcard-active"), $(selectors2.GiftCard).addClass("show"), setTimeout(function() {
                $(".gift_card-container .gift_card__content").addClass("show")
            }, 400)
        },
        hide: function() {
            $(selectors2.giftCardContainer).html(), $(selectors2.body).removeClass("giftcard-active"), $(".gift_card-container .gift_card__content").removeClass("show"), setTimeout(function() {
                $(selectors2.GiftCard).removeClass("show")
            }, 400)
        }
    }), GiftCard
}(), wpbingo.update_variant_cartpage = function() {
    var selectors2 = {
        body: "body",
        EditVariant: "[data-edit_variant-cart]",
        EditVariantTemplate: "#edit_variants-template",
        EditVariantBtn: ".cart-product-edit_variant",
        EditVariantContainer: "[data-edit_variant-cart-container]",
        EditVariantClose: "[data-edit_variant-cart-close]",
        EditVariantImages: "[data-edit_variant-images]",
        EditVariantVariant: ".js-edit_variant-option-selector",
        originalSelectorId: "[data-edit_variant-variant]",
        EditVariantProductPrice: ".js-edit_variant-product-price",
        EditVariantProductPriceCompare: ".js-edit_variant-product-price-compare",
        EditVariantQty: "[data-edit_variant-quantity]",
        EditVariantAvaiable: ".product-avaiable",
        EditVariantAvaiableInStock: ".product-avaiable--instock",
        EditVariantAvaiableOutStock: ".product-avaiable--outstock",
        EditVariantDetailsURL: ".js-qv-product-details"
    };

    function EditVariant(container2) {
        this.$container = $(container2), this.cache = {}, this.productVariants = [], this.currentVariant = {}, this.cacheSelectors(), this.initializeEvents()
    }
    return EditVariant.prototype = _.assignIn({}, EditVariant.prototype, {
        cacheSelectors: function() {
            this.cache = {
                $body: $("body"),
                $EditVariantContainer: this.$container.find(selectors2.EditVariantContainer)
            }
        },
        initializeEvents: function() {
            var $this = this;
            $(selectors2.body).on("click", selectors2.EditVariantBtn, function(e) {
                e.preventDefault();
                var productHandle = $(this).data("handle"),
                    qty = $(this).data("value"),
                    line = $(this).data("line"),
                    id_variant = $(this).data("id_variant"),
                    $parent = $(this).closest(".content-edit_variant-popup");
                $(this).addClass("load-edit_variant"), $(".image-popup", $parent).addClass("imagepopup_active"), $("body").addClass("editv_overlay-layer"), $.getJSON("/products/" + productHandle + ".js", function(product) {
                    product.available ? $this.firstAvailableVariant(product.variants, $this) : $this.currentVariant = product.variants[0], $(selectors2.EditVariantBtn).removeClass("load-edit_variant"), $this.buildEditVariant(product, qty, line, id_variant);
                    var $element2 = $(".edit_variant-cart-container .content_product_detail .variants-wrapper");
                    $($element2).each(function() {
                        var $this2 = $(this),
                            value = $("input:checked", $this2).attr("value");
                        $(".variants__label span", $this2).html(value)
                    }), $(selectors2.EditVariantContainer).on("change", selectors2.EditVariantVariant, function(e2) {
                        $this.onVariantChange(id_variant)
                    }), $(window).width() < 767, $(selectors2.EditVariant).addClass("transform")
                })
            }), $(selectors2.body).on("click", selectors2.EditVariantClose, function(e) {
                $(window).width() < 767 ? ($(selectors2.EditVariant).removeClass("transform"), $("body").removeClass("editv_overlay-layer"), setTimeout(function() {
                    $("[data-edit_variant-cart-container]").empty()
                }, 300)) : ($(selectors2.EditVariant).removeClass("transform"), setTimeout(function() {
                    $("body").removeClass("editv_overlay-layer"), $("[data-edit_variant-cart-container]").empty()
                }, 300))
            }), $(selectors2.body).on("click", function(e) {
                $(e.target).is("body.editv_overlay-layer") && ($(window).width() < 767 ? ($(selectors2.EditVariant).removeClass("transform"), $("body").removeClass("editv_overlay-layer"), setTimeout(function() {
                    $("[data-edit_variant-cart-container]").empty()
                }, 300)) : ($(selectors2.EditVariant).removeClass("transform"), setTimeout(function() {
                    $("body").removeClass("editv_overlay-layer"), $("[data-edit_variant-cart-container]").empty()
                }, 300)))
            })
        },
        firstAvailableVariant: function(variants, global) {
            global.productVariants = variants;
            for (var i = 0; i < variants.length; i++) {
                var variant = variants[i];
                if (variant.available) {
                    global.currentVariant = variant;
                    break
                }
            }
        },
        buildEditVariant: function(product, qty, line, id_variant) {
            var moneyFormat2 = wpbingo.strings.moneyFormat,
                currentVariant = this.currentVariant;
            for (var key in product.variants)
                if (id_variant == product.variants[key].id) var currentVariant = product.variants[key];
            var source = $(selectors2.EditVariantTemplate).html(),
                template = Handlebars.compile(source),
                images = "",
                price = "",
                external = "",
                qvObject = {
                    id: product.id
                };
            if (typeof product.media < "u") {
                images += '<div class="edit_variant-images__list slick-carousel" data-edit_variant-images>';
                for (var i = 0; i < product.media.length; i++) {
                    var media = product.media[i];
                    media.media_type === "image" && (i == 0 ? images += '<div class="slick-carousel__item show"><div class="edit_variant-images__item" data-media-id=' + media.id + '><img class="img-fluid" alt="' + product.title + '" src="' + media.src + '" /></div></div>' : images += '<div class="slick-carousel__item"><div class="edit_variant-images__item" data-media-id=' + media.id + '><img class="img-fluid" alt="' + product.title + '" src="' + media.src + '" /></div></div>')
                }
                images += "</div>"
            }
            qvObject.variantID = currentVariant.id, qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== "" ? currentVariant.sku : "N/A", qvObject.images = images, qvObject.title = product.title, qvObject.qty = qty, qvObject.line = line, qvObject.url = product.url, price += '<div class="price-container">';
            var productCompareClass = product.compare_at_price !== null ? "" : "d-none";
            price += '<div class="js-edit_variant-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + wpbingo.Currency.formatMoney(product.compare_at_price, moneyFormat2) + "</div>", price += '<div class="js-edit_variant-product-price product-single__price">' + wpbingo.Currency.formatMoney(product.price, moneyFormat2) + "</div>", price += '</div">', qvObject.price = price, qvObject.variants = this.buildVariant(product, id_variant), $(selectors2.EditVariantContainer).html(template(qvObject)), this.updateMedia(currentVariant), this.updateDetailsLink(currentVariant), $("#form-edit_variants-addtocart .btn--add-to-cart").on("click", function(e) {
                e.preventDefault();
                var $parent = $(this).closest(".product-edit_variants");
                $(this).removeClass("added"), $(this).addClass("active");
                let addToCartForm = document.querySelector("#form-edit_variants-addtocart");
                var params = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: new FormData(addToCartForm),
                    processData: !1,
                    contentType: !1,
                    dataType: "json",
                    success: function(cart) {
                        var line2 = $parent.data("line") + 1;
                        $("#form-edit_variants-addtocart .btn--add-to-cart").removeClass("active"), $("#form-edit_variants-addtocart .btn--add-to-cart").addClass("added"), setTimeout(function() {
                            $("#form-edit_variants-addtocart .btn--add-to-cart").removeClass("added")
                        }, 2e3), ShopifyAPI.changeItem(line2, 0), setTimeout(function() {
                            ajaxCart.load()
                        }, 300), $("body").hasClass("template-cart") && setTimeout(function() {
                            ajaxCartPage.load()
                        }, 300), setTimeout(function() {
                            $(window).width() < 767 ? ($(selectors2.EditVariant).removeClass("is-visible"), $("body").removeClass("editv_overlay-layer"), setTimeout(function() {
                                $("[data-edit_variant-cart-container]").empty()
                            }, 300)) : ($(selectors2.EditVariant).removeClass("is-visible"), setTimeout(function() {
                                $(selectors2.EditVariant).removeClass("transform")
                            }, 500), setTimeout(function() {
                                $("body").removeClass("editv_overlay-layer"), $("[data-edit_variant-cart-container]").empty()
                            }, 700))
                        }, 500)
                    },
                    error: function(XMLHttpRequest2, textStatus) {
                        typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus) : ShopifyAPI.onError(XMLHttpRequest2, textStatus)
                    }
                };
                jQuery.ajax(params)
            }), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        convertToSlug: function(str) {
            return str.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        buildVariant: function(product, id_variant) {
            var result = "",
                currentVariant = this.currentVariant;
            for (var key in product.variants)
                if (id_variant == product.variants[key].id) var currentVariant = product.variants[key];
            if (product.options[0].name !== "Title")
                for (var options = product.options, i = 0; i < options.length; i++) {
                    var option = options[i],
                        optionIndex = i + 1,
                        type = "label";
                    wpbingo.settings.filter_name_1 === option.name ? type = wpbingo.settings.select_filter_1 : wpbingo.settings.filter_name_2 === option.name ? type = wpbingo.settings.select_filter_2 : wpbingo.settings.filter_name_3 === option.name && (type = wpbingo.settings.select_filter_3), result += '<div class="variants-wrapper product-form__item ' + type + '" data-edit_variants-variant-option="' + optionIndex + '">', result += '<label class="variants__label">' + option.name + ": <span></span></label>", result += '<div class="variants__options">';
                    for (var j = 0; j < option.values.length; j++) {
                        for (var value = option.values[j], isDisable = !0, colorAttribute = "", k = 0; k < this.productVariants.length; k++) {
                            var variantCondition = this.productVariants[k];
                            if (variantCondition.available) {
                                if (i == 0 && variantCondition.option1 === value) {
                                    isDisable = !1;
                                    break
                                } else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
                                    isDisable = !1;
                                    break
                                } else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
                                    isDisable = !1;
                                    break
                                }
                            }
                        }
                        result += '<div class="single-option-selector">', result += '<input type="radio" data-single-option-button', result += currentVariant.options[i] === value ? " checked " : " ", isDisable && (result += 'disabled="disabled"'), result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ', result += 'class="js-edit_variant-option-selector', isDisable && (result += " disabled"), result += '" id="edit_variants-product-option-' + i + "-" + value.toLowerCase() + '">', result += '<label class="' + value + '" data-toggle="tooltip" title="' + value + '" for="edit_variants-product-option-' + i + "-" + value.toLowerCase() + '" ' + colorAttribute, isDisable && (result += ' class="disabled"'), result += ">" + value + '<span class="tool-tip">' + value + "</span></label>", result += "</div>"
                    }
                    result += "</div>", result += "</div>"
                }
            return result
        },
        createImageCarousel: function(product) {
            product.media.length > 1 && $(selectors2.EditVariant).find(selectors2.EditVariantImages).slick({
                infinite: !1,
                rows: 0,
                fade: !0,
                rtl: wpbingo.rtl_slick()
            })
        },
        getCurrentOptions: function() {
            var currentOptions = _.map($(selectors2.EditVariantVariant, selectors2.EditVariantContainer), function(element) {
                var $element2 = $(element),
                    type = $element2.attr("type"),
                    currentOption = {};
                return type === "radio" || type === "checkbox" ? $element2[0].checked ? (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption) : !1 : (currentOption.value = $element2.val(), currentOption.index = $element2.data("index"), currentOption)
            });
            return currentOptions = _.compact(currentOptions), currentOptions
        },
        getVariantFromOptions: function() {
            var selectedValues = this.getCurrentOptions(),
                variants = this.productVariants,
                found = _.find(variants, function(variant) {
                    return selectedValues.every(function(values) {
                        return _.isEqual(variant[values.index], values.value)
                    })
                });
            return found
        },
        updateVariantsButton: function() {
            for (var selectedValues = this.getCurrentOptions(), variants = this.productVariants, i = 2; i <= 3; i++) $('[data-edit_variants-variant-option="' + i + '"]', selectors2.EditVariantContainer).length && $('[data-edit_variants-variant-option="' + i + '"] ' + selectors2.EditVariantVariant, selectors2.EditVariantContainer).each(function() {
                var $self = $(this),
                    optionValue = $self.val(),
                    foundIndex;
                i === 2 ? foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), selectedValues[0].value = selectedValues[0].value.toString(), variant.option2 = variant.option2.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === !0
                }) : i === 3 && (foundIndex = _.findIndex(variants, function(variant) {
                    return variant.option1 = variant.option1.toString(), variant.option2 = variant.option2.toString(), variant.option3 = variant.option3.toString(), selectedValues[0].value = selectedValues[0].value.toString(), selectedValues[1].value = selectedValues[1].value.toString(), optionValue = optionValue.toString(), variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value && variant.option3 === optionValue && variant.available === !0
                })), foundIndex !== -1 ? ($self.removeAttr("disabled", "disabled").removeClass("disabled"), $self.next("label").removeClass("disabled")) : ($self.attr("disabled", "disabled").addClass("disabled"), $self.next("label").addClass("disabled"))
            })
        },
        updateVariantsButtonDisabed: function() {
            for (var i = 2; i <= 3; i++)
                if ($('[data-edit_variants-variant-option="' + i + '"]', selectors2.EditVariantContainer).length) {
                    var isUpdate = !1;
                    $('[data-edit_variants-variant-option="' + i + '"] ' + selectors2.EditVariantVariant, selectors2.EditVariantContainer).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if ((type === "radio" || type === "checkbox") && this.checked && $element2.hasClass("disabled")) return $element2.prop("checked", !1), isUpdate = !0, !1
                    }), $('[data-edit_variants-variant-option="' + i + '"] ' + selectors2.EditVariantVariant, selectors2.EditVariantContainer).each(function() {
                        var $element2 = $(this),
                            type = $element2.attr("type");
                        if (isUpdate && (type === "radio" || type === "checkbox") && !$element2.hasClass("disabled")) return $element2.prop("checked", !0), isUpdate = !1, $element2.trigger("change"), !1
                    })
                }
        },
        updateMasterSelect: function(variant) {
            variant && $(selectors2.originalSelectorId, selectors2.EditVariantContainer).val(variant.id)
        },
        updateLabelvariant: function(variant) {
            var $element2 = $(".edit_variant-cart-container .content_product_detail .variants-wrapper");
            $($element2).each(function() {
                var $this = $(this),
                    value = $("input:checked", $this).attr("value");
                $(".variants__label span", $this).html(value)
            })
        },
        updateMedia: function(variant) {
            variant && variant.featured_media && variant.featured_media.id && ($(".slick-carousel__item", selectors2.EditVariantContainer).removeClass("show"), $(selectors2.EditVariantImages, selectors2.EditVariantContainer).find(".edit_variant-images__item").each(function() {
                var imageID = $(this).data("media-id");
                if (variant.featured_media.id == imageID) {
                    $(this).closest(".slick-carousel__item").addClass("show");
                    var slickIndex = $(this).closest(".slick-carousel__item").data("slick-index");
                    slickIndex != null && $(selectors2.EditVariantImages, selectors2.EditVariantContainer).slick("slickGoTo", slickIndex)
                }
            }))
        },
        updatePrice: function(variant) {
            var moneyFormat2 = wpbingo.strings.moneyFormat;
            variant ? ($(selectors2.EditVariantProductPrice, selectors2.EditVariantContainer).removeClass("d-none"), $(selectors2.EditVariantProductPriceCompare, selectors2.EditVariantContainer).removeClass("d-none"), $(selectors2.EditVariantProductPrice, selectors2.EditVariantContainer).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat2)), variant.compare_at_price > variant.price ? ($(selectors2.EditVariantProductPriceCompare, selectors2.EditVariantContainer).html(wpbingo.Currency.formatMoney(variant.compare_at_price, moneyFormat2)).removeClass("d-none"), $(selectors2.EditVariantProductPrice, selectors2.EditVariantContainer).addClass("on-sale")) : ($(selectors2.EditVariantProductPriceCompare, selectors2.EditVariantContainer).addClass("d-none"), $(selectors2.EditVariantProductPrice, selectors2.EditVariantContainer).removeClass("on-sale"))) : ($(selectors2.EditVariantProductPrice, selectors2.EditVariantContainer).addClass("d-none"), $(selectors2.EditVariantProductPriceCompare, selectors2.EditVariantContainer).addClass("d-none")), $(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
        },
        updateProductAvaiable: function(variant) {
            var classActive = "product-avaiable--active",
                translations = wpbingo.strings;
            $(selectors2.EditVariantAvaiable, selectors2.EditVariantContainer).removeClass(classActive), variant ? (variant.available ? ($(selectors2.EditVariantQty, selectors2.EditVariantContainer).removeClass("d-none"), $(selectors2.EditVariantAvaiableInStock, selectors2.EditVariantContainer).addClass(classActive)) : ($(selectors2.EditVariantQty, selectors2.EditVariantContainer).addClass("d-none"), $(selectors2.EditVariantAvaiableOutStock, selectors2.EditVariantContainer).addClass(classActive)), variant.available ? ($(selectors2.EditVariantContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", !1), $(selectors2.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(translations.addToCart)) : ($(selectors2.EditVariantContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0), $(selectors2.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(translations.soldOut))) : ($(selectors2.EditVariantQty, selectors2.EditVariantContainer).addClass("d-none"), $(selectors2.EditVariantContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", !0), $(selectors2.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(translations.unavailable))
        },
        updateDetailsLink: function(variant) {
            if (variant) {
                var productURL = $(selectors2.EditVariantDetailsURL, selectors2.EditVariantContainer).data("url") + "?variant=" + variant.id;
                $(selectors2.EditVariantDetailsURL, selectors2.EditVariantContainer).removeClass("d-none").attr("href", productURL)
            } else $(selectors2.EditVariantDetailsURL, selectors2.EditVariantContainer).addClass("d-none")
        },
        onVariantChange: function(id_variant) {
            var variant = this.getVariantFromOptions();
            if ($("[data-single-option-button]", selectors2.EditVariantContainer).length && (this.updateVariantsButton(), !variant || !variant.available)) {
                this.updateVariantsButtonDisabed();
                return
            }
            setTimeout(function() {
                variant.id != id_variant ? $(".btn--add-to-cart", selectors2.EditVariantContainer).prop("disabled", !1) : $(".btn--add-to-cart", selectors2.EditVariantContainer).prop("disabled", !0)
            }, 100), this.updateMasterSelect(variant), this.updateLabelvariant(variant), this.updateMedia(variant), this.updatePrice(variant), this.updateProductAvaiable(variant), this.updateDetailsLink(variant), this.currentVariant = variant
        }
    }), EditVariant
}();
var ajaxCartPage = function(module2, $2) {
    "use strict";
    var init2, loadCart2, settings2, isUpdating2, $body2, $formContainer2, $cartCountSelector2, $cartCostSelector2, $cartContainer2, initializeEvents2, updateCountPrice2, itemAddedCallback2, itemErrorCallback2, cartUpdateCallback2, buildCart2, cartCallback2, adjustCart2, adjustCartCallback2, validateQty2;
    return init2 = function(options) {
        settings2 = {
            cartContainer: "[data-cartpage-container]",
            cartCostSelector: ".cart-total__subtotal-price",
            cartRemoveSelector: ".cart-product-info__btn--remove",
            moneyFormat: "${{amount}}",
            disableAjaxCart: !1,
            cartTemplate: "#cart-form-template"
        }, wpbingo.strings.moneyFormat !== void 0 && (settings2.moneyFormat = wpbingo.strings.moneyFormat), $2.extend(settings2, options), $cartContainer2 = $2(settings2.cartContainer), $cartCostSelector2 = $2(settings2.cartCostSelector), $body2 = $2("body"), isUpdating2 = !1, initializeEvents2(), adjustCart2()
    }, initializeEvents2 = function() {
        $body2.on("click", settings2.cartRemoveSelector, function(e) {
            if (e.preventDefault(), !isUpdating2) {
                var $el = $2(this),
                    line = $el.data("line");
                line && ($2('.item-cart[data-line="' + line + '"]').addClass("is-loading"), isUpdating2 = !0, setTimeout(function() {
                    ShopifyAPI.changeItem(line, 0, adjustCartCallback2)
                }, 250))
            }
        })
    }, loadCart2 = function() {
        ShopifyAPI.getCart(cartUpdateCallback2)
    }, updateCountPrice2 = function(cart) {
        $cartCostSelector2 && $cartCostSelector2.html(wpbingo.Currency.formatMoney(cart.total_price, settings2.moneyFormat))
    }, cartUpdateCallback2 = function(cart, added) {
        updateCountPrice2(cart), buildCart2(cart), cart.item_count > 0 ? ($2(".page-cart .content-cart_page").removeClass("hidden"), $2(".page-cart .page-cart__header").removeClass("hidden"), $2(".page-cart .page-cart-empty").addClass("hidden")) : ($2(".page-cart .content-cart_page").addClass("hidden"), $2(".page-cart .page-cart__header").addClass("hidden"), $2(".page-cart .page-cart-empty").removeClass("hidden"))
    }, buildCart2 = function(cart, edit_variant) {
        if ($cartContainer2.empty(), cart.item_count === 0) {
            $cartContainer2.append('<p class="cart-empty-message">' + wpbingo.strings.cartEmpty + `</p>
<p class="cookie-message">` + wpbingo.strings.cartCookies + "</p>"), cartCallback2(cart), $2(".js-drawer .drawer__title .count").text("0"), $2(".shipping-bar-cart").addClass("hidden");
            return
        }
        var items = [],
            item = {},
            data2 = {},
            source = $2(settings2.cartTemplate).html(),
            template = Handlebars.compile(source);
        if ($2.each(cart.items, function(index, cartItem) {
                var prodImg2, unitPrice = null,
                    disabled = "",
                    variant_id = cartItem.variant_id,
                    count = $2('#count_quantity [data-variant_id="' + variant_id + '"]').data("count_quantity");
                if (cartItem.quantity == count && (disabled = "disabled"), cartItem.image !== null ? prodImg2 = cartItem.image.replace(/(\.[^.]*)$/, "_120x$1").replace("http:", "") : prodImg2 = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif", cartItem.properties !== null && $2.each(cartItem.properties, function(key, value) {
                        (key.charAt(0) === "_" || !value) && delete cartItem.properties[key]
                    }), cartItem.properties !== null && $2.each(cartItem.properties, function(key, value) {
                        (key.charAt(0) === "_" || !value) && delete cartItem.properties[key]
                    }), cartItem.line_level_discount_allocations.length !== 0)
                    for (var discount in cartItem.line_level_discount_allocations) {
                        var amount = cartItem.line_level_discount_allocations[discount].amount;
                        cartItem.line_level_discount_allocations[discount].formattedAmount = wpbingo.Currency.formatMoney(amount, settings2.moneyFormat)
                    }
                if (cart.cart_level_discount_applications.length !== 0)
                    for (var cartDiscount in cart.cart_level_discount_applications) {
                        var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
                        cart.cart_level_discount_applications[cartDiscount].formattedAmount = wpbingo.Currency.formatMoney(cartAmount, settings2.moneyFormat)
                    }
                cartItem.unit_price_measurement && (unitPrice = {
                    addRefererenceValue: cartItem.unit_price_measurement.reference_value !== 1,
                    price: wpbingo.Currency.formatMoney(cartItem.unit_price, settings2.moneyFormat),
                    reference_value: cartItem.unit_price_measurement.reference_value,
                    reference_unit: cartItem.unit_price_measurement.reference_unit
                }), item = {
                    key: cartItem.key,
                    line: index + 1,
                    url: cartItem.url,
                    img: prodImg2,
                    name: cartItem.product_title,
                    variation: cartItem.variant_title,
                    variant: cartItem.variant_title !== null,
                    options: cartItem.options_with_values,
                    variant_id: cartItem.variant_id,
                    price: wpbingo.Currency.formatMoney(cartItem.price, settings2.moneyFormat),
                    discountprice: wpbingo.Currency.formatMoney(cartItem.original_line_price, settings2.moneyFormat),
                    finalPrice: wpbingo.Currency.formatMoney(cartItem.final_line_price, settings2.moneyFormat),
                    handle: cartItem.handle,
                    properties: cartItem.properties,
                    itemAdd: cartItem.quantity + 1,
                    itemMinus: cartItem.quantity - 1,
                    itemQty: cartItem.quantity,
                    discounts: cartItem.line_level_discount_allocations,
                    discountsApplied: cartItem.line_level_discount_allocations.length !== 0,
                    vendor: cartItem.vendor,
                    unitPrice,
                    disabled
                }, items.push(item), wpbingo.discount_single()
            }), data2 = {
                items,
                note: cart.note,
                totalPrice: wpbingo.Currency.formatMoney(cart.total_price, settings2.moneyFormat),
                cartDiscounts: cart.cart_level_discount_applications,
                cartDiscountsApplied: cart.cart_level_discount_applications.length !== 0
            }, $cartContainer2.append(template(data2)), cartCallback2(cart), $2(".shipping-bar-cart").removeClass("hidden"), $2(".shipping-bar-cart").length) {
            var price_shipping_bar = $2(".shipping-bar-cart").data("price_shipping_bar");
            if (price_shipping_bar > cart.total_price && price_shipping_bar != 0) {
                var minus_spend = price_shipping_bar - cart.total_price,
                    spend = wpbingo.Currency.formatMoney(minus_spend, settings2.moneyFormat),
                    percent = cart.total_price / price_shipping_bar * 100;
                $2(".shipping-bar-cart .title-spend .spend").html(spend), $2(".shipping-bar-cart .shipping-progress").css("width", percent + "%"), $2(".shipping-bar-cart .title-shipping").addClass("hide"), $2(".shipping-bar-cart .title-spend").removeClass("hide"), $2(".shipping-bar-cart").removeClass("full"), $2(".shipping-bar-cart .shipping-progress").removeClass("fire-done"), $2("#fire_work").addClass("hide")
            } else $2(".shipping-bar-cart .title-shipping").removeClass("hide"), $2(".shipping-bar-cart .title-spend").addClass("hide"), $2(".shipping-bar-cart .shipping-progress").css("width", "100%"), $2(".shipping-bar-cart").addClass("full"), $2(".shipping-bar-cart .shipping-progress").hasClass("fire-done") || $2(".shipping-bar-cart .shipping-progress").addClass("fire"), $2(".shipping-bar-cart .shipping-progress").hasClass("fire") && ($2("#fire_work").removeClass("hide"), confettiLoop()), setTimeout(function() {
                $2(".shipping-bar-cart .shipping-progress").addClass("fire-done"), $2(".shipping-bar-cart .shipping-progress").removeClass("fire")
            }, 100), setTimeout(function() {
                $2("#fire_work").addClass("hide")
            }, 5e3)
        }
        $2(".page-cart .pre_order-cart >span").each(function() {
            var id = $2(this).data("handle");
            for (var i in data2.items) data2.items[i].variant_id == id && $2('.page-cart .item-cart[data-line="' + data2.items[i].line + '"] .pre_order').removeClass("hidden")
        }), $2(".bwp_currency").length > 0 && Currency.Currency_customer(!0)
    }, cartCallback2 = function(cart) {
        window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize()
    }, adjustCart2 = function() {
        $body2.on("click", "#cart-form .ajaxcart__qty-adjust", function() {
            if (!isUpdating2) {
                var $el = $2(this),
                    line = $el.data("line"),
                    $qtySelector = $el.siblings(".ajaxcart__qty-num"),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ""));
                qty = validateQty2(qty), $el.hasClass("ajaxcart__qty--plus") ? qty += 1 : (qty -= 1, qty <= 0 && (qty = 0)), line ? updateQuantity(line, qty) : $qtySelector.val(qty)
            }
        }), $body2.on("change", "#cart-form .ajaxcart__qty-num", function() {
            if (!isUpdating2) {
                var id = $2(this).data("variant_id"),
                    count = $2('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity"),
                    $el = $2(this),
                    line = $el.data("line"),
                    qty = parseInt($el.val().replace(/\D/g, ""));
                qty = validateQty2(qty), qty >= count && (qty = count, $el.val(qty)), line && updateQuantity(line, qty)
            }
        }), $body2.on("submit", "#cart-form ", function(evt) {
            isUpdating2 && evt.preventDefault()
        }), $body2.on("focus", "#cart-form .ajaxcart__qty-adjust", function() {
            var $el = $2(this);
            setTimeout(function() {
                $el.select()
            }, 50)
        });

        function updateQuantity(line, qty) {
            isUpdating2 = !0;
            var $row = $2('#cart-form .item-cart[data-line="' + line + '"]').addClass("is-loading");
            qty === 0 && $row.parent().addClass("is-removed"), setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback2)
            }, 250)
        }
    }, adjustCartCallback2 = function(cart) {
        updateCountPrice2(cart), ajaxCart.load(), setTimeout(function() {
            ShopifyAPI.getCart(buildCart2), isUpdating2 = !1, cart.item_count > 0 ? ($2(".page-cart .content-cart_page").removeClass("hidden"), $2(".page-cart .page-cart__header").removeClass("hidden"), $2(".page-cart .page-cart-empty").addClass("hidden")) : ($2(".page-cart .content-cart_page").addClass("hidden"), $2(".page-cart .page-cart__header").addClass("hidden"), $2(".page-cart .page-cart-empty").removeClass("hidden"))
        }, 150)
    }, validateQty2 = function(qty) {
        return parseFloat(qty) === parseInt(qty) && !isNaN(qty) || (qty = 1), qty
    }, module2 = {
        init: init2,
        load: loadCart2
    }, module2
}(ajaxCartPage || {}, jQuery);
wpbingo.ajax_cartpage = function() {
    $("body").hasClass("template-cart") && (ajaxCartPage.init(), ajaxCartPage.load())
}, wpbingo.ajax_blogpage = function() {
    var ajaxBreadcrumbs, ajaxPaging, ajaxPagingportfolio, ajaxLoadMore, ajaxLoadMoreportfolio, ajaxSidebar, init2 = function() {
        ajaxPaging(), ajaxPagingportfolio(), ajaxLoadMore(), ajaxLoadMoreportfolio(), ajaxBreadcrumbs(), ajaxSidebar()
    };
    return ajaxLoadMore = function() {
        $(".page-blog .pagination-ajax-blog-loadmore").length && $(".page-blog .pagination-ajax-blog-loadmore").on("click", "a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href"),
                newTitle = $(this).attr("title"),
                URL_array = $(this).attr("href").match(/page=\d+/g),
                curret = parseInt(URL_array[0].match(/\d+/g));
            $(this).addClass("active"), $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            });
            var offset = $(this).offset().top;
            pageURL && $.ajax({
                type: "get",
                url: pageURL,
                success: function(data2) {
                    document.title = newTitle, $(".page-blog .article__list").append($(data2).find(".page-blog .article__list").html()), $(".page-blog .pagination-ajax-blog-loadmore").replaceWith($(data2).find(".page-blog .pagination-ajax-blog-loadmore")), $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }), $("body,html").animate({
                        scrollTop: offset
                    }, 600), setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }), $("#pre-loading").removeClass("load-product")
                    }, 500), ajaxBreadcrumbs(), ajaxSidebar(), ajaxLoadMore(), wpbingo.christmas_snow(), $(this).removeClass("active")
                },
                error: function(xhr, text) {
                    console.log(text)
                }
            })
        })
    }, ajaxPaging = function() {
        $(".page-blog .pagination-ajax-blog").length && $(".page-blog .pagination-ajax-blog").on("click", "a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href"),
                newTitle = $(this).closest(".pagination-ajax-blog").attr("title");
            History.pushState({
                param: Shopify.queryParams
            }, pageURL, pageURL), $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }), pageURL && $.ajax({
                type: "get",
                url: pageURL,
                success: function(data2) {
                    document.title = newTitle, $(".page-blog").replaceWith($(data2).find(".page-blog")), $("body,html").animate({
                        scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                    }, 600), $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }), setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }), $("#pre-loading").removeClass("load-product")
                    }, 500), ajaxBreadcrumbs(), ajaxSidebar(), ajaxPaging()
                },
                error: function(xhr, text) {
                    console.log(text)
                }
            })
        })
    }, ajaxLoadMoreportfolio = function() {
        $(".page-portfolio .pagination-ajax-blog-loadmore").length && $(".page-portfolio .pagination-ajax-blog-loadmore").on("click", "a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href"),
                newTitle = $(this).attr("title"),
                URL_array = $(this).attr("href").match(/page=\d+/g),
                curret = parseInt(URL_array[0].match(/\d+/g));
            $(this).addClass("active"), $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }), pageURL && $.ajax({
                type: "get",
                url: pageURL,
                success: function(data2) {
                    document.title = newTitle, $(".page-portfolio .article__list").append($(data2).find(".page-portfolio .article__list").html()), $(".page-portfolio .pagination-ajax-blog-loadmore").replaceWith($(data2).find(".page-portfolio .pagination-ajax-blog-loadmore")), $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }), setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }), $("#pre-loading").removeClass("load-product")
                    }, 500), ajaxBreadcrumbs(), ajaxLoadMoreportfolio(), wpbingo.christmas_snow(), $(this).removeClass("active")
                },
                error: function(xhr, text) {
                    console.log(text)
                }
            })
        })
    }, ajaxPagingportfolio = function() {
        $(".page-portfolio .pagination-ajax-blog").length && $(".page-portfolio .pagination-ajax-blog").on("click", "a", function(e) {
            e.preventDefault();
            var pageURL = $(this).attr("href"),
                newTitle = $(this).closest(".pagination-ajax-blog").attr("title");
            History.pushState({
                param: Shopify.queryParams
            }, pageURL, pageURL), $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                width: "40%"
            }), pageURL && $.ajax({
                type: "get",
                url: pageURL,
                success: function(data2) {
                    document.title = newTitle, $(".page-portfolio").replaceWith($(data2).find(".page-portfolio")), $("body,html").animate({
                        scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                    }, 600), $("#pre-loading .pre-loading__bar").css({
                        width: "100%"
                    }), setTimeout(function() {
                        $("#pre-loading .pre-loading__bar").css({
                            width: "0"
                        }), $("#pre-loading").removeClass("load-product")
                    }, 500), ajaxBreadcrumbs(), ajaxPagingportfolio()
                },
                error: function(xhr, text) {
                    console.log(text)
                }
            })
        })
    }, ajaxBreadcrumbs = function() {
        if ($(".wpbingo-breadcrumbs .wpbingo-blog-list").length) {
            var $categories_blog = $(".wpbingo-blog-list");
            $($categories_blog).on("click", "a", function(e) {
                e.preventDefault();
                var pageURL = $(this).attr("href"),
                    newTitle = $(this).attr("title");
                $(this).closest(".item-blog").addClass("active"), History.pushState({
                    param: Shopify.queryParams
                }, pageURL, pageURL), delete Shopify.queryParams.page, $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                    width: "40%"
                }), $.ajax({
                    type: "get",
                    url: pageURL,
                    success: function(data2) {
                        document.title = newTitle, $(".page-blog").replaceWith($(data2).find(".page-blog")), $(".page-portfolio").replaceWith($(data2).find(".page-portfolio")), $(".wpbingo-breadcrumbs .wpbingo-blog-list").replaceWith($(data2).find(".wpbingo-breadcrumbs .wpbingo-blog-list")), $("#pre-loading .pre-loading__bar").css({
                            width: "100%"
                        }), setTimeout(function() {
                            $("#pre-loading .pre-loading__bar").css({
                                width: "0"
                            }), $("#pre-loading").removeClass("load-product")
                        }, 500), ajaxBreadcrumbs(), ajaxSidebar(), ajaxPaging(), ajaxPagingportfolio(), ajaxLoadMore(), ajaxLoadMoreportfolio()
                    },
                    error: function(xhr, text) {
                        console.log(text)
                    }
                }), $("body,html").animate({
                    scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                }, 600)
            })
        }
    }, ajaxSidebar = function() {
        if ($(".page-blog .blog-sidebar .list-category").length) {
            var $categories_blog = $(".blog-sidebar .list-category");
            $($categories_blog).on("click", "a", function(e) {
                e.preventDefault();
                var pageURL = $(this).attr("href"),
                    newTitle = $(this).attr("title");
                $(this).closest("li").addClass("active"), History.pushState({
                    param: Shopify.queryParams
                }, pageURL, pageURL), delete Shopify.queryParams.page, $("#pre-loading").addClass("load-product"), $("#pre-loading .pre-loading__bar").css({
                    width: "40%"
                }), $.ajax({
                    type: "get",
                    url: pageURL,
                    success: function(data2) {
                        document.title = newTitle, $(".page-blog").replaceWith($(data2).find(".page-blog")), $(".wpbingo-breadcrumbs .wpbingo-blog-list").replaceWith($(data2).find(".wpbingo-breadcrumbs .wpbingo-blog-list")), $("#pre-loading .pre-loading__bar").css({
                            width: "100%"
                        }), setTimeout(function() {
                            $("#pre-loading .pre-loading__bar").css({
                                width: "0"
                            }), $("#pre-loading").removeClass("load-product")
                        }, 500), ajaxBreadcrumbs(), ajaxSidebar(), ajaxPaging(), ajaxLoadMore()
                    },
                    error: function(xhr, text) {
                        console.log(text)
                    }
                }), $("body,html").animate({
                    scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height()
                }, 600)
            })
        }
    }, init2
}(), /*wpbingo.checkbox_terms_conditions = function() {
    $(".ajaxcart_terms_conditions").length > 0 && ($(".agree_terms_conditions").is(":checked") ? $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !1) : $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !0), setTimeout(function() {
        $(".agree_terms_conditions").is(":checked") ? $('[data-shopify="payment-button"] button').prop("disabled", !1) : $('[data-shopify="payment-button"] button').prop("disabled", !0)
    }, 1e3), $("body").on("click", ".agree_terms_conditions", function() {
        $(this).is(":checked") ? ($("body").find(".agree_terms_conditions").each(function() {
            $(this).attr("checked", "checked")
        }), $('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !1)) : ($("body").find(".agree_terms_conditions").each(function() {
            $(this).removeAttr("checked")
        }), $('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !0))
    }), $(".content_terms_conditions [data-close-terms_conditions]").on("click", function(e) {
        $(".content_terms_conditions").removeClass("show"), setTimeout(function() {
            $(".content_terms_conditions").removeClass("active")
        }, 300)
    }), $(".ajaxcart_terms_conditions a").on("click", function(e) {
        e.preventDefault(), $(".content_terms_conditions").addClass("active"), setTimeout(function() {
            $(".content_terms_conditions").addClass("show")
        }, 300)
    }))
}*/
  wpbingo.checkbox_terms_conditions = function() {
    if ($(".ajaxcart_terms_conditions").length === 0) return;

    function allChecked() {
        return $(".agree_terms_conditions").length === $(".agree_terms_conditions:checked").length;
    }

    function updateButtons() {
        var enabled = allChecked();
        $('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop("disabled", !enabled);
    }

    // Estado inicial
    updateButtons();
    setTimeout(updateButtons, 1000);

    // Al hacer click en cualquier checkbox
    $("body").on("click", ".agree_terms_conditions", function() {
        updateButtons();
    });

    $(".content_terms_conditions [data-close-terms_conditions]").on("click", function(e) {
        $(".content_terms_conditions").removeClass("show");
        setTimeout(function() {
            $(".content_terms_conditions").removeClass("active");
        }, 300);
    });

    $(".ajaxcart_terms_conditions a").on("click", function(e) {
        e.preventDefault();
        $(".content_terms_conditions").addClass("active");
        setTimeout(function() {
            $(".content_terms_conditions").addClass("show");
        }, 300);
    });
}, wpbingo.check_width_megamenu = function() {
    $(".menu-dropdown__content--megamenu.width_custom_pos").length > 0 && $(".menu-dropdown__content--megamenu.width_custom_pos").each(function() {
        var left = $(this).offset().left,
            width_left = $(this).width() + left,
            $parent = $(this).closest(".menu-dropdown--mega");
        $parent.addClass("position-relative"), width_left >= $(window).width() && $parent.addClass("width_custom_pos_right")
    })
}, wpbingo.slick_mobile = function() {
    $(window).width() < 767 && $(".bwp-load-slick-mobile").each(function() {
        $(this).slick({
            infinite: !0,
            slidesToShow: $(this).data("col1"),
            slidesToScroll: $(this).data("col1"),
            arrows: $(this).data("nav"),
            dots: $(this).data("dot"),
            autoplay: $(this).data("autoplay"),
            autoplaySpeed: 5e3,
            rtl: wpbingo.rtl_slick(),
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: $(this).data("col2"),
                    slidesToScroll: $(this).data("col2")
                }
            }]
        })
    })
}, wpbingo.accordion_footer = function() {
    $(".footer-center").hasClass("accordion") && $(window).width() < 767 && $(".accordion .content-toggle").each(function() {
        var toggle = $(".footer-block", $(this));
        $(".title-footer", $(this)).on("click", function() {
            var $parent = $(this).closest(".content-toggle");
            $parent.toggleClass("active"), toggle.slideToggle()
        })
    })
}, wpbingo.product_tab = function() {
    $(".wpbingo-section--product-tabs-grid").length > 0 && $(".wpbingo-section--product-tabs-grid .product-tabs__nav-link").each(function() {
        $(this).on("click", function() {
            var $parent = $(this).closest(".menu-dropdown"),
                $text = $(this).text();
            $("span", $parent).text($text)
        })
    })
}, wpbingo.banner_video = function() {
    $(".wpbingo--button-video").length > 0 && ($(".wpbingo--button-video .button-video").each(function() {
        $(this).on("click", function() {
            var $parent = $(this).closest(".wpbingo--button-video");
            $(".video-wrapper", $parent).addClass("active"), setTimeout(function() {
                $(".video-wrapper", $parent).addClass("show")
            }, 100)
        })
    }), $(".wpbingo--button-video .close-video").each(function() {
        $(this).on("click", function() {
            var $parent = $(this).closest(".wpbingo--button-video");
            setTimeout(function() {
                $(".video-wrapper", $parent).removeClass("active")
            }, 300), $(".video-wrapper", $parent).removeClass("show")
        })
    }))
}, wpbingo.christmas_snow = function() {
    if ($(".frame-snow").length > 0) {
        let create_flake2 = function() {
                var snow_flake = '<div class="snow" style="left:' + random_num1 + "%;transform:scale(" + random_num2 / 50 + "); animation-duration:" + random_num3 + 's"><img src="' + flake + '" /></div>';
                $(snow_flake).appendTo(".frame-snow")
            },
            destroy_flake2 = function() {
                snow = $(".frame-snow .snow"), snow.each(function() {
                    snow_y = $(this).offset().top, snow_x = $(this).offset().left, snow_y > doc_height + 200 && $(this).remove(), snow_x > doc_width + 200 && $(this).remove()
                })
            };
        var create_flake = create_flake2,
            destroy_flake = destroy_flake2,
            flake = window.routes.svg_christmas,
            random_num1, random_num2, random_num3, snow, snow_x, snow_y, doc_height, doc_width, interval, wind;
        doc_height = $(document).height(), doc_width = $(document).width(), wind = 0, $(window).resize(function() {
            doc_height = $(document).height(), doc_width = $(document).width()
        }), $(".frame-snow").css({
            height: doc_height + "px"
        }), interval = setInterval(function() {
            random_num1 = Math.round(Math.random() * 100), random_num2 = Math.round(Math.random() * 100), random_num3 = Math.floor(Math.random() * 30) + Math.round(doc_height / 1e3), create_flake2()
        }, 100), interval = setInterval(function() {
            doc_height = $(document).height(), destroy_flake2()
        }, 10)
    }
}, wpbingo.address_delete = function() {
    $(".address-delete").on("click", function() {
        var $el = $(this),
            target = $el.data("target"),
            confirmMessage = $el.data("confirm-message");
        confirm(confirmMessage || "Are you sure you wish to delete this address?") && Shopify.postLink(target, {
            parameters: {
                _method: "delete"
            }
        })
    })
}, wpbingo.change_head = function() {
    if (wpbingo.settings.show_come_back) {
        let change_in2 = function() {
            change_out1 = function() {}, change_out2 = function() {}, $("#before-you-leave").length > 0 && !$("#before-you-leave").hasClass("active") && !$("#before-you-leave").hasClass("hiden") && $("#before-you-leave").addClass("hiden"), $(document).attr("title", title)
        };
        var change_in = change_in2,
            title = $(document).attr("title");
        if ($("#before-you-leave").length > 0) var data_time = $("#before-you-leave").data("time"),
            time = data_time * 60 * 1e3;
        document.addEventListener("visibilitychange", function(event) {
            document.hidden ? (change_out2 = function() {
                $(document).attr("title", wpbingo.strings.come_back), setTimeout(function() {
                    change_out1()
                }, 500)
            }, change_out1 = function() {
                $(document).attr("title", wpbingo.strings.forget), setTimeout(function() {
                    change_out2()
                }, 500)
            }, $("#before-you-leave").length > 0 && $("#before-you-leave").hasClass("hiden") && $("#before-you-leave").removeClass("hiden"), setTimeout(function() {
                $("#before-you-leave").length > 0 && !$("#before-you-leave").hasClass("active") && !$("#before-you-leave").hasClass("hiden") && $("#before-you-leave").addClass("active")
            }, time), change_out1()) : change_in2()
        })
    }
}, wpbingo.before_you_leave = function() {
    if ($("#before-you-leave").length > 0) {
        var data_time = $("#before-you-leave").data("time"),
            time = data_time * 60 * 1e3;
        $("#before-you-leave [data-close-you-leave]").on("click", function() {
            $("#before-you-leave").removeClass("active"), $("#before-you-leave").addClass("hiden")
        }), window.addEventListener("mouseover", function(event) {
            $("#before-you-leave").length > 0 && !$("#before-you-leave").hasClass("active") && !$("#before-you-leave").hasClass("hiden") && $("#before-you-leave").addClass("hiden")
        }), window.addEventListener("blur", function(event) {
            $("#before-you-leave").length > 0 && $("#before-you-leave").hasClass("hiden") && $("#before-you-leave").removeClass("hiden"), setTimeout(function() {
                $("#before-you-leave").length > 0 && !$("#before-you-leave").hasClass("active") && !$("#before-you-leave").hasClass("hiden") && $("#before-you-leave").addClass("active")
            }, time)
        })
    }
}, wpbingo.product_result_count = function() {
    if ($("#product_result_count").length > 0) {
        var $text = $("#product_result_count").text();
        $("#main-collection-filters .page-collection-header .product_result_count").html($text)
    }
}, wpbingo.vertical_menu = function() {
    var $element2 = $(".categories-vertical-menu"),
        max_number_1600 = $element2.data("max_number_1600") ? $element2.data("max_number_1600") : "15",
        max_number_1400 = $element2.data("max_number_1400") ? $element2.data("max_number_1400") : "8",
        max_number_1100 = $element2.data("max_number_1100") ? $element2.data("max_number_1100") : "6";
    $(window).width() >= 1600 ? wpbingo.appendMoreCategories($element2, max_number_1600) : $(window).width() >= 1400 ? wpbingo.appendMoreCategories($element2, max_number_1400) : $(window).width() >= 1100 && wpbingo.appendMoreCategories($element2, max_number_1100)
}, wpbingo.vertical_menu_2 = function() {
    var $element2 = $(".categories-vertical-menu_2"),
        max_number_1600 = $element2.data("max_number_1600") ? $element2.data("max_number_1600") : "15",
        max_number_1400 = $element2.data("max_number_1400") ? $element2.data("max_number_1400") : "8",
        max_number_1100 = $element2.data("max_number_1100") ? $element2.data("max_number_1100") : "6";
    $(window).width() >= 1600 ? wpbingo.appendMoreCategories($element2, max_number_1600) : $(window).width() >= 1400 ? wpbingo.appendMoreCategories($element2, max_number_1400) : $(window).width() >= 1100 && wpbingo.appendMoreCategories($element2, max_number_1100)
}, wpbingo.appendMoreCategories = function($element2, limit) {
    var textmore = $element2.data("textmore") ? $element2.data("textmore") : "Load More",
        closemore = $element2.data("textclose") ? $element2.data("textclose") : "Close";
    $("ul.vertical-menu >li", $element2).length > limit && $element2.find(".more-wrap").length <= 0 && $("ul.vertical-menu", $element2).append('<div class="more-wrap"><span class="more-view">' + textmore + "</span></div>"), $(".more-wrap", $element2).unbind("click"), $(".more-wrap", $element2).on("click", function() {
        var this_more = $(this);
        $(this).hasClass("open") ? ($("ul.vertical-menu >li", $element2).each(function(i) {
            i > limit - 1 && $(this).slideUp()
        }), $(this).removeClass("open"), $(this_more).html('<span class="more-view">' + textmore + "</span>")) : ($("ul.vertical-menu >li", $element2).each(function(i) {
            i > limit - 1 && $(this).slideDown()
        }), $(this).addClass("open"), $(this_more).html('<span class="more-view">' + closemore + "</span>"))
    }), $("ul.vertical-menu >li", $element2).css("display", "block"), $("ul.vertical-menu >li", $element2).each(function(i) {
        i > limit - 1 && $(this).css("display", "none")
    })
}, wpbingo.accordion_menu = function() {
    var $elements = $(".categories-vertical-menu.accordion");
    $(".select_category__title", $elements).on("click", function() {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(".bwp-vertical-navigation >div", $elements).slideUp()) : ($(this).addClass("active"), $(".bwp-vertical-navigation >div", $elements).slideDown())
    }), $(".select_category__title", ".categories-vertical-menu.show").on("click", function() {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(".bwp-vertical-navigation.sticky-vertical >div", ".categories-vertical-menu.show").slideUp()) : ($(this).addClass("active"), $(".bwp-vertical-navigation.sticky-vertical >div", ".categories-vertical-menu.show").slideDown())
    }), $(".select_category__title_2", ".categories-vertical-menu_2").on("click", function() {
        $(".select_category__title", ".categories-vertical-menu").hasClass("active") && ($(".select_category__title", ".categories-vertical-menu").removeClass("active"), $(".bwp-vertical-navigation >div", $elements).slideUp())
    })
}, wpbingo.accordion_menu_2 = function() {
    var $elements = $(".categories-vertical-menu_2.accordion");
    $(".select_category__title_2", $elements).on("click", function() {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(".bwp-vertical-navigation_2 >div", $elements).slideUp()) : ($(this).addClass("active"), $(".bwp-vertical-navigation_2 >div", $elements).slideDown())
    }), $(".select_category__title_2", ".categories-vertical-menu_2.show").on("click", function() {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(".bwp-vertical-navigation_2.sticky-vertical >div", ".categories-vertical-menu_2.show").slideUp()) : ($(this).addClass("active"), $(".bwp-vertical-navigation_2.sticky-vertical >div", ".categories-vertical-menu_2.show").slideDown())
    }), $(".select_category__title", ".categories-vertical-menu").on("click", function() {
        $(".select_category__title_2", ".categories-vertical-menu_2").hasClass("active") && ($(".select_category__title_2", ".categories-vertical-menu_2").removeClass("active"), $(".bwp-vertical-navigation_2 >div", $elements).slideUp())
    })
}, wpbingo.popup_product_card = function() {
    $(".product-card .btn-select").length && ($(".product-card .btn-select").on("click", function(e) {
        e.preventDefault(), $(".product-card .product-card_popup").hasClass("active") && ($(".product-card .product-card_popup").removeClass("active"), $(".product-card .btn-select").removeClass("hide"));
        var $parent = $(this).closest(".product-card");
        $(".product-card_popup", $parent).hasClass("active") || ($(".product-card_popup", $parent).addClass("active"), $(".btn-select", $parent).addClass("hide"))
    }), $(window).on("click.Bst", function(event) {
        var $box = $(".product-card .product-card_popup"),
            $box2 = $(".product-card .product-card__form");
        if ($box.has(event.target).length == 0 && !$box.is(event.target) && $box2.has(event.target).length == 0 && !$box2.is(event.target)) {
            var $parent = $(".product-card");
            $(".product-card_popup", $parent).hasClass("active") && ($(".product-card_popup", $parent).removeClass("active"), $(".btn-select", $parent).removeClass("hide"))
        }
    }))
}, wpbingo.widget_collapsible = function() {
    $(".bwp-widget-collapsible .card-link").on("click", function(e) {
        e.preventDefault();
        var $parent = $(this).closest(".card");
        $parent.hasClass("active") ? ($parent.removeClass("active"), $(".collapse-body", $parent).slideUp()) : ($(".bwp-widget-collapsible .card").removeClass("active"), $(".bwp-widget-collapsible .collapse-body").slideUp(), $parent.addClass("active"), $(".collapse-body", $parent).slideDown())
    })
}, wpbingo.init = function() {
    if (wpbingo.initializeEvents(), wpbingo.setBreakpoints(), wpbingo.cartInit(), wpbingo.collectionPages(), wpbingo.slideshow(), wpbingo.slickCarousel(), wpbingo.countdown(), wpbingo.countdown_single(), wpbingo.sticky_product(), wpbingo.sticky_header(), wpbingo.lookbook(), wpbingo.lookbook_block(), wpbingo.click_button(), wpbingo.click_atribute_image(), wpbingo.active_form_login(), wpbingo.cookieConsent(), wpbingo.newsletter(), wpbingo.verify_popup(), wpbingo.header_campar(), wpbingo.customNumberInput(), wpbingo.zoom_thumb(), wpbingo.sale_nofication(), wpbingo.discount_single(), wpbingo.pick_up(), wpbingo.time_estimated_delivery(), wpbingo.countActiveSidebar(), wpbingo.toggleSidebar(), wpbingo.sidebarCollection(), wpbingo.ajax_cartpage(), wpbingo.ajax_blogpage(), wpbingo.checkbox_terms_conditions(), wpbingo.check_width_megamenu(), wpbingo.slick_mobile(), wpbingo.accordion_footer(), wpbingo.product_tab(), wpbingo.banner_video(), wpbingo.christmas_snow(), wpbingo.address_delete(), wpbingo.change_head(), wpbingo.before_you_leave(), wpbingo.popup_product_card(), wpbingo.product_result_count(), wpbingo.vertical_menu(), wpbingo.vertical_menu_2(), wpbingo.accordion_menu(), wpbingo.accordion_menu_2(), wpbingo.widget_collapsible(), new wpbingo.update_variant_cartpage(".js-edit_variants"), wpbingo.settings.enableGiftCard && new wpbingo.gift_wrap(".js-giftcard"), wpbingo.settings.enableQuickView && new wpbingo.QuickView(".js-quickview"), $("body").hasClass("template-product")) {
        var $element2 = $(".product-single"),
            _data = $element2.data();
        _data.layout_thumb != "slider" && ($(".product-media__wrapper--video iframe").css("width", $(".product-single__main-media .mfp-image").width()), $(".product-media__wrapper--video iframe").css("height", $(".product-single__main-media .mfp-image").height()), $(".js-product-media-item model-viewer").css("width", $(".js-product-media").width()), $(".js-product-media-item model-viewer").css("height", $(".mfp-image").height()))
    }
};
const confetti = document.getElementById("fire_work"),
    confettiCtx = confetti.getContext("2d");
let container, confettiElements = [],
    clickPosition;
rand = (min, max) => Math.random() * (max - min) + min;
const confettiParams = {
        number: 200,
        size: {
            x: [5, 10],
            y: [10, 10]
        },
        initSpeed: 100,
        gravity: .9,
        drag: .5,
        terminalVelocity: 6,
        flipSpeed: .07
    },
    colors = [{
        front: "#3B870A",
        back: "#235106"
    }, {
        front: "#B96300",
        back: "#6f3b00"
    }, {
        front: "#E23D34",
        back: "#88251f"
    }, {
        front: "#CD3168",
        back: "#7b1d3e"
    }, {
        front: "#664E8B",
        back: "#3d2f53"
    }, {
        front: "#394F78",
        back: "#222f48"
    }, {
        front: "#008A8A",
        back: "#005353"
    }];
setupCanvas(), updateConfetti(), window.addEventListener("resize", () => {
    setupCanvas(), hideConfetti()
});

function Conf() {
    this.randomModifier = rand(-1, 1), this.colorPair = colors[Math.floor(rand(0, colors.length))], this.dimensions = {
        x: rand(confettiParams.size.x[0], confettiParams.size.x[1]),
        y: rand(confettiParams.size.y[0], confettiParams.size.y[1])
    }, this.position = {
        x: clickPosition[0],
        y: clickPosition[1]
    }, this.rotation = rand(0, 2 * Math.PI), this.scale = {
        x: 1,
        y: 1
    }, this.velocity = {
        x: rand(-confettiParams.initSpeed, confettiParams.initSpeed) * .4,
        y: rand(-confettiParams.initSpeed, confettiParams.initSpeed)
    }, this.flipSpeed = rand(.2, 1.5) * confettiParams.flipSpeed, this.position.y <= container.h && (this.velocity.y = -Math.abs(this.velocity.y)), this.terminalVelocity = rand(1, 1.5) * confettiParams.terminalVelocity, this.update = function() {
        this.velocity.x *= .98, this.position.x += this.velocity.x, this.velocity.y += this.randomModifier * confettiParams.drag, this.velocity.y += confettiParams.gravity, this.velocity.y = Math.min(this.velocity.y, this.terminalVelocity), this.position.y += this.velocity.y, this.scale.y = Math.cos((this.position.y + this.randomModifier) * this.flipSpeed), this.color = this.scale.y > 0 ? this.colorPair.front : this.colorPair.back
    }
}

function updateConfetti() {
    confettiCtx.clearRect(0, 0, container.w, container.h), confettiElements.forEach(c => {
        c.update(), confettiCtx.translate(c.position.x, c.position.y), confettiCtx.rotate(c.rotation);
        const width = c.dimensions.x * c.scale.x,
            height = c.dimensions.y * c.scale.y;
        confettiCtx.fillStyle = c.color, confettiCtx.fillRect(-.5 * width, -.5 * height, width, height), confettiCtx.setTransform(1, 0, 0, 1, 0, 0)
    }), confettiElements.forEach((c, idx) => {
        (c.position.y > container.h || c.position.x < -.5 * container.x || c.position.x > 1.5 * container.x) && confettiElements.splice(idx, 1)
    }), window.requestAnimationFrame(updateConfetti)
}

function setupCanvas() {
    container = {
        w: confetti.clientWidth,
        h: confetti.clientHeight
    }, confetti.width = container.w, confetti.height = container.h
}

function addConfetti(e) {
    const canvasBox = confetti.getBoundingClientRect();
    e ? clickPosition = [e.clientX - canvasBox.left, e.clientY - canvasBox.top] : clickPosition = [canvasBox.width * Math.random(), canvasBox.height * Math.random()];
    for (let i = 0; i < confettiParams.number; i++) confettiElements.push(new Conf)
}

function hideConfetti() {
    confettiElements = [], window.cancelAnimationFrame(updateConfetti)
}

function confettiLoop() {
    for (let i = 0; i < 8; i++) addConfetti()
}
const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist",
    LOCAL_STORAGE_DELIMITER = ",",
    BUTTON_ACTIVE_CLASS = "active",
    GRID_LOADED_CLASS = "loaded",
    selectors = {
        button: ".button-wishlist >button",
        grid: "[grid-wishlist]",
        productCard: ".product-content-card"
    };
document.addEventListener("DOMContentLoaded", () => {
    initButtons(), initGrid();
    const wishlist = getWishlist();
    $("[data-count-wishlist] .count").html(wishlist.length)
}), document.addEventListener("shopify-wishlist:updated", event => {
    initGrid()
});
const fetchProductCardHTML = handle => {
        const productTileTemplateUrl = `/products/${handle}?view=wishlist`;
        return fetch(productTileTemplateUrl).then(res => res.text()).then(res => {
            const text = res;
            return new DOMParser().parseFromString(text, "text/html").documentElement.querySelector(selectors.productCard).outerHTML
        }).catch(err => console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err))
    },
    setupGrid = async grid => {
        const wishlist = getWishlist(),
            requests = wishlist.map(fetchProductCardHTML),
            wishlistProductCards = (await Promise.all(requests)).join("");
        grid.innerHTML = wishlistProductCards, grid.classList.add(GRID_LOADED_CLASS), initButtons(), initButtonsCompare(), wpbingo.countdown(), wpbingo.click_atribute_image(), $(".bwp_currency").length > 0 && wishlist.length > 0 && Currency.Currency_customer(!0), ajaxCart.init();
        const event = new CustomEvent("shopify-wishlist:init-product-grid", {
            detail: {
                wishlist
            }
        });
        document.dispatchEvent(event), $(".wishlist__grid").removeClass("loading_wishlist"), wishlist.length > 0 ? $(".wishlist_empty").addClass("hidden") : $(".wishlist_empty").removeClass("hidden")
    }, setupButtons = buttons => {
        buttons.forEach(button => {
            const productHandle = button.dataset.productHandle || !1;
            productHandle && (wishlistContains(productHandle) && button.classList.add(BUTTON_ACTIVE_CLASS), button.addEventListener("click", () => {
                const timeWishlist = setTimeout(loadWishlist, 1e3);
                updateWishlist(productHandle), button.classList.add("load-wishlist");

                function loadWishlist() {
                    if (button.classList.remove("load-wishlist"), button.classList.toggle(BUTTON_ACTIVE_CLASS), $(button).hasClass("active")) {
                        var $parent = button.closest(".button-wishlist");
                        $parent.setAttribute("data-title", window.strings.remove_wishlist)
                    } else {
                        var $parent = button.closest(".button-wishlist");
                        $parent.setAttribute("data-title", window.strings.wishlist)
                    }
                }
            }))
        })
    }, initGrid = () => {
        const grid = document.querySelector(selectors.grid) || !1;
        grid && setupGrid(grid)
    }, initButtons = $element2 => {
        if ($element2) {
            let buttons = document.querySelector($element2).querySelectorAll(selectors.button) || [];
            if (buttons.length) setupButtons(buttons);
            else return
        } else {
            const buttons = document.querySelectorAll(selectors.button) || [];
            if (buttons.length) setupButtons(buttons);
            else return
        }
        const event = new CustomEvent("shopify-wishlist:init-buttons", {
            detail: {
                wishlist: getWishlist()
            }
        });
        document.dispatchEvent(event), $(selectors.button).each(function(event2) {
            if ($(this).hasClass("active")) {
                var $parent = $(this).closest(".button-wishlist");
                $parent.attr("data-title", window.strings.remove_wishlist)
            } else {
                var $parent = $(this).closest(".button-wishlist");
                $parent.attr("data-title", window.strings.wishlist)
            }
        })
    }, getWishlist = () => {
        const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || !1;
        return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : []
    }, setWishlist = array => {
        const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
        array.length ? localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist) : localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
        const event = new CustomEvent("shopify-wishlist:updated", {
            detail: {
                wishlist: array
            }
        });
        return document.dispatchEvent(event), wishlist
    }, updateWishlist = handle => {
        const wishlist = getWishlist(),
            indexInWishlist = wishlist.indexOf(handle);
        return indexInWishlist === -1 ? wishlist.push(handle) : wishlist.splice(indexInWishlist, 1), $("[data-count-wishlist] .count").html(wishlist.length), setWishlist(wishlist)
    }, wishlistContains = handle => getWishlist().includes(handle), resetWishlist = () => setWishlist([]), LOCAL_STORAGE_COMPARE_KEY = "shopify-compare", LOCAL_STORAGE_DELIMITER_COMPARE = ",", BUTTON_ACTIVE_CLASS_COMPARE = "active", GRID_LOADED_CLASS_COMPARE = "loaded", selectorscompare = {
        button: ".button-compare >button",
        remove: ".remove-compare >button",
        grid: "[grid-compare]",
        table: ".compare__table",
        productCard: ".product-content-compare"
    };
document.addEventListener("DOMContentLoaded", () => {
    initButtonsCompare(), initGridCompare();
    const compare = getCompare();
    compare.length === 0 ? $(selectorscompare.table).removeClass(GRID_LOADED_CLASS_COMPARE) : ($(selectorscompare.table).addClass(GRID_LOADED_CLASS_COMPARE), $(".show-compare .count", selectorscompare.table).html(compare.length))
}), document.addEventListener("shopify-compare:updated", event => {
    initGridCompare()
});
const fetchProductCardHTMLCOMPARE = handle => {
        const productTileTemplateUrl = `/products/${handle}?view=compare`;
        return fetch(productTileTemplateUrl).then(res => res.text()).then(res => {
            const text = res;
            return new DOMParser().parseFromString(text, "text/html").documentElement.querySelector(selectorscompare.productCard).outerHTML
        }).catch(err => console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err))
    },
    setupGridCompare = async grid => {
        const compare = getCompare(),
            requests = compare.map(fetchProductCardHTMLCOMPARE);
        requests && ($.each(requests, function(key, result) {
            result.then(function(value) {
                const productRemove = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-remove-compare").innerHTML;
                $(".remove-button", selectorscompare.table).append("<li>" + productRemove + "</li>")
            }, function(error) {
                console.log(error)
            })
        }), $.each(requests, function(key, result) {
            result.then(function(value) {
                const productName = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-compare-title").innerHTML;
                $(".compare-name", selectorscompare.table).append("<li>" + productName + "</li>")
            }, function(error) {
                console.log(error)
            })
        }), $.each(requests, function(key, result) {
            result.then(function(value) {
                const productImage = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-compare-image").innerHTML;
                $(".compare-image", selectorscompare.table).append("<li>" + productImage + "</li>")
            }, function(error) {
                console.log(error)
            })
        }), $.each(requests, function(key, result) {
            result.then(function(value) {
                const productVariants = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-compare-card__content").innerHTML;
                $(".compare-variants", selectorscompare.table).append("<li>" + productVariants + "</li>")
            }, function(error) {
                console.log(error)
            })
        }), $.each(requests, function(key, result) {
            result.then(function(value) {
                const productAvailability = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-compare-inventory").innerHTML;
                $(".compare-availability", selectorscompare.table).append("<li>" + productAvailability + "</li>")
            }, function(error) {
                console.log(error)
            })
        }), $.each(requests, function(key, result) {
            result.then(function(value) {
                const productPrice = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-compare-price").innerHTML;
                $(".compare-price", selectorscompare.table).append("<li>" + productPrice + "</li>")
            }, function(error) {
                console.log(error)
            })
        }), $.each(requests, function(key, result) {
            result.then(function(value) {
                const productAtc = new DOMParser().parseFromString(value, "text/html").querySelector(".clone-compare-atc").innerHTML;
                $(".compare-atc", selectorscompare.table).append("<li>" + productAtc + "</li>")
            }, function(error) {
                console.log(error)
            })
        }));
        const compareProductCards = (await Promise.all(requests)).join("");
        wpbingo.click_atribute_image(), compare.length > 0 && $(".bwp_currency").length > 0 && $(".bwp_currency").length > 0 && Currency.Currency_customer(!0), removeCompare();
        const event = new CustomEvent("shopify-compare:init-product-grid", {
            detail: {
                compare
            }
        });
        document.dispatchEvent(event)
    }, setupButtonsCompare = buttons => {
        buttons.forEach(button => {
            const productHandle = button.dataset.productHandle || !1;
            productHandle && (compareContains(productHandle) && button.classList.add(BUTTON_ACTIVE_CLASS_COMPARE), button.addEventListener("click", () => {
                $(button).hasClass("active") || ($(".content-compare", selectorscompare.table).addClass("active"), $(".content", selectorscompare.table).addClass("load-compare"));
                const timeCompare = setTimeout(loadCompare, 1e3);
                updateCompare(productHandle), button.classList.add("load-compare");

                function loadCompare() {
                    if (button.classList.remove("load-compare"), $(".content", selectorscompare.table).removeClass("load-compare"), button.classList.toggle(BUTTON_ACTIVE_CLASS_COMPARE), $(button).hasClass("active")) {
                        var $parent = button.closest(".button-compare");
                        $parent.setAttribute("data-title", window.strings.remove_compare)
                    } else {
                        var $parent = button.closest(".button-compare");
                        $parent.setAttribute("data-title", window.strings.compare)
                    }
                }
            }))
        })
    }, removeButtonsCompare = buttons => {
        buttons.forEach(remove => {
            const productHandle = remove.dataset.productHandle || !1;
            productHandle && (compareContains(productHandle) && remove.classList.add(BUTTON_ACTIVE_CLASS_COMPARE), remove.addEventListener("click", () => {
                const timeCompare = setTimeout(loadCompare, 1e3);
                updateCompare(productHandle), $(".content", selectorscompare.table).addClass("load-compare");

                function loadCompare() {
                    $(".content", selectorscompare.table).removeClass("load-compare");
                    var handle = remove.getAttribute("data-product-handle");
                    $(".button-compare >button[data-product-handle=" + handle + "]").removeClass(BUTTON_ACTIVE_CLASS_COMPARE), $(selectorscompare.button).each(function(event) {
                        if ($(this).hasClass("active")) {
                            var $parent = $(this).closest(".button-compare");
                            $parent.attr("data-title", window.strings.remove_compare)
                        } else {
                            var $parent = $(this).closest(".button-compare");
                            $parent.attr("data-title", window.strings.compare)
                        }
                    })
                }
            }))
        })
    }, initGridCompare = () => {
        const grid = document.querySelector(selectorscompare.grid) || !1;
        grid && ($(".remove-button", selectorscompare.table).empty(), $(".compare-name", selectorscompare.table).empty(), $(".compare-image", selectorscompare.table).empty(), $(".compare-variants", selectorscompare.table).empty(), $(".compare-availability", selectorscompare.table).empty(), $(".compare-price", selectorscompare.table).empty(), $(".compare-atc", selectorscompare.table).empty(), $(".remove-button", selectorscompare.table).append('<li class="label"></li>'), $(".compare-name", selectorscompare.table).append('<li class="label">' + $(".compare-name").data("label") + "</li>"), $(".compare-image", selectorscompare.table).append('<li class="label"></li>'), $(".compare-variants", selectorscompare.table).append('<li class="label">' + $(".compare-variants").data("label") + "</li>"), $(".compare-availability", selectorscompare.table).append('<li class="label">' + $(".compare-availability").data("label") + "</li>"), $(".compare-price", selectorscompare.table).append('<li class="label">' + $(".compare-price").data("label") + "</li>"), $(".compare-atc", selectorscompare.table).append('<li class="label"></li>'), setupGridCompare(grid)), $(".compare__table .hide-compare").on("click", function() {
            $(".compare__table .content-compare").hasClass("active") && $(".compare__table .content-compare").removeClass("active")
        }), $(".compare__table .show-compare").on("click", function() {
            $(".compare__table .content-compare").hasClass("active") || $(".compare__table .content-compare").addClass("active")
        })
    }, initButtonsCompare = $element2 => {
        if ($element2) {
            let buttons = document.querySelector($element2).querySelectorAll(selectorscompare.button) || [];
            if (buttons.length) setupButtonsCompare(buttons);
            else return
        } else {
            const buttons = document.querySelectorAll(selectorscompare.button) || [];
            if (buttons.length) setupButtonsCompare(buttons);
            else return
        }
        const event = new CustomEvent("shopify-compare:init-buttons", {
            detail: {
                compare: getCompare()
            }
        });
        document.dispatchEvent(event), $(selectorscompare.button).each(function(event2) {
            if ($(this).hasClass("active")) {
                var $parent = $(this).closest(".button-compare");
                $parent.attr("data-title", window.strings.remove_compare)
            } else {
                var $parent = $(this).closest(".button-compare");
                $parent.attr("data-title", window.strings.compare)
            }
        })
    }, removeCompare = () => {
        const buttons = document.querySelectorAll(selectorscompare.remove) || [];
        if (buttons.length) removeButtonsCompare(buttons);
        else return;
        const event = new CustomEvent("shopify-compare:init-buttons", {
            detail: {
                compare: getCompare()
            }
        });
        document.dispatchEvent(event)
    }, getCompare = () => {
        const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || !1;
        return compare ? compare.split(LOCAL_STORAGE_DELIMITER_COMPARE) : []
    }, setCompare = array => {
        const compare = array.join(LOCAL_STORAGE_DELIMITER_COMPARE);
        array.length ? localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare) : localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
        const event = new CustomEvent("shopify-compare:updated", {
            detail: {
                compare: array
            }
        });
        return document.dispatchEvent(event), compare
    }, updateCompare = handle => {
        const compare = getCompare(),
            indexInCompare = compare.indexOf(handle),
            table = document.querySelector(selectorscompare.table);
        return indexInCompare === -1 ? compare.push(handle) : compare.splice(indexInCompare, 1), compare.length === 0 ? table.classList.remove(GRID_LOADED_CLASS_COMPARE) : (table.classList.add(GRID_LOADED_CLASS_COMPARE), $(".show-compare .count", selectorscompare.table).html(compare.length)), setCompare(compare)
    }, compareContains = handle => getCompare().includes(handle), resetCompare = () => setCompare([]);
$(document).ready(function() {
    wpbingo.init();
    var sections = new wpbingo.Sections;
    if (sections.register("product-template", wpbingo.Product), sections.register("header-section", wpbingo.HeaderSection), sections.register("header-topbar-section", wpbingo.HeaderSection), sections.register("product-recommendations", wpbingo.ProductRecommendations), sections.register("login-register", wpbingo.LoginRegister), sections.register("search", wpbingo.Search), $("body").hasClass("template-product")) {
        sections.register("product-template", Shopify.Products.showRecentlyViewed()), sections.register("product-template", Shopify.Products.recordRecentlyViewed());
        var $element2 = $(".product-single"),
            _data = $element2.data();
        _data.layout_thumb == "slider" && ($(".product-media__wrapper--video iframe").css("width", $(".product-single__main-media #slick-slide11 .mfp-image").width()), $(".product-media__wrapper--video iframe").css("height", $(".product-single__main-media #slick-slide11 .mfp-image").height()), $(".js-product-media-item model-viewer").css("width", $(".product-single__main-media #slick-slide11 .mfp-image").width()), $(".js-product-media-item model-viewer").css("height", $(".product-single__main-media #slick-slide11 .mfp-image").height()))
    }
    $("#pre-loading").addClass("loading-done"), setTimeout(function() {
        $("#pre-loading").removeClass("loading-done"), $("#pre-loading").removeClass("loading-page")
    }, 1300), window.Shopify.designMode && ($("body").addClass("designMode_active"), document.addEventListener("shopify:section:load", function(event) {
        var sectionId2 = ".wpbingo-section--" + event.detail.sectionId;
        $(".js-carousel", sectionId2).length > 0 && wpbingo.elementslickCarousel($(".js-carousel", sectionId2)), $("[data-countdown]", sectionId2).length > 0 && wpbingo.countdown(), $(".custom-product-card", sectionId2).length > 0 ? $(".custom-product-card", sectionId2).addClass("active") : $(".custom-product-card").removeClass("active")
    }), document.addEventListener("shopify:section:select", function(event) {
        var sectionId2 = ".wpbingo-section--" + event.detail.sectionId;
        $(".custom-product-card", sectionId2).length > 0 ? $(".custom-product-card", sectionId2).addClass("active") : $(".custom-product-card").removeClass("active")
    }), document.addEventListener("shopify:block:select", function(event) {
        var id = $("#" + event.detail.blockId);
        id.length > 0 ? ($(".js-carousel", sectionId).length > 0 && wpbingo.elementslickCarousel($(".js-carousel", sectionId)), $(".block-card-mobi").removeClass("active"), $(".product-card__buttons").addClass("hidden"), id.addClass("active")) : ($(".block-card-mobi").removeClass("active"), $(".product-card__buttons").removeClass("hidden"))
    }))
});
//# sourceMappingURL=/s/files/1/0919/5349/6355/t/3/assets/wpbingo.js.map?v=1737013414